export const en = {
  common: {
    appName: "noaretraite",
    tagline: "Personal Pension Review by Aon.",
    loading: "Loading…",
    error: "Something went wrong",
    retry: "Try again",
    back: "Back",
    next: "Next",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    confirm: "Confirm",
    learnMore: "Learn more",
    getStarted: "Get started",
    contactUs: "Contact us",
    search: "Search",
    close: "Close",
    open: "Open",
    add: "Add",
    create: "Create",
    update: "Update",
    remove: "Remove",
    yes: "Yes",
    no: "No",
    all: "All",
    none: "None",
    export: "Export",
    export_excel: "Export (Excel)",
    export_csv: "Export CSV",
    no_name: "(no name)",
    import: "Import",
    download: "Download",
    upload: "Upload",
    filter: "Filter",
    sort: "Sort",
    reset: "Reset",
    apply: "Apply",
    select: "Select",
    selected: "selected",
    actions: "Actions",
    details: "Details",
    status: "Status",
    date: "Date",
    name: "Name",
    email: "Email",
    phone: "Phone",
    description: "Description",
    notes: "Notes",
    total: "Total",
    of: "of",
    noResults: "No results",
    showMore: "Show more",
    showLess: "Show less",
    showHelp: "Show help",
    required: "Required",
    optional: "Optional",
    enabled: "Enabled",
    disabled: "Disabled",
    active: "Active",
    inactive: "Inactive",
    pending: "Pending",
    success: "Success",
    warning: "Warning",
    info: "Information",
    copy: "Copy",
    copied: "Copied!",
    preview: "Preview",
    send: "Send",
    ctrl_cmd: "Ctrl/Cmd",
    sent: "Sent",
    archive: "Archive",
    restore: "Restore",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    days: "days",
    hours: "hours",
    minutes: "minutes",
    and: "and",
    or: "or",
    notAvailable: "not provided",
    size_kb: "{{size}} KB",
    size_mb: "{{size}} MB",
  },
  ui: {
    pagination: {
      range: "of {{total}} {{unit}}",
      items: "items",
      page_of: "Page {{page}} / {{pages}}",
      prev: "Previous",
      next: "Next",
    },
    list: {
      truncated: "List limited to the first 20,000 rows, refine the filters.",
    },
    combobox: {
      placeholder: "Select…",
      search: "Search…",
      empty: "No results",
      refine: "Refine your search to see more results…",
    },
    collapsible: {
      collapse: "Collapse section",
      expand: "Expand section",
    },
    imageUploader: {
      too_big: "The file exceeds {{max}} MB.",
      unsupported: "Unsupported type ({{type}}).",
      unknown_type: "unknown",
      upload_failed: "Upload failed",
      saved: "Image saved",
      replace: "Replace",
      remove: "Remove",
      uploading: "Uploading…",
      drop_here: "Drop the file here",
      drop_or_click: "Drop or click to upload",
      formats: "PNG, JPG, WEBP or SVG · max {{max}} MB",
    },
    editor: {
      aria_label: "Text editor",
      bold: "Bold",
      italic: "Italic",
      heading: "Heading",
      subheading: "Subheading",
      paragraph: "Normal text",
      bullet_list: "Bullet list",
      ordered_list: "Numbered list",
      quote: "Quote",
      insert_link: "Insert a link",
      confirm_link: "Confirm link",
      placeholder: "Write your text here, then format it with the toolbar above.",
    },
    emailPreview: {
      title: "Email preview",
      description: "Review the message content before sending.",
      to: "To",
      subject: "Subject",
      loading: "Loading preview…",
      iframe_title: "Email preview",
    },
    password: {
      strength: "Strength:",
      hint: "{{min}} characters minimum, with an uppercase letter, a lowercase letter and a digit.",
      score_0: "Very weak",
      score_1: "Weak",
      score_2: "Medium",
      score_3: "Good",
      score_4: "Excellent",
    },
    assistant: {
      title: "Noa",
      subtitle: "Your retirement assistant",
      open: "Open the assistant",
      placeholder: "Ask your question…",
      disclaimer: "Noa can make mistakes: check important information with your advisor.",
      thinking: "Noa is thinking…",
      empty_title: "How can I help you?",
      empty_subtitle: "Ask a question about your data or request an action.",
      new_conversation: "New conversation",
      fullscreen: "Full screen",
      exit_fullscreen: "Exit full screen",
      history: "History",
      no_history: "No conversation yet.",
      untitled: "Conversation",
      error_generic: "Something went wrong. Please try again.",
      action_title: "Action to confirm",
      action_running: "Running…",
      action_done: "Action completed",
      action_failed: "The action failed",
      action_rejected: "Action cancelled",
      open_dossier_bri: "Open the file to generate the BRI",
      tools: {
        run_sql_select: "Querying data",
        get_schema: "Reading structure",
        call_rpc: "Business function",
        get_dossier_overview: "Reading the file",
        get_simulation_results: "Reading results",
        get_career: "Reading career",
        search_salaries: "Searching employees",
        export_data: "Preparing export",
        compute: "Computing",
        run_pension_calculation: "Running pension calculation",
        create_simulation: "Creating simulation",
        update_dossier_souhaits: "Updating retirement wishes",
        update_salarie_contact: "Updating contact details",
        replace_retraite_supplementaire: "Updating retirement savings",
        generate_bri: "Preparing the BRI",
        set_dossier_status: "Changing status",
        assign_dossier: "Assigning the file",
        log_relance: "Logging the follow-up",
        send_message: "Sending message",
        create_formation: "Creating training session",
        enroll_formation: "Enrolling in training",
        set_formation_presence: "Recording training attendance",
        code_interpreter: "Generating file (Python)",
      },
      sugg: {
        explain_results: "Explain my simulation results",
        fill_projet: "I want to fill in my departure wishes",
        best_departure: "What is my best departure date?",
        rachat_worth: "Is buying back quarters worth it for me?",
        compare_runs: "Compare my different calculations",
        missing_docs: "Which documents am I missing?",
        explain_ris: "Explain my career statement",
        draft_message: "Help me write a message to my advisor",
        where_dossier: "What is the status of my file?",
        explain_notion: "Explain pension discount and premium",
        export_formation_xlsx: "Export training attendees to Excel",
        participation_summary: "Summarize my employees' participation",
        top_risques: "Which employees have career anomalies?",
        salaries_inactifs: "Which employees never signed in?",
        export_salaries: "Export the employee list to Excel",
        relance_targets: "Who should be reminded first?",
        sessions_remplissage: "What is the session fill rate?",
        resume_salarie: "Summarize this employee's situation",
        resume_dossier: "Summarize this file",
        generate_bri: "Generate this file's BRI",
        next_action: "What is the next action on this file?",
        dispatch_stats: "How many files are left to dispatch?",
        oldest_pending: "What are the oldest pending files?",
        my_workload: "Summarize my workload",
        ai_costs_month: "How much did AI cost this month?",
        ai_top_users: "Who are the biggest AI users?",
        global_stats: "Give me the platform's global statistics",
      },
    },
  },
  nav: {
    home: "Home",
    employees: "Employees",
    employers: "HR",
    aonTeam: "Aon team",
    security: "Security",
    login: "Sign in",
    signup: "Create account",
    logout: "Sign out",
    dashboard: "My space",
  },
  landing: {
    hero: {
      eyebrow: "Aon Wealth platform",
      title: "Your Personal Pension Review, with confidence.",
      subtitle:
        "noaretraite is the digital platform built by Aon to produce and deliver personal pension reviews — for employees, HR leaders and Aon consultants.",
      ctaPrimary: "Go to my account",
      ctaSecondary: "Discover the platform",
    },
    trust: {
      label: "Designed and operated by",
      items: [
        "Aon — global leader in risk and human capital",
        "EU hosting, GDPR compliant",
        "Powered by a reference pension calculation engine",
      ],
    },
    personas: {
      title: "Three experiences, one platform.",
      subtitle:
        "Each persona has a dedicated workspace, with its own data, permissions and level of detail.",
      salarie: {
        tag: "Employee workspace",
        title: "Your pension review in a few clicks",
        bullets: [
          "Centralise your documents (RIS, Agirc-Arrco, payslips)",
          "Run your simulations independently",
          "Chat with your dedicated Aon consultant",
          "Browse your Pension Review and update history",
        ],
        cta: "Explore the employee workspace",
      },
      drh: {
        tag: "HR workspace",
        title: "Pilot retirement flows with precision",
        bullets: [
          "Real-time tracking of every operation",
          "Aggregated views by BU, region, salary band",
          "Distribution of possible retirement dates",
          "CSV / Excel exports for your workforce planning",
        ],
        cta: "Explore the HR workspace",
      },
      aon: {
        tag: "Aon teams",
        title: "Industrial-grade pension review production",
        bullets: [
          "Manage clients, operations and populations",
          "Assign cases to your production team",
          "Native integration with the pension calculation engine",
          "Generate co-branded Pension Review PDFs",
        ],
        cta: "Explore the back office",
      },
    },
    features: {
      title: "Built for industrial-grade production.",
      items: [
        {
          title: "Calculation engine integrated",
          body: "All schemes supported by the calculation engine (CNIEG, Civil Service, specific schemes). 15+ automatic alerts.",
        },
        {
          title: "Per-company branding",
          body: "Logos, colours, typography, wording, PDF deliverables — every client company gets its own co-branded identity.",
        },
        {
          title: "GDPR by design",
          body: "EU hosting, database encryption, Row Level Security, audit logs, right to be forgotten and portability.",
        },
        {
          title: "Multi-language",
          body: "French, English and Spanish available. Labels and emails are configurable per operation.",
        },
        {
          title: "Built-in messaging",
          body: "Direct conversations between employees, the Aon production team, project leads and HR — with file attachments and traceability.",
        },
        {
          title: "Appointments & reminders",
          body: "Teams / phone restitution, consultant calendars, programmable automated reminders.",
        },
      ],
    },
    security: {
      title: "Security and compliance at the core.",
      subtitle:
        "Built to handle sensitive personal data, noaretraite meets the most demanding standards.",
      items: [
        "Strong authentication (MFA) and enterprise SSO available",
        "AES-256 at rest, TLS 1.2/1.3 in transit",
        "EU hosting — SOC 2, ISO 27001 / 27018, GDPR",
        "Postgres Row Level Security on every table",
        "Full audit trail and right to erasure",
        "No credit card storage (payment via Stripe)",
      ],
    },
    cta: {
      title: "Ready to industrialise your pension reviews?",
      subtitle: "Let's talk about your operation. Our team replies within one business day.",
      ctaPrimary: "Request a demo",
      ctaSecondary: "Sign in to my account",
    },
  },
  auth: {
    login: {
      title: "Sign in to your workspace",
      subtitle: "Enter your credentials to access your Pension Review.",
      email: "Email address",
      password: "Password",
      submit: "Sign in",
      forgot: "Forgot password?",
      noAccount: "No account yet?",
      signup: "Create an account",
      orContinueWith: "or continue with",
      remember: "Remember me",
      noAccountContact: "No account? Contact your Aon administrator.",
      timeoutTitle: "You have been signed out",
      timeoutDesc:
        "For your security, your session was closed after a period of inactivity. Sign in again to continue.",
      expiredTitle: "Link expired or already used",
      expiredDesc: "Enter your email below to receive a new sign-in link.",
      close: "Close",
      modePassword: "Password",
      modeOtp: "Email link",
      otpInfoTitle: "Sign in with an email link.",
      otpInfoBody:
        "Enter your work or personal email. We will send you a secure sign-in link. No password required.",
      otpSentTitle: "Email sent",
      otpSentBody1: "A sign-in link has been sent to",
      otpSentBody2: ". Remember to check your spam folder. The link is valid for 1 hour.",
      otpSubmit: "Receive a sign-in link",
      otpSubmitSent: "Link sent",
    },
    mfa: {
      enrollTitle: "Secure your account",
      enrollSubtitle:
        "Two-factor authentication adds a second verification at each sign-in. It is managed by a free app on your phone.",
      preparing: "Preparing enrollment…",
      enrollAppsHint:
        "Install a free authenticator app, for example Microsoft Authenticator or Google Authenticator.",
      step1: "Scan this code with your app",
      step2: "Or enter this key manually",
      step3: "Enter the code shown by the app",
      qrAlt: "QR code to scan with your authenticator app",
      manualKey: "Setup key",
      codeLabel: "6-digit code",
      autoVerifyHint: "The code is verified automatically once all six digits have been entered.",
      verify: "Verify",
      errorInvalidCode:
        "The code does not match this setup. Use the entry linked to this QR code and its latest code. If the problem persists, check that your phone sets its time automatically.",
      errorExpiredCode:
        "The verification request expired. Try again with the code currently shown in your app.",
      errorGeneric:
        "The authentication service could not complete the request. Please try again shortly.",
      errorFactorMissing:
        "This authentication setup has expired or was removed. Start enrollment again with a new QR code.",
      errorRejected:
        "Verification was rejected by the security policy. Sign in again or contact your administrator.",
      errorNetworkChanged:
        "Your network connection changed during verification. Keep the same connection and try again.",
      errorEnrollmentConflict: "Enrollment is already in progress. Reload the page to resume it.",
      errorSessionExpired: "Your session expired. Sign in again before continuing verification.",
      errorRateLimit: "Too many attempts in a short time. Wait a minute before trying again.",
      errorNetwork:
        "The authentication service cannot be reached. Check your connection and try again.",
      errorRecoveryCodes:
        "Two-factor authentication is enabled, but recovery codes could not be retrieved. Try again to get them.",
      preparingRecovery: "Two-factor authentication enabled. Preparing recovery codes…",
      retryRecovery: "Get my recovery codes",
      resumeWithoutQr:
        "Enrollment is already in progress. Enter the code from the NOA Retraite entry you added to your app. If you have not scanned the QR code yet, choose ‘Restart enrollment’.",
      restart: "Restart enrollment",
      restartWarning:
        "A new QR code will be created and the old one will stop working. Remove only the NOA Retraite entry added for this enrollment from your app, then scan the new QR code.",
      retry: "Try again",
      recoveryIntro:
        "These codes let you sign back in if you lose your phone. Each code works only once.",
      recoveryWarning:
        "They will not be shown again. Keep them in a safe place (for example a password manager).",
      copied: "Copied to clipboard",
      copyCodes: "Copy codes",
      downloadCodes: "Download (.txt)",
      recoveryConfirm: "I have saved my recovery codes",
      continue: "Continue",
      logout: "Sign out",
      challengeTitle: "Two-step verification",
      challengeSubtitle: "Enter the 6-digit code shown by your authenticator app.",
      challengeHint: "6-digit code",
      useRecovery: "Use a recovery code",
      recoveryHint: "Lost your phone? Enter one of your recovery codes.",
      recoveryLabel: "Recovery code",
      recoverySubmit: "Validate code",
      backToTotp: "Back to the 6-digit code",
      recoveryFileHeader: "NOA Retraite: recovery codes",
    },
    layout: {
      featMfa: "Strong authentication (MFA) and SSO",
      featEncryption: "AES-256 encryption and TLS 1.2/1.3",
      featHosting: "European hosting, GDPR compliant",
    },
    signup: {
      title: "Create your account",
      subtitle:
        "Sign-up is by invitation from your employer. Enter the email address that received your invitation.",
      email: "Email address",
      password: "Choose a password",
      passwordHelp: "12 characters minimum, mixing uppercase / lowercase / digits / symbols.",
      firstName: "First name",
      lastName: "Last name",
      submit: "Create my account",
      hasAccount: "Already have an account?",
      login: "Sign in",
      acceptTos: "By creating your account, you accept our terms of use and privacy policy.",
    },
    reset: {
      title: "Reset your password",
      subtitle: "Enter your email — we will send you a secure link to reset your password.",
      email: "Email address",
      submit: "Send the link",
      backToLogin: "Back to sign in",
      sent: "If an account exists for this address, an email has just been sent.",
    },
    callback: {
      title: "Set your password",
      subtitle: "Choose a password to access your workspace.",
      password: "Password",
      confirm: "Confirm password",
      submit: "Confirm",
      success: "Password set successfully.",
    },
    errors: {
      invalidEmail: "Invalid email address.",
      passwordTooShort: "Password must be at least 12 characters long.",
      passwordsDoNotMatch: "Passwords do not match.",
      generic: "Unable to sign in. Check your credentials or try again later.",
      emailRequired: "Email is required.",
      invalidCredentials: "Invalid email or password.",
      accountLocked: "Account locked. Contact your administrator.",
      sessionExpired: "Your session has expired. Please sign in again.",
    },
  },
  legal: {
    privacy: {
      title: "Aon confidentiality commitment",
      updated: "This text has been updated: please read it again and accept it.",
      accept: "I have read and I accept Aon's confidentiality commitment",
      enter: "Access my space",
      logout: "Sign out",
      error: "Your acceptance could not be saved. Please try again or contact your advisor.",
      impersonation_banner: "This employee has not yet accepted the confidentiality commitment.",
    },
    ia: {
      learn_more: "Learn more",
      mention_default:
        "Content generated by artificial intelligence (OpenAI). Your first name, last name and e-mail are not sent, and your data is not used to train the models.",
      conditions_default: `NOA uses an artificial intelligence service (OpenAI, through its programming interface) for two purposes: preparing a summary of your file (Noa analysis) and answering your general questions about retirement (assistant).

- Data sent: only the information needed for the analysis (career, calculation results, family situation, wishes). Your first name, last name and e-mail address are not sent.
- No training: data sent by the platform is not used to train the provider's models.
- Retention: the provider may keep requests for up to 30 days, for security and abuse prevention, then deletes them.
- Location: the provider may process data outside the European Union, under the safeguards provided by the GDPR.
- No automated decision: the analysis is an aid. It is reviewed by an Aon consultant before being shared with you, except in fully digital journeys, where it is presented as indicative guidance.`,
    },
  },
  footer: {
    legalDocuments: "Legal documents (new tab)",
    builtBy: "Platform built by Aon France",
    legal: "© 2026 Aon France. 31-35 rue de la Fédération, 75015 Paris.",
    privacy: "Privacy",
    terms: "Terms",
    contact: "Contact",
    dataProtection: "Data protection",
    legalNotice: "Legal notice",
    complaint: "Client complaint",
  },
  salariesView: {
    kicker_admin: "Administration",
    kicker_drh: "HR area",
    kicker_aon: "Aon production",
    subtitle_admin: "BRI operation beneficiaries. Manual creation or CSV import.",
    subtitle_drh: "Your employees within your scope. Manual creation or CSV import.",
    subtitle_aon: "The files within your scope. Manual creation or CSV import.",
    item_salarie: "employee",
    items_salarie: "employees",
    item_dossier: "file",
    items_dossier: "files",
    import_file: "Import a file",
    new_item: "New {{item}}",
    search: "Search",
    search_placeholder: "Last name, first name, ID, email…",
    filter_society: "Company",
    filter_operation: "Operation",
    filter_type: "Type",
    filter_urgence: "Urgency",
    urgents_only: "Urgent",
    badge_urgent: "Urgent",
    all_f: "All",
    all_m: "All",
    vip: "VIP",
    standard: "Standard",
    empty_filtered_title: "No results with these filters",
    empty_title: "No {{item}} yet",
    empty_filtered_desc: "Adjust your filters or create a new record.",
    confidential_masked_title: "Employee data hidden: confidential company",
    confidential_masked_desc:
      "Personal data of this company's employees is only accessible to super-admins and authorized internal Aon users.",
    empty_desc: "Import a CSV file or create records manually.",
    count: "{{count}} {{item}}",
    badge_exited: "Left",
    badge_outgoing: "Leaving on {{date}}",
    filter_depart: "Departure",
    outgoing_only: "Leaving",
    exited_only: "Left",
    badge_account: "Account active",
    open_dossier: "The file",
    open_dossier_title: "Open the file (retirement journey)",
    view_sheet: "View record",
    edit: "Edit",
    delete: "Delete",
    send_invitation: "Send an invitation",
    resend_link: "Resend a sign-in link",
    none_dossier: "No file",
    change_status: "Change status",
    change_status_aria: "Change the file status",
    delete_title: "Delete {{name}}?",
    delete_desc: "All files linked to this {{item}} will also be deleted.",
    delete_irreversible: "This action is irreversible.",
    delete_confirm: "Delete permanently",
    status_title: "Change the file status",
    status_reason_label: "Reason (optional, logged in history)",
    status_reason_placeholder: "E.g. documents provided, BRI delivered…",
    status_confirm: "Confirm the change",
    status_incomplete_warn: "This file is not complete yet",
    status_incomplete_body:
      "(current status: {{status}}). You can still change its status, but some items may be missing from the review.",
    status_updated: "Status updated: {{status}}.",
    status_error: "Error while changing status",
    invitation_sent: "Invitation sent to {{recipient}}.",
    invitation_error: "Error while sending",
    preview_error: "Error while previewing",
    send_invitation_confirm: "Send the invitation",
    invitation_preview_title: "Invitation: {{name}}",
    email_preview: "Email preview",
    preview_desc: "Check the content before sending the magic link to the {{item}}.",
    category_cadre: "Manager",
    category_oetam: "OETAM",
    category_dirigeant: "Executive",
    close: "Close",
  },
  relancesBoard: {
    kicker_aon: "Aon tracking",
    kicker_rh: "HR tracking",
    title: "Follow-ups",
    description: "Track employees whose file is awaiting an action on their part.",
    kpi_to_relance: "To follow up",
    kpi_to_relance_hint: "Files awaiting the employee",
    kpi_due: "To contact again",
    kpi_due_hint: "Scheduled follow-up overdue",
    kpi_never: "Never followed up",
    kpi_never_hint: "No follow-up recorded",
    kpi_month: "Follow-ups this month",
    kpi_month_hint: "Email + phone",
    kpi_total: "Total follow-ups",
    kpi_total_hint: "Within the displayed scope",
    search_placeholder: "Search an employee, ID, company…",
    only_mine: "My files only",
    filter_operation_all: "All operations",
    filter_operation_aria: "Filter by operation",
    filter_status_all: "All statuses",
    filter_status_aria: "Filter by file status",
    queue_title: "Follow-up queue ({{count}})",
    without_dossier: "No file yet",
    operation_employees: "Employees",
    operation_employees_hint: "Employees in the operation matching the filters",
    operation_queue_title: "Employees in the operation ({{count}})",
    operation_scope_hint:
      "This list includes employees without a file. Select all selects everyone with an email matching the filters, across all pages. Contact refusals and departures remain excluded.",
    operation_empty_title: "No employees match these filters",
    operation_empty_desc:
      "Check the operation and filters. Employees who declined contact or have a departure date are excluded.",
    load_error: "Unable to load employees to contact. Reload the page to try again.",
    queue_empty_title: "No pending follow-up",
    queue_empty_desc: "All files within your scope are up to date or advanced.",
    recent_title: "Recent activity",
    recent_empty_title: "No follow-up yet",
    recent_empty_desc: "Recorded follow-ups will appear here.",
    never_relanced: "Never followed up",
    last_relance: "Last follow-up {{when}}",
    relance_count_one: "{{count}} follow-up",
    relance_count_other: "{{count}} follow-ups",
    badge_due: "To contact again",
    badge_planned: "Planned",
    email_title: "Follow up {{email}} by email",
    call_title: "Call {{phone}}",
    relance: "Follow up",
    never: "Never followed up",
    today: "Today",
    yesterday: "Yesterday",
    days_ago: "{{count}} d ago",
    weeks_ago: "{{count}} w ago",
    months_ago: "{{count}} mo ago",
    channel_email: "Email",
    channel_phone: "Phone",
    outcome_repondu: "Replied",
    outcome_pas_de_reponse: "No reply",
    outcome_message_laisse: "Message left",
    outcome_a_rappeler: "To call back",
    outcome_refus: "Refusal",
    outcome_injoignable: "Unreachable",
    drawer_title: "Follow up {{name}}",
    drawer_title_default: "Follow up",
    open_dossier: "Open the file",
    send_email: "Send a follow-up email",
    no_email: "No known email address",
    record_title: "Record a follow-up",
    notes_placeholder: "Follow-up note (answer received, next action…)",
    outcome_label_call: "Call outcome",
    outcome_label_relance: "Follow-up outcome",
    outcome_none: "Not specified",
    next_relance_label: "Next follow-up planned",
    record_submit: "Record the follow-up",
    save_error: "Error while saving",
    history_title: "History ({{count}})",
    history_empty: "No follow-up recorded.",
    auto: "Auto",
    by_author: "by {{author}}",
    next_relance_history: "Next follow-up planned {{date}}",
    delete_relance_aria: "Delete the follow-up",
    delete: "Delete",
    delete_title: "Delete this follow-up?",
    delete_desc: "The entry will be permanently removed from the follow-up log.",
    not_provided: "Not specified",
    select_all: "Select all",
    deselect_all: "Deselect all",
    select_aria: "Select {{name}}",
    selected_count_one: "{{count}} employee selected",
    selected_count_other: "{{count}} employees selected",
    clear_selection: "Cancel",
    export_excel: "Export to Excel",
    export_hint: "Downloads the displayed queue and the follow-up log as an Excel file",
    export_error: "Unable to generate the export",
    export_sheet_rows: "Follow-ups",
    export_sheet_journal: "Log",
    export_col_salarie: "Employee",
    export_col_matricule: "Employee ID",
    export_col_societe: "Company",
    export_col_operation: "Operation",
    export_col_statut: "File status",
    export_col_email: "Email",
    export_col_telephone: "Phone",
    export_col_relance_count: "Follow-ups",
    export_col_last_relance_at: "Last follow-up",
    export_col_last_channel: "Last channel",
    export_col_last_outcome: "Last outcome",
    export_col_next_relance_at: "Next follow-up",
    export_col_is_due: "Due",
    export_col_relance_at: "Date",
    export_col_channel: "Channel",
    export_col_outcome: "Outcome",
    export_col_author: "Author",
    export_col_automatic: "Automatic",
    export_col_notes: "Notes",
    export_yes: "Yes",
    export_no: "No",
    bulk_send_email: "Bulk email",
    bulk_title: "Bulk email reminder",
    bulk_desc:
      "One template, automatically personalized for each employee (first name, company, operation).",
    bulk_recipients_one: "{{count}} recipient",
    bulk_recipients_other: "{{count}} recipients",
    bulk_template: "Template",
    bulk_preview_note_one: "Preview shown for {{name}}.",
    bulk_preview_note_other:
      "Preview shown for {{name}}. The email will be personalized for each of the {{count}} recipients.",
    bulk_no_recipient: "No recipient with a known email address.",
    bulk_excluded_one: "{{count}} employee without an email address, excluded from sending:",
    bulk_excluded_other: "{{count}} employees without an email address, excluded from sending:",
    bulk_done_one: "{{count}} email sent.",
    bulk_done_other: "{{count}} emails sent.",
    bulk_failures_one: "{{count}} failed send:",
    bulk_failures_other: "{{count}} failed sends:",
    bulk_send_one: "Send to {{count}} recipient",
    bulk_send_other: "Send to {{count}} recipients",
    bulk_sending: "Sending {{sent}}/{{total}}…",
    bulk_send_error: "Send failed",
    bulk_customize: "Customize the message",
    bulk_reset: "Reset",
    bulk_subject: "Subject",
    bulk_body: "Message",
    bulk_customize_hint:
      "HTML content: the variables (first name, last name, company, dossier link…) stay personalized for each recipient. The Aon header and footer are added automatically. The preview below updates in real time.",
  },
  roles: {
    salarie: "Employee",
    drh: "HR Director",
    consultant_aon: "Aon Consultant",
    chef_projet_aon: "Aon Project Manager",
    admin_aon: "Aon Admin",
    desc_salarie: "BRI beneficiary",
    desc_drh: "Client HR / HR Director",
    desc_consultant_aon: "BRI production",
    desc_chef_projet_aon: "Aon operation leader",
    desc_admin_aon: "Platform administration",
    no_role: "No role assigned",
  },
  statuses: {
    non_demarre: "Not started",
    demarre_non_complete: "Started",
    complete_incomplet: "Completed — incomplete",
    complete_complet: "Completed — complete",
    en_production: "In production",
    a_restituer: "Pending delivery",
    restitue_avec_rdv: "Delivered (meeting)",
    restitue_sans_rdv: "Delivered",
    maj_sans_restitution: "Updated — no meeting",
    maj_avec_restitution: "Updated — with meeting",
    sans_suite: "Closed",
    desc_non_demarre: "The employee has not yet activated their file.",
    desc_demarre_non_complete: "The employee has started filling in their file.",
    desc_complete_incomplet: "Submitted but some documents or information are missing.",
    desc_complete_complet: "The file is ready for production.",
    desc_en_production: "Your Aon consultant is preparing your Pension Review.",
    desc_a_restituer: "The BRI is ready — the debrief meeting will be scheduled.",
    desc_restitue_avec_rdv: "The BRI was delivered during a meeting.",
    desc_restitue_sans_rdv: "The BRI was delivered without a meeting.",
    desc_maj_sans_restitution: "A BRI update was produced without a new meeting.",
    desc_maj_avec_restitution: "An update was delivered.",
    desc_sans_suite: "The file was closed without a BRI.",
    group_draft: "Draft",
    group_review: "In review",
    group_production: "Production",
    group_delivered: "Delivered",
    group_closed: "Closed",
  },
  journey: {
    demarrage: "Getting started",
    completion: "Completion",
    production: "Production",
    restitution: "Delivery",
    suivi: "Follow-up",
    desc_demarrage: "Account activation and first exchanges.",
    desc_completion: "Documents, personal situation, scenarios.",
    desc_production: "Pension calculation and BRI preparation.",
    desc_restitution: "BRI presentation by an Aon consultant.",
    desc_suivi: "Subsequent BRI updates.",
  },
  app: {
    evaluation: {
      title: "Service evaluation",
      desc: "Your assessment is available: help us improve the support we provide.",
      satisfaction: "Your overall satisfaction",
      pick: "Choose a rating",
      satisfaction_1: "Very dissatisfied",
      satisfaction_2: "Dissatisfied",
      satisfaction_3: "Neutral",
      satisfaction_4: "Satisfied",
      satisfaction_5: "Very satisfied",
      nps: "Would you recommend this support to a colleague?",
      nps_min: "Not at all",
      nps_max: "Definitely",
      optional: "(optional)",
      comment: "A comment to share with us?",
      comment_placeholder: "What was helpful, what could be improved…",
      submit: "Send my evaluation",
      update: "Update",
      sending: "Sending…",
      edit: "Edit my evaluation",
      recorded: "Thank you, your evaluation has been recorded.",
      stars: "{{count}} star(s)",
    },
    appetences: {
      title: "Your retirement preferences",
      title_salarie: "My wishes",
      required_badge: "Required to access your BRI",
      optional_badge: "Optional",
      confirm: "Confirm my wishes",
      update: "Update",
      confirmed_on: "Wishes saved on {{date}}",
      description:
        "Your wishes for what comes next: they guide your support and feed your company's reporting (anonymised).",
      souhait_depart_au_plus_tot: "Retire as early as possible",
      souhait_depart_au_plus_tard: "Retire as late as possible",
      souhait_rupture_conventionnelle: "Interested in a mutual termination",
      souhait_temps_partiel_progressive: "Part-time / progressive retirement",
      interet_rachat_trimestres: "Interested in buying back quarters",
      interet_cumul_emploi_retraite: "Interested in combining work and retirement",
      souhait_date_depart: "Desired retirement date",
      hint: "Each answer is saved immediately.",
    },
    scenarios: {
      des_que_possible: "As early as possible",
      des_que_possible_desc:
        "Earliest possible retirement, as soon as a first pension can be paid (often with a reduction).",
      des_que_possible_result: "Retirement as early as possible",
      age_legal: "At legal age",
      age_legal_desc: "Retirement at the legal pension age, which depends on your year of birth.",
      age_legal_perso: "Your legal age: {{age}} (earliest departure {{date}}).",
      age_legal_result: "Retirement at legal age",
      age_62: "At 62",
      age_62_desc:
        "Early retirement at 62 (usually with a reduction if the full rate is not reached).",
      age_62_result: "Retirement at 62",
      age_65: "At 65",
      age_65_desc: "Retirement at 65.",
      age_65_result: "Retirement at 65",
      taux_plein_naturel: "At full rate",
      taux_plein_naturel_desc:
        "Retirement as soon as the automatic full rate is reached (between 65 and 67 depending on your date of birth).",
      taux_plein_naturel_result: "Full-rate retirement (full pension)",
      age_67: "At 67 (guaranteed full rate)",
      age_67_desc:
        "Retirement at 67, the automatic full-rate age regardless of the number of quarters.",
      rachat_taux_plein: "With buyback of quarters for the full rate",
      rachat_taux_plein_desc:
        "Retirement at the legal age after buying back the missing quarters (up to 12) to reach the full rate, with estimated cost and payback period.",
      rachat_taux_seul: "Legal-age buyback (rate only)",
      rachat_taux_seul_desc: "Quarter buyback affecting the pension rate only.",
      rachat_taux_seul_result: "Legal-age retirement after buyback (rate only)",
      rachat_taux_plein_result: "Legal-age retirement after quarters buyback",
      date_imposee: "Date set by the company",
      date_imposee_desc: "Departure date requested by your company for the whole operation.",
      age_67_result: "Retirement at 67",
      date_departure: "Retirement on {{date}}",
      date_chosen: "Retirement on a chosen date",
      fallback: "Scenario",
    },
    nav: {
      group_employee: "My space",
      group_aon: "Aon space",
      group_drh: "HR space",
      group_admin: "Administration",
      dashboard: "Dashboard",
      parcours: "My retirement journey",
      historique: "My calculation history",
      dossier: "My file",
      documents: "My documents",
      simulations: "My simulations",
      bri: "My BRI",
      messages: "Messages",
      rdv: "Appointments",
      formations: "Training",
      profile: "My profile",
      settings: "Settings",
      help: "Help & contacts",
      evaluation: "Service evaluation",
      // HR
      operations: "Operations",
      salaries: "Employees",
      relances: "Follow-ups",
      reporting: "Reporting",
      synthese_mission: "Mission summary",
      // Aon
      mes_dossiers: "My files",
      calendrier: "My calendar",
      bibliotheque: "Library",
      revue: "Quality review",
      anomalies: "Anomaly library",
      equipe: "My team",
      pilotage: "Steering",
      // Admin
      onboarding: "New company",
      tenants: "Clients",
      utilisateurs: "Users",
      email_templates: "Email templates",
      branding: "Branding",
      audit: "Audit",
      roadmap: "Roadmap",
      rachat_bareme: "Buyback scale",
      annexes_bri: "BRI annexes",
      rgpd: "GDPR",
      controle_qualite: "Quality checklist",
      document_types: "Document types",
      referentiels: "Reference data freshness",
      referentiel_professions: "Professions reference",
      conventions_collectives: "Collective agreements",
      parametres: "Settings",
      couts_ia: "AI costs",
      stats_usage: "Usage statistics",
      suivi_messages: "Message tracking",
    },
    header: {
      greeting_morning: "Good morning",
      greeting_afternoon: "Good afternoon",
      greeting_evening: "Good evening",
      search_placeholder: "Search…",
      open_menu: "Open menu",
      change_language: "Change language",
      breadcrumb: "Breadcrumb",
    },
    dashboard: {
      welcome_back: "Welcome back",
      no_dossier_title: "No active file",
      no_dossier_body:
        "Your file has not been created yet. If your employer just invited you, please wait a few minutes or contact your HR.",
      kpi_status: "File status",
      kpi_consultant: "Aon consultant",
      kpi_next_rdv: "Next appointment",
      kpi_bri_type: "BRI type",
      no_consultant: "To be assigned",
      no_rdv: "No scheduled appointment",
      progression: "Progress",
      actions_title: "Things to do",
      actions_empty: "You're all caught up, nothing to do for now ✨",
      action_upload_ris: "Upload your career statement (RIS)",
      action_upload_agirc: "Upload your Agirc-Arrco statement",
      action_upload_bulletin: "Upload your latest payslip",
      action_complete_profile: "Complete your contact details",
      action_select_scenarios: "Pick your simulation scenarios",
      action_book_rdv: "Book your debrief appointment",
      recent_activity: "Recent activity",
      urgent_title: "File marked urgent",
      urgent_body:
        "Your Aon adviser is handling it as a priority. Your HR contact only sees that it is a priority.",
      urgent_auto: "Automatically flagged as a priority (departure soon)",
    },
    notFound: {
      title: "Page not found",
      description: "This address does not match any page in your space.",
      back_home: "Back to home",
    },
    profile: {
      title: "My profile",
      subtitle: "Your contact details and personal preferences.",
      section_identity: "Identity",
      section_contact: "Contact",
      section_preferences: "Preferences",
      first_name: "First name",
      last_name: "Last name",
      civility: "Title",
      email: "Email",
      phone: "Phone",
      locale: "Interface language",
      saved: "Changes saved.",
      save: "Save changes",
      section_security: "Security",
      contact_pref_title: "Contact preferences",
      contact_pref_desc:
        "You can ask the team to stop following up about your file. You keep access to your space and can change your mind at any time.",
      contact_pref_label: "I do not wish to be contacted about my file",
      contact_pref_on: "You will no longer receive reminders (email, phone) from the team.",
      contact_pref_off: "The team may follow up if your file remains incomplete.",
      security_description: "Update your sign-in password.",
      new_password: "New password",
      confirm_password: "Confirm password",
      password_hint: "8 characters minimum.",
      password_too_short: "Password must be at least 8 characters long.",
      password_mismatch: "Passwords do not match.",
      change_password: "Change password",
      password_saved: "Password updated.",
      mfa_title: "Two-factor authentication",
      mfa_desc: "Protect your account with a code generated by an app on your phone.",
      mfa_status_on: "2FA enabled",
      mfa_status_off: "2FA not enabled",
      mfa_required_badge: "Required for your profile",
      mfa_enable: "Enable two-factor authentication",
      mfa_regenerate: "Regenerate my recovery codes",
      mfa_disable: "Disable two-factor authentication",
      mfa_codes_done: "I have saved my new codes",
      mfa_error: "The operation failed. Please try again.",
      rgpd: {
        title: "My personal data (GDPR)",
        description:
          "Exercise your rights over your data: access, rectification, erasure, objection or restriction. Your request will be processed within one month.",
        kind_label: "Request type",
        reason_label: "Details (optional)",
        reason_placeholder: "Describe your request if needed…",
        submit: "Send my request",
        submitted: "Request submitted",
        my_requests: "My requests ({{count}})",
        deposited: "Submitted on {{date}}",
      },
    },
    dossier: {
      title: "My file",
      subtitle: "Overview of your retirement file.",
      tab_overview: "Summary",
      tab_career: "Career",
      tab_family: "Family",
      tab_special: "Special cases",
      tab_scenarios: "Scenarios",
      not_assigned: "Not yet linked to an employee record.",
    },
    dossierDetail: {
      // Tabs
      tab_synthesis: "Summary",
      tab_documents: "Documents",
      tab_scenarios: "Scenarios",
      tab_career: "Career",
      tab_calculations: "Calculations",
      tab_analysis: "Noa Analysis",
      tab_vip: "VIP",
      tab_appointments: "Appointments",
      tab_history: "History",
      chomage_title: "Unemployment scenario",
      chomage_desc:
        "Models a period of unemployment before retirement, based on the dates declared by the employee.",
      chomage_active: "Active",
      chomage_inactive: "Not included",
      chomage_by_config: "Enabled by the operation settings.",
      chomage_request_cta: "Request the unemployment scenario",
      chomage_request_title: "Request an unemployment scenario",
      chomage_request_desc:
        "The scenario will be taken into account at the next calculation, using the dates provided by the employee.",
      chomage_request_message: "Message for the Aon team (optional)",
      chomage_request_placeholder: "E.g. settlement agreement planned for late 2027.",
      chomage_request_send: "Send request",
      chomage_request_received: "Unemployment scenario requested on {{date}}",
      chomage_request_clear: "Remove request",
      // Header
      not_found: "File not found",
      not_found_description: "You may not have access to this file.",
      back_to_list: "← Back to list",
      vip: "VIP",
      consultant: "Consultant:",
      me: "Me",
      not_assigned: "not assigned",
      assign: "assign",
      // Urgent file (B4)
      urgent_badge: "Urgent",
      urgence_delay_badge: "Overdue",
      urgent_detail_prefix: "since {{date}}",
      urgence_reason_depart_moins_6_mois: "Departure planned within 6 months",
      urgence_reason_rupture_licenciement: "Termination or dismissal in progress",
      urgence_reason_decision_rapide: "Decision to be made quickly",
      urgence_reason_autre: "Other",
      urgence_source_salarie: "employee",
      urgence_source_consultant: "Aon staff",
      urgence_source_automatique: "automatic flag",
      urgence_mark: "Mark as urgent",
      urgence_lift: "Clear urgency",
      urgence_lift_title: "Clear urgency?",
      urgence_lift_desc:
        "The file will lose its urgent badge. This action is recorded in the history.",
      urgence_lift_desc_auto:
        "This urgency was flagged automatically. Clearing it tells the daily job not to flag it again.",
      urgence_dialog_title: "Mark the file as urgent",
      urgence_dialog_desc:
        "The file will be listed first and a notification will be sent to the assigned project manager and consultant.",
      urgence_reason_label: "Reason",
      urgence_reason_pick: "Choose a reason",
      urgence_comment_label: "Comment (optional)",
      urgence_comment_ph: "Details visible only to the Aon team.",
      urgence_history_title: "Urgency history",
      urgence_history_marked: "Marked urgent",
      urgence_history_lifted: "Urgency cleared",
      modify: "modify",
      project_manager: "Project manager:",
      reviewer: "Reviewer:",
      restitution_consultant: "Restitution consultant:",
      restitution_same_as_production: "Same as the production consultant",
      release: "Release",
      open_file: "The file",
      edit_file: "Edit file",
      // Overview tab
      not_editable_warning:
        "This file is no longer in the employee completion phase. File modification is now done in back-office only.",
      identity: "Identity",
      civility: "Civility",
      first_name: "First name",
      last_name: "Last name",
      birth_name: "Birth name",
      birth_date: "Date of birth",
      birth_place: "Place",
      email: "Email",
      phone: "Phone",
      career_current_company: "Career (current company)",
      company: "Company",
      site: "Site",
      position: "Position",
      category: "Category",
      entry_date: "Entry date",
      presence: "Presence",
      present: "Present",
      left: "Left",
      declared_salary: "Declared salary",
      confirmed_salary: "Confirmed salary",
      family: "Family",
      situation: "Situation",
      spouse_birth: "Spouse — birth",
      wedding_date: "Wedding date",
      children_count: "Number of children",
      children_charge_retirement: "Children charge retirement",
      children_handicap: "Children in handicap",
      yes: "Yes",
      no: "No",
      special_cases: "Special cases",
      no_special_cases: "No special cases declared.",
      cet_jours: "Saved CET days",
      cet_avant_depart: "CET used before departure",
      children_quarters_title: "Quarters per child",
      children_quarters_hint:
        "Bonus quarters retained per child. Empty = general rule (8 quarters, 4 for a stillborn child). Adjust for sharing between parents, adoption or a special scheme.",
      children_quarters_total: "{{count}} quarters in total",
      children_quarters_empty: "No child declared at the Family step.",
      child_n: "Child {{index}}",
      child_stillborn: "Stillborn",
      child_handicap: "Disability",
      child_quarters_label: "Quarters",
      file_metadata: "File metadata",
      id: "ID",
      bri_type: "BRI Type",
      created_on: "Created on",
      submitted_on: "Submitted on",
      control_n1: "Control N1",
      control_n2: "Control N2",
      restored_on: "Restored on",
      // Documents tab
      no_document_uploaded: "No document uploaded",
      no_document_description:
        "The employee has not yet provided any documents. Follow up if necessary.",
      close: "Close",
      reject_document: "Reject this document",
      reject_reason: "Rejection reason",
      reject_placeholder: "Ex. unreadable, incomplete document, wrong document type…",
      reject_button: "Reject",
      document_rejected_default: "Document rejected",
      launch_ris_extraction: "Launch RIS extraction",
      launch_analysis: "Launch analysis",
      ris_extraction_description:
        "The RIS will be transmitted to the calculation engine to automatically extract career periods, points and quarters, feeding the <strong>Career</strong> tab.",
      ris_revenue_note:
        "The end-of-career income is recalculated (un-capped from PASS) by the engine.",
      validated: "Validated",
      rejected: "Rejected",
      to_validate: "To validate",
      parsed: "Parsed",
      parse_this_ris: "Parse this RIS",
      uploaded_on: "Uploaded on",
      reason: "Reason:",
      // Scenarios tab
      no_scenario_selected: "No scenario selected",
      no_scenario_description: "The employee will choose their scenarios when completing the file.",
      selected_by: "by",
      inactive: "inactive",
      selected_on: "Selected on",
      // History tab
      no_history: "No history",
      current_status: "Current status:",
      // Consent journal
      consents_title: "Consents",
      consent_privacy: "Aon privacy commitment accepted, version {{version}}",
      consent_share: "Employer sharing: {{from}} → {{to}}",
      share_full: "full report",
      share_date_only: "departure date only",
      share_none: "no information",
      share_initial: "no choice",
      // Appointments tab
      appointments_count_one: "{{count}} appointment",
      appointments_count_other: "{{count}} appointments",
      schedule_appointment: "Schedule an appointment",
      no_appointment: "No appointment",
      schedule_description: "Schedule a restitution appointment with the employee.",
      no_appointment_description: "No appointment has been scheduled yet for this file.",
      open_meeting_link: "Open meeting link",
      realized: "Realized",
      cancel: "Cancel",
      cancel_appointment: "Cancel this appointment",
      appointment_cancellation_note:
        "The associated time slot will become available again. The employee will not be automatically notified in this version.",
      // Status transitions
      change_status: "Change status",
      status_change_description: "Status change",
      reason_optional: "Reason (optional, traced in history)",
      reason_placeholder: "Ex. employee provided missing documents, appointment scheduled…",
      validate_change: "Validate change",
      // Take over menu
      reassign: "Reassign",
      assign_to_myself: "Assign to myself",
      take_charge: "Take charge",
      i_become_consultant: "I become the consultant.",
      assign_to_consultant: "Assign to a consultant…",
      choose_team_member: "Choose a team member.",
      // Dynamic labels
      reject_document_description: "Document « {{filename}} ». The employee will be notified.",
      parse_document_description: "Document « {{filename}} ».",
      parsed_with_count_one: "{{count}} period",
      parsed_with_count_other: "{{count}} periods",
      cancel_appointment_description: "Appointment on {{date}}.",
      selected_on_date: "Selected on {{date}}",
      uploaded_on_date: "Uploaded on {{date}}",
      reason_value: "Reason: {{reason}}",
      full_rate_age_value: "{{years}} years{{months}}",
      full_rate_age_months: " {{months}} m",
      appointment_consultant: "Consultant: {{name}}",
      // Calculation tab
      retirement_calculation: "Retirement calculation",
      open_retirement_journey: "Open retirement journey",
      no_calculation_available:
        "No calculation available. Import a RIS, then launch the calculation from the retirement journey.",
      monthly_gross_pension: "Monthly gross pension",
      monthly_net_pension: "Monthly net pension",
      replacement_rate: "Replacement rate",
      validated_quarters: "Validated quarters",
      contributed_quarters: "Contributed quarters",
      deemed_contributed_quarters: "Deemed contributed",
      full_rate_age: "Full rate age",
      // Appointment channels
      video: "Video",
      telephone: "Telephone",
      in_person: "In person",
      // Appointment statuses
      proposed: "Proposed",
      planned: "Planned",
      cancelled: "Cancelled",
      absent: "Absent",
      // Tracking
      file_tracking: "File tracking",
      closed_short: "Closed",
      to_do: "To do",
      status_non_demarre: "Not started",
      status_demarre_non_complete: "Started",
      status_complete_incomplet: "Completed — incomplete",
      status_complete_complet: "Completed — complete",
      status_en_production: "In production",
      status_a_restituer: "To be delivered",
      status_restitue_avec_rdv: "Delivered (appointment)",
      status_restitue_sans_rdv: "Delivered",
      status_maj_sans_restitution: "Update — without delivery",
      status_maj_avec_restitution: "Update — with delivery",
      status_sans_suite: "Closed without follow-up",
      status_non_demarre_description: "The employee has not yet activated their file.",
      status_demarre_non_complete_description: "The employee has started completing their file.",
      status_complete_incomplet_description: "Submitted but documents or information are missing.",
      status_complete_complet_description: "The file is ready to move into production.",
      status_en_production_description: "The Aon consultant is preparing your Retirement Report.",
      status_a_restituer_description: "The BRI is ready — delivery will be scheduled.",
      status_restitue_avec_rdv_description: "The BRI was delivered during an appointment.",
      status_restitue_sans_rdv_description: "The BRI was delivered without an appointment.",
      status_maj_sans_restitution_description: "A BRI update was produced without a new meeting.",
      status_maj_avec_restitution_description: "An update was delivered.",
      status_sans_suite_description: "The file was closed without a BRI.",
      journey_step_demarrage: "Start",
      journey_step_demarrage_description: "Account activation and first exchanges.",
      journey_step_completion: "Completion",
      journey_step_completion_description: "Documents, situation, scenarios.",
      journey_step_production: "Production",
      journey_step_production_description: "Pension calculation and BRI preparation.",
      journey_step_restitution: "Delivery",
      journey_step_restitution_description: "BRI presentation by an Aon consultant.",
      journey_step_suivi: "Follow-up",
      journey_step_suivi_description: "Subsequent BRI updates.",
      next_action_non_demarre: "Invite / follow up with the employee to activate their space.",
      next_action_demarre_non_complete:
        "The employee must complete their file (information, documents, scenarios).",
      next_action_complete_incomplet:
        "Some documents or information are missing: follow up with the employee to complete.",
      next_action_complete_complet: "File ready: assign a consultant and move to production.",
      next_action_en_production:
        "BRI calculations and drafting in progress, then N1 / N2 controls.",
      next_action_a_restituer: "BRI ready: schedule the delivery appointment with the employee.",
      next_action_restitue_avec_rdv:
        "Report delivered: collect feedback and handle update requests.",
      next_action_restitue_sans_rdv:
        "Report delivered: collect feedback and handle update requests.",
      next_action_maj_sans_restitution: "Update produced: nothing to do, ongoing monitoring.",
      next_action_maj_avec_restitution: "Update produced: nothing to do, ongoing monitoring.",
      next_action_sans_suite: "File closed without follow-up.",
      // BRI
      bri_delivered: "BRI delivered",
      bri_description:
        "Generate the Individual Retirement Report PDF — the same document downloadable from the employee's retirement journey.",
      pptx_source_title: "PowerPoint source (VIP file)",
      pptx_source_hint:
        "Same pages as the PDF, as editable shapes, to rework the restitution. Template illustrations are included as high-resolution images.",
      pptx_source_download: "Download the .pptx",
      generation_blocked: "Generation blocked.",
      n1_must_be_validated: "N1 control must be validated.",
      n2_must_be_validated: "N2 control must be validated.",
      generate_new_version: "Generate a new version",
      generate_bri: "Generate the BRI",
      create_version_vX:
        "Creates v{{nextVersion}} (replaces v{{currentVersion}} as current version).",
      first_bri_v1: "First BRI delivered (v1).",
      regenerate: "Regenerate",
      previous_versions: "Previous versions ({{count}})",
      send_bri_to_employee: "Send the BRI to the employee",
      send_bri_description:
        "Version {{version}} will be made available in the employee's space, who will be notified by email.",
      send: "Send",
      employee_will_receive_email:
        "The employee will receive an email inviting them to view their Individual Retirement Report.",
      bri_version: "Version {{version}}",
      draft: "Draft",
      current: "Current",
      sent_on: "Sent on {{date}}",
      not_sent_to_employee: "Not sent to employee",
      send_to_employee: "Send to employee",
      open: "Open",
      bri_selection_title: "Simulations shown in the BRI",
      bri_selection_help:
        "The BRI will only show the checked simulations, in this order. The choice applies to the next generation; already produced BRIs do not change.",
      bri_selection_source_consultant: "Consultant's choice",
      bri_selection_source_operation: "Operation default",
      bri_selection_source_all: "All simulations",
      bri_selection_degraded_warning:
        "None of the selected items is available in the latest calculation: the BRI will show all simulations.",
      bri_selection_empty: "No simulation available: run the file's calculation first.",
      bri_selection_on_demand: "On-demand simulation",
      bri_selection_progressive_title: "Progressive retirement: quotities shown",
      bri_selection_save: "Save selection",
      bri_selection_reset: "Back to default choice",
      // Controls
      controls_self_control_sheet: "Self-control sheet",
      controls_description: "Two-level review to complete before making the BRI available.",
      sim_settings_title: "Simulation settings",
      sim_settings_desc: "Bounds inherited from the operation, and optional unlock for this file.",
      sim_parcours_type: "Journey type",
      sim_max_age: "Maximum retirement date",
      sim_rachat: "Quarter buyback",
      sim_quota: "Simulations / 12 months",
      sim_quota_value: "{{count}} per employee",
      sim_quota_unlimited: "Unlimited",
      sim_policy_taux_plein_naturel: "Natural full rate",
      sim_policy_age_65: "Up to age 65",
      sim_policy_age_67: "Up to age 67",
      sim_policy_libre: "Unrestricted",
      sim_request_title: "The employee requested a specific date on {{date}}",
      sim_unlock_label: "Allow free dates for this file",
      sim_unlock_active: "Unlocked",
      sim_unlock_hint:
        "The employee will be able to simulate any retirement date, ignoring the operation bound.",
      controls_n1_production: "Control N1 — Production self-check",
      controls_n1_description:
        "Self-check performed by the consultant in charge of the file (project manager and admin as backup).",
      controls_n1_reserved_consultant:
        "Reserved for the consultant in charge of the file, the project manager or an admin.",
      controls_unvalidate_n1_cascade: "Cancelling N1 also cancels the N2 control.",
      controls_n2_project_manager: "Control N2 — Project manager",
      controls_n2_description_available: "Final check by the project manager before delivery.",
      controls_n2_description_waiting: "Waiting for N1 validation before becoming available.",
      controls_validated: "Validated",
      controls_validated_by: "Validated by {{name}}",
      controls_bri_can_be_generated: "The BRI can now be generated.",
      controls_progress:
        "{{doneRequired}}/{{totalRequired}} required · {{doneTotal}}/{{totalTotal}} total",
      controls_validate_level: "Validate N{{level}}",
      controls_validate_blocked: "Check all required N{{level}} points to validate.",
      controls_reserved_project_manager: "Reserved for the project manager",
      controls_loading_grid: "Loading grid…",
      controls_no_checkpoints_defined: "No checkpoints defined for this level.",
      controls_required: "Required",
    },
    salarieFollowup: {
      // Salarie follow-up
      account_management: "Account management",
      account_management_description: "Training, activation and employee login.",
      formation_followed: "Training completed",
      formation_marked_on: "Marked on {{date}}",
      formation_question: "Has the employee completed the retirement training?",
      trained_check_title: "Employee trained — follow-up check:",
      logged_in: "Logged in",
      last_login_on: "Last login on {{date}}",
      login_detected: "Login detected",
      checking: "Checking…",
      account_created_never_logged_in: "Account created but never logged in",
      no_account_send_invitation: "No account — send an invitation",
      file_complete: "File complete",
      all_required_elements_provided: "All required elements are provided",
      elements_provided: "{{done}}/{{total}} elements provided",
      trained_but_issue: "Employee trained but {{issue}}",
      not_connected: "not logged in",
      file_incomplete: "file incomplete",
      follow_up_below: "— follow up (see Relances module below).",
      not_yet_trained: "Employee not yet trained",
      invite_to_training: "— invite to a training session before login/completion follow-up.",
      account_activated: "Account activated",
      account_created: "Account created",
      no_account_send_invitation_from_list: "No account — send an invitation from the list",
      file_completeness: "File completeness",
      all_elements_present: "All required elements are present.",
      elements_missing: "Some elements are still missing from the file.",
      no_file_yet: "No file: it will be created on the employee's first login.",
      checklist_infos: "Individual information",
      checklist_ris: "Career statement",
      checklist_agirc_arrco: "Agirc-Arrco statement",
      checklist_bulletin: "December N-1 payslip",
      checklist_profil: "Other elements based on profile (hardship, disability…)",
      checklist_hypotheses: "Calculation assumptions settings",
      profile_requires_justification:
        "The employee profile (special cases) requires supporting documentation.",
      no_special_case_no_justification:
        "No special case declared: no supporting documentation required.",
      not_required: "Not required",
      account_closure_title: "Account closure",
      account_closure_description: "Record the employee's departure (date and reason).",
      account_closed_badge: "Closed",
      account_outgoing_badge: "Leaving on {{date}}",
      account_active_badge: "Active",
      exit_date: "Exit date",
      exit_reason: "Reason for departure",
      exit_reason_unspecified: "Not specified",
      reactivate_account: "Reactivate account",
      close_account: "Close account",
      active_description:
        "The employee is currently active. Record their departure when they leave the company.",
      closure_warning:
        "Closure marks the employee as left the company. Their account will remain accessible but will be flagged as 'Left'.",
      exit_comment_placeholder: "Additional comment on the departure (optional)",
      exit_date_required: "Exit date is required.",
      exit_reason_required: "Reason for departure is required.",
      closure_error: "Error while closing the account.",
      reactivate_account_title: "Reactivate this account?",
      reactivate_account_description:
        "The exit date and reason will be cleared and the employee will become active again.",
      exit_type_retraite: "Voluntary retirement",
      exit_type_mise_a_la_retraite: "Employer-initiated retirement",
      exit_type_rupture_conventionnelle: "Mutual termination",
      exit_type_licenciement: "Dismissal",
      exit_type_demission: "Resignation",
      exit_type_mutation: "Transfer",
      exit_type_deces: "Deceased",
      exit_type_autre: "Other",
      relances_title: "Follow-ups",
      refuse_contact_title: "This employee asked not to be contacted again.",
      refuse_contact_body:
        "They are excluded from automatic reminders and from the follow-up queue. Respect this choice: only reach out for a legal or contractual obligation.",
      relances_description: "Track follow-ups by email or phone.",
      new_relance: "New follow-up",
      relance_channel_email: "Email",
      relance_channel_telephone: "Phone",
      relance_notes_placeholder: "Follow-up comment (response obtained, next action…)",
      relance_outcome_label: "Follow-up result ({{channel}})",
      relance_outcome_repondu: "Answered",
      relance_outcome_pas_de_reponse: "No answer",
      relance_outcome_message_laisse: "Message left",
      relance_outcome_a_rappeler: "To call back",
      relance_outcome_refus: "Declined",
      relance_outcome_injoignable: "Unreachable",
      next_relance_date: "Next follow-up scheduled",
      save_relance: "Save follow-up",
      relance_save_error: "Error while saving",
      no_relances: "No follow-up recorded for this employee.",
      relance_auto: "Auto",
      relance_by: "by {{name}}",
      next_relance_on: "Next follow-up scheduled {{date}}",
      delete_relance: "Delete follow-up",
      delete_relance_title: "Delete this follow-up?",
      delete_relance_description: "The entry will be permanently removed from the follow-up log.",
      evaluation_title: "Service evaluation",
      evaluation_description: "Employee feedback after the delivery of their report.",
      no_evaluation_yet: "The employee has not yet evaluated the service.",
      evaluation_score: "{{score}}/5",
      evaluation_recommendation_badge: "Recommendation {{score}}/10",
      evaluated_on: "Evaluated on {{date}}",
      evaluation_invited_on: "Invitation sent on {{date}}",
      evaluation_reminded_on: "Reminder sent on {{date}}",
      satisfaction_1: "Very dissatisfied",
      satisfaction_2: "Dissatisfied",
      satisfaction_3: "Neutral",
      satisfaction_4: "Satisfied",
      satisfaction_5: "Very satisfied",
    },
    careerPeriods: {
      unavailable_title: "The career periods editor is not available",
      unavailable_desc: "The career periods table is not yet available in this environment.",
      postgres_error: "Postgres error: {{msg}}",
      unknown_error: "Unknown error",
      count_one: "{{count}} period",
      count_other: "{{count}} periods",
      validated_count_one: "{{count}} validated",
      validated_count_other: "{{count}} validated",
      add_period: "Add a period",
      empty_title: "No period entered",
      empty_desc_editable: "Start by adding the first professional period for this file.",
      empty_desc_readonly: "No period has been entered for this file yet.",
      add_first_period: "Add the first period",
      activity_period: "Activity period",
      validated: "Validated",
      revenues: "Income:",
      evolution: "evolution",
      remove_validation: "Remove validation",
      validate_period: "Validate the period",
      invalidate: "Invalidate",
      validate: "Validate",
      edit: "Edit",
      delete_confirm: "Delete the period “{{label}}”?",
      delete_desc: "This period's data will be permanently deleted. This action is irreversible.",
      delete_desc_ris:
        "The quarters and points of this period remain counted: they are part of the career statement sent to the calculation. Only delete a statement period to fix a display duplicate.",
      delete: "Delete",
      cancel: "Cancel",
      period_fallback: "period {{range}}",
      in_progress: "ongoing",
    },
    noaAnalyse: {
      cancel: "Cancel",
      save: "Save",
      edit_text: "Edit text",
      regenerate: "Regenerate (AI)",
      generate: "Generate with AI",
      generate_self: "Run my analysis",
      regenerate_self: "Run my analysis again",
      generate_failed: "Analysis generation failed.",
      save_failed: "Saving failed.",
      reset_failed: "Reset failed.",
      title_aon: "Full analysis by Noa",
      title_salarie: "Your personalized analysis",
      description_aon:
        "Detailed case study of the file, verified against official sources. Generate a first version with AI, then freely adjust the text: this is the version the employee will see.",
      description_salarie:
        "A detailed study of your retirement situation: profile, scenarios, optimization levers and personalized recommendations.",
      editor_aria: "Analysis content",
      reset_to_ai: "Reset to the AI-generated text",
      publish: "Publish to employee",
      unpublish: "Unpublish",
      publish_failed: "The publication could not be saved.",
      badge_published: "Published",
      badge_draft: "Draft",
      pending_publication:
        "Your analysis is being reviewed by your Aon adviser. It will appear here as soon as it is approved.",
      unpublish_confirm_title: "Unpublish?",
      unpublish_confirm_desc:
        "The employee will lose access to the analysis and the Tranche C trade-off, and both will disappear from their report. You can publish again at any time.",
      empty_aon:
        "Run the analysis to generate a first version with AI, then adjust the text before it becomes visible to the employee.",
      empty_salarie:
        "Your personalized analysis will be available soon. Your Aon advisor is preparing it for you.",
      description_self:
        "Noa reviews your situation and writes a detailed analysis for you: profile, retirement scenarios, optimisation levers and recommendations.",
      empty_self:
        "Run your analysis whenever you like: Noa goes through your career, your simulations and the rules in force to explain your situation. Allow one to two minutes.",
      disclaimer_self:
        "Analysis written by Noa, our retirement-specialised artificial intelligence, from the information in your file. A decision-making aid: it does not replace personalised legal or tax advice.",
      disclaimer_self_with_date:
        "Analysis written by Noa, our retirement-specialised artificial intelligence, on {{date}}, from the information in your file. Run it again after any change. A decision-making aid: it does not replace personalised legal or tax advice.",
      cooldown:
        "Your analysis has just been generated. You will be able to run it again in a few minutes.",
      no_credit:
        "The AI service is out of credit: generation is paused until the account is topped up. Try again afterwards.",
      last_error_title: "Last generation failed on {{date}}",
      last_error_retry: "Run the generation again once the cause is fixed.",
      disclaimer_readonly:
        "This analysis has been prepared for you by your Aon advisor. It is a decision-making aid and does not replace personalized legal or tax advice.",
      disclaimer_editable_with_date:
        "First version generated by artificial intelligence on {{date}}{{model}}, then reviewed and adjusted by the Aon team. Decision-making aid: does not replace personalized legal or tax advice.",
      disclaimer_editable_no_date:
        "First version generated by artificial intelligence{{model}}, then reviewed and adjusted by the Aon team. Decision-making aid: does not replace personalized legal or tax advice.",
      loading_title: "Noa is studying your file… this can take a few minutes.",
      background_hint:
        "You can leave this page: the analysis continues and will appear when you return.",
      did_you_know: "Did you know?",
      steps: [
        "Reconstruction of your career and your rights",
        "Verification of the applicable legal parameters",
        "Analysis of your different retirement scenarios",
        "Identification of optimization levers",
        "Drafting of your personalized conclusion",
      ],
      facts: [
        "The full rate is obtained either by reaching the insurance duration required for your generation, or by reaching the automatic full-rate age.",
        "Each missing quarter leads to a reduction; conversely, working beyond the full rate grants an increase.",
        "The Agirc-Arrco supplementary pension works in points, converted into a pension via the point service value.",
        "The basic pension of the general scheme is calculated on the average of your 25 best salary years, reduced to 24 or 23 years for certain parents under the social security financing act for 2026.",
        "The “long career” scheme may allow retirement before the legal age, subject to early-activity conditions.",
        "The Agirc-Arrco solidarity coefficient (temporary penalty) was abolished for pensions taking effect on or after 1 December 2023.",
      ],
    },
    documents: {
      title: "My documents",
      subtitle: "Upload the documents needed to produce your Individual Retirement Report.",
      kind_ris: "Career statement (RIS)",
      kind_agirc_arrco: "Agirc-Arrco statement",
      kind_bulletin: "Payslip (December N-1)",
      kind_other: "Other document",
      uploaded_at: "Uploaded on",
      validated: "Validated",
      pending_validation: "Awaiting validation",
      rejected: "Rejected",
      add: "Upload a document",
      drop_here: "Drop your file here or click to browse.",
      empty: "No documents uploaded yet.",
      extracted_periods_one: "{{count}} period imported from the RIS (Career tab).",
      extracted_periods_other: "{{count}} periods imported from the RIS (Career tab).",
      extract_failed: "RIS analysis failed.",
      download: "Download",
      download_aria: "Download {{name}}",
      download_error: "Unable to download this file. Please try again in a moment.",
    },
    messages: {
      kicker: "My space",
      title: "Messages",
      subtitle: "Your direct channel with the Aon team handling your file.",
      new_message: "New message",
      no_messages: "No messages yet.",
      send: "Send",
      type_message: "Write a message…",
      attachment: "Attachment",
      attachments: "Attachments",
      no_dossier_title: "Messaging will be available soon",
      no_dossier_body:
        "As soon as a file is created for you, you'll be able to chat with your Aon consultant from here.",
      no_consultant_title: "No consultant assigned yet",
      no_consultant_body:
        "You'll be able to start a conversation as soon as an Aon consultant is assigned to you.",
      start_title: "Start a conversation",
      start_body: "Ask your Aon consultant your first question.",
      start_button: "Start the discussion",
      unknown_error: "Unknown error",
      aon_team: "Aon Retirement Team",
      role_chef_projet: "Aon project manager",
      role_consultant: "Aon consultant",
      // Aon space + shared message thread
      aon_kicker: "Aon steering",
      aon_subtitle: "Your conversations with employees and project managers.",
      new_conversation: "New conversation",
      tab_active: "Active",
      tab_archived: "Archived",
      no_archived: "No archived conversation",
      no_conversation: "No conversation",
      empty_hint: "Threads started from a file will appear here.",
      back_to_list: "Conversations",
      select_conversation: "Select a conversation",
      dialog_title: "New conversation",
      dialog_description: "Select an employee within your scope to start (or reopen) an exchange.",
      search_employee_placeholder: "Search an employee (last name, first name, email, ID)…",
      error_create_dossier: "Unable to create the employee's file.",
      no_employee_found: "No employee found",
      no_employee: "No employee",
      no_employee_scope: "No employee is attached to your scope.",
      no_name: "(no name)",
      opening: "Opening…",
      no_subject: "(no subject)",
      participants_count_one: "{{count}} participant",
      participants_count_other: "{{count}} participants",
      channel_salarie_production: "Employee ↔ Production",
      channel_drh_chefprojet: "HR ↔ Project manager",
      open_dossier_title: "Open linked file",
      dossier: "File",
      archive: "Archive",
      restore: "Restore",
      no_one: "(no one)",
      relative_min: "{{count}} min ago",
      relative_hour: "{{count}} h ago",
      relative_day: "{{count}} d ago",
      drop_files: "Drop your files here",
      no_messages_title: "No message",
      no_messages_body: "Start the discussion by sending a first message below.",
      remove_file: "Remove",
      attach_file: "Attach a file",
      archived_conversation: "Archived conversation",
      send_shortcut: "Send (Ctrl/Cmd+Enter)",
      enter_key: "Enter",
      drop_hint: "to send · drop your files into the conversation",
      deleted_message: "Message deleted",
      delete_message: "Delete message",
      seen: "Seen",
      mark_unread: "Mark as unread",
      size_b: "{{value}} B",
      size_kb: "{{value}} KB",
      size_mb: "{{value}} MB",
      send_failed: "Send failed",
      file_too_big: "The file « {{name}} » exceeds 25 MB.",
      max_files: "Maximum {{count}} files per message.",
    },
    bri_lock: {
      title: "Your Retirement Review is ready",
      version: "Version {{version}}",
      finalized_on: "finalised on {{date}}",
      body: "Your Aon consultant has finalised your Individual Retirement Review. They will present and discuss it with you during a restitution meeting: pick the date that suits you in their agenda.",
      next_rdv_title: "Appointment confirmed.",
      next_rdv_body: "Your restitution is scheduled on {{date}}.",
      manage_rdv: "Manage my appointment",
      choose_date: "Choose an appointment date",
      unlock_note: "The document will be downloadable here after your restitution meeting.",
      parcours_body:
        "Your document is finalised and will be handed to you during your restitution meeting with your Aon consultant. It will be downloadable here right after.",
      appetences_title: "Share your wishes to access your BRI",
      appetences_body:
        "Your Retirement Review is ready. To access it, first share your retirement wishes in the “My results” step, even if none apply: you only need to confirm.",
      appetences_cta: "Share my wishes",
    },
    rdv: {
      kicker: "My space",
      title: "My appointments",
      subtitle: "Debrief appointments for your Pension Review.",
      book: "Book a slot",
      book_short: "Book",
      no_rdv: "No appointments scheduled.",
      upcoming: "Upcoming",
      past: "Past",
      cancel_rdv: "Cancel appointment",
      confirm_cancel: "Are you sure you want to cancel this appointment?",
      no_consultant_title: "No consultant assigned yet.",
      no_consultant_body:
        "You'll be able to book an appointment as soon as an Aon consultant is assigned to you.",
      disabled_title: "Your journey is fully self-service",
      disabled_body:
        "It does not include appointments. Ask the Noa assistant or message the team: you will get a written answer.",
      upcoming_title: "Upcoming appointments",
      upcoming_empty: "No appointment scheduled",
      upcoming_empty_can_book: "Book a slot in your consultant's calendar.",
      upcoming_empty_cannot_book: "No appointment planned for now.",
      history_title: "History",
      history_count: "{{count}} past or cancelled appointments.",
      join_meeting: "Join the meeting",
      with: "with {{name}}",
      cancel: "Cancel",
      cancel_dialog_title: "Cancel this appointment",
      cancel_dialog_desc: "Appointment on {{date}}.",
      cancel_dialog_confirm: "Cancel appointment",
      cancel_dialog_body: "You can book a new appointment at any time.",
      status_propose: "Proposed",
      status_planifie: "Scheduled",
      status_realise: "Completed",
      status_annule: "Cancelled",
      status_no_show: "No-show",
      channel_visio: "Video",
      channel_phone: "Phone",
      channel_presentiel: "In person",
      book_dialog: {
        title: "Book an appointment",
        desc_with: "With your consultant {{name}}",
        desc_default: "Choose a slot in your consultant's calendar",
        cancel: "Cancel",
        confirm: "Confirm this slot",
        error_unknown: "Unknown error.",
        empty_title: "No slot available",
        empty_desc: "Your consultant hasn't opened any slots yet. Try again later or contact them.",
        slots_label: "Available slots",
        notes_label: "A message for your consultant?",
        notes_hint: "Optional: specify your questions or expectations for this appointment.",
        notes_placeholder: "E.g. I'd like to talk about phased retirement…",
        summary_prefix: "You are about to book:",
        duration_note: "The appointment length planned for your operation is {{minutes}} minutes.",
        channel_teams: "Teams video",
        channel_phone: "Phone",
        channel_presentiel: "In person",
      },
    },
    aon: {
      appointments: {
        form: {
          title: "Schedule an appointment",
          desc_with: "With {{name}}",
          mode_slot: "Existing slot",
          mode_custom: "Custom date",
          slot_label: "Choose a slot",
          no_slot:
            'No open slots. Open slots from your calendar first, or switch to "Custom date".',
          date_label: "Date",
          start_label: "Start time",
          end_label: "End time",
          modality_label: "Channel",
          channel_teams: "Video (Teams)",
          channel_phone: "Phone",
          channel_presentiel: "In person",
          url_label: "Teams / video link",
          url_hint: "Optional — can be added later",
          url_placeholder: "https://teams.microsoft.com/...",
          phone_label: "Phone number",
          phone_hint: "Will be shown to the employee",
          phone_placeholder: "+33 6 12 34 56 78",
          notes_label: "Internal notes (consultant)",
          notes_hint: "Not visible to the employee",
          notes_placeholder: "E.g. prepare the PDF mockup, ask for Excel confirmation…",
          cancel: "Cancel",
          submit: "Schedule appointment",
          error_select_slot_or_date: "Select a slot or enter a date.",
          error_unknown: "Unknown error.",
        },
      },
    },
    library: {
      kicker: "Retirement resources",
      title: "My library",
      subtitle:
        "Fact sheets, videos and articles to understand your retirement and prepare your departure with peace of mind.",
      empty: "No resources",
      empty_search: "No content matches your search.",
      empty_none: "No resources are available at the moment.",
      search_placeholder: "Search a sheet, a topic, a keyword…",
      category_all: "All",
      category_comprendre: "Better understand my retirement",
      category_dispositifs: "Devices & optimization",
      category_demarches: "Procedures",
      category_fiscalite: "Taxation",
      category_outils: "Tools & simulators",
      category_pilotage: "HR steering",
      category_methode: "Method & production",
      kind_article: "Article",
      kind_video: "Video",
      kind_document: "Document",
      kind_link: "Link",
      kind_pdf: "Document",
      audience_salarie: "Employee",
      audience_drh: "HR",
      audience_aon: "Aon",
      featured: "Featured",
      min_suffix: "min",
      viewer_download: "Download",
      viewer_download_ext: "Download ({{ext}})",
      viewer_download_fallback: "the document",
      viewer_open_link: "Open resource",
      viewer_attachment: "Attachment",
      viewer_unavailable_video: "Video unavailable",
      viewer_unavailable_document: "Document unavailable",
      viewer_unavailable_preview: "Preview unavailable. Download the document below.",
      viewer_unavailable_link: "Link unavailable",
    },
    formations_employee: {
      kicker: "My space",
      title: "Retirement training",
      subtitle: "Browse the available training sessions and register directly.",
      no_formations: "No training available",
      no_formations_desc:
        "Retirement training sessions organized for your company will appear here.",
      register: "Register",
      unregister: "Unregister",
      registered: "Registered",
      period_upcoming: "Upcoming",
      period_all: "All",
      period_past: "Past",
      stat_sessions: "Sessions",
      stat_upcoming: "Upcoming",
      stat_enrolled: "My registrations",
      filter_empty: "No session for this filter",
      filter_empty_desc: "Change the period to display more sessions.",
      badge_past: "Past",
      badge_full: "Full",
      participants: "{{count}} registered",
      unenroll_title: "Unregister from this training?",
      unenroll_desc:
        "You will no longer be registered for the \u201c{{title}}\u201d session on {{date}}.",
      unenroll_confirm: "Unregister me",
    },
    formations: {
      channel_presentiel: "In person",
      channel_visio: "Video",
      channel_mixte: "Mixed",
      form: {
        title_edit: "Edit session",
        title_create: "New training session",
        description: "Schedule a retirement training session linked to an operation.",
        title_label: "Title",
        title_placeholder: "Retirement workshop — early departure",
        operation_label: "Operation",
        operation_placeholder: "Select an operation",
        starts_label: "Start",
        ends_label: "End",
        channel_label: "Channel",
        channel_placeholder: "Not specified",
        capacity_label: "Max capacity",
        capacity_placeholder: "Unlimited",
        location_label: "Location",
        location_placeholder: "Room, city, or connection link",
        description_label: "Description",
        description_placeholder: "Program, objectives, speaker…",
        cancel: "Cancel",
        save: "Save",
        create: "Create session",
        error_title_required: "Title is required.",
        error_operation_required: "Select an operation.",
        error_start_required: "Start date is required.",
        error_start_invalid: "Invalid start date.",
        error_end_after_start: "End date must be after start date.",
        error_capacity_invalid: "Capacity must be a positive integer.",
        error_unknown: "An error occurred.",
      },
      manage: {
        title: "Training",
        kicker_aon: "AON Space · Production",
        kicker_admin: "Admin Space · Aon",
        description: "Plan retirement training sessions, manage registrations and attendance.",
        new_session: "New session",
        empty_title: "No training session",
        empty_desc:
          "Create your first retirement training session to start managing registrations.",
        stats_sessions: "Sessions",
        stats_upcoming: "Upcoming",
        stats_inscriptions: "Registrations",
        filter_all: "All sessions",
        filter_upcoming: "Upcoming",
        filter_past: "Past",
        empty_filter_title: "No session for this filter",
        empty_filter_desc: "Change the period to display more sessions.",
        badge_upcoming: "Upcoming",
        badge_past: "Past",
        participants: "Participants",
        present_label: "{{rate}} % present",
        edit_title: "Edit",
        delete_title: "Delete",
        delete_title_dialog: "Delete this session?",
        delete_desc:
          'The session "{{title}}" and its {{count}} registration(s) will be permanently deleted.',
        delete_confirm: "Delete",
      },
      participants: {
        description: "{{count}} registered · {{presents}} present",
        close_add: "Close add",
        add_one: "Add a participant",
        done: "Done",
        loading: "Loading…",
        empty_title: "No participant registered",
        empty_desc: "Add employees to this session to manage attendance.",
        no_match: 'No registered participant matches "{{term}}".',
        range_label: "{{start}}–{{end}} of {{total}} registered",
        range_filtered_suffix: " (filtered on {{filtered}})",
        previous_page: "Previous page",
        next_page: "Next page",
        present: "Present",
        absent: "Absent",
        remove_title: "Remove from session",
        bulk_title: "Enroll the whole operation",
        bulk_available: "{{count}} member(s) not registered",
        bulk_all_enrolled: "All operation members are already registered.",
        bulk_enroll_all: "Enroll all",
        bulk_cancel: "Cancel",
        bulk_confirm: "Confirm ({{count}})",
        bulk_success: "{{count}} employee(s) successfully registered.",
        bulk_none: "No new employee to register.",
        add_search_placeholder: "Search an employee (first name, last name, ID…)",
        list_search_placeholder:
          "Search a registered participant (first name, last name, ID, email…)",
        no_available: "No employee available for this operation.",
        no_search_result: "No result for this search.",
        add_button: "Add",
        unnamed_salarie: "Employee with no name",
        matricule_prefix: "ID {{matricule}}",
        unnamed_fallback: "Employee",
      },
    },
    historique: {
      kicker: "My space",
      title: "My calculation history",
      subtitle:
        "Find all your retirement calculations, from the most recent to the oldest. Click on a calculation to review its estimate and the details per scenario.",
      empty_title: "No calculation yet",
      empty_desc:
        "As soon as you run an estimate or a simulation, each calculation will be archived here with its results. You'll be able to revisit any past calculation.",
      base_estimate: "Base estimate",
      calculated_on: "Calculated on {{date}}",
      badge_simulation: "Simulation",
      badge_parcours: "Journey",
      badge_carriere_longue: "Long career",
      no_result: "No result saved for this calculation.",
    },
    parcours: {
      evaluation_banner: "Give your feedback on the service",
      tranchec: {
        kicker: "Tranche C trade-off",
        title: "Are your Tranche C contributions worth it?",
        lead: "We compared what your Tranche C contributions cost you with the annuity they will generate, then weighed that result against buying back quarters.",
        years: "{{value}} years",
        roi_caption: "of annuity to pay back your contributions",
        ratio_caption: " of annuity received per euro contributed",
        verdict_favorable: "Favourable trade-off",
        verdict_neutre: "Balanced trade-off",
        verdict_defavorable: "Unfavourable trade-off",
        verdict_inconnu: "Trade-off to be completed",
        tile_cout: "Total cost of contributions",
        tile_cout_hint: "over {{years}} contribution years",
        tile_rente: "Annual annuity generated",
        tile_rente_hint: "i.e. {{amount}} per month",
        tile_esperance: "Payout period used",
        tile_age: "Retirement age used",
        age_value: "{{age}} years old",
        compare_title: "Tranche C or buying back quarters?",
        compare_desc:
          "The shorter the bar, the more profitable the lever: it is the time needed to recover what you paid in.",
        compare_tranchec: "Tranche C contributions",
        compare_rachat: "Buying back quarters",
        compare_rachat_empty:
          "No buy-back has been quantified for your situation. Talk to your adviser if you would like to explore it.",
        advisor_note: "Your adviser's comment",
        note: "Estimate based on the parameters selected by your adviser. It is a decision-making aid and does not constitute investment advice.",
        note_with_point:
          "Estimate based on a point service value of €{{value}} and the parameters selected by your adviser. A decision-making aid: it does not constitute investment advice.",
      },
      not_ready_title: "Your file is not ready yet",
      not_ready_body:
        "Your retirement space will be available as soon as your file has been created by your company.",
      gate: {
        kicker: "My space",
        title: "My retirement journey",
        subtitle:
          "Your pension review is prepared in three steps: training first, then your personalized journey.",
        step1_title: "I register for a training session",
        step1_desc: "Choose a retirement training session organized for your company.",
        step2_title: "I attend the training",
        step2_desc: "Your attendance is confirmed by the organizer at the end of the session.",
        step3_title: "I access my retirement journey",
        step3_desc: "Your personalized journey unlocks: information, documents, simulations.",
        step_label: "Step {{index}}",
        badge_done: "Done",
        badge_active: "In progress",
        sessions_title: "Available sessions — register to get started",
        no_sessions:
          "No session is scheduled at the moment. Your company will soon organize retirement training sessions: you'll then be able to register here and unlock your journey.",
        see_all: "View all training sessions",
        enrolled_title: "You're registered — now just attend!",
        enrolled_session:
          "\u201c{{title}}\u201d session on {{date}} at {{time}}{{place}}. Your retirement journey will unlock automatically as soon as your attendance is confirmed by the organizer.",
        enrolled_no_session:
          "Your retirement journey will unlock automatically as soon as your training attendance is confirmed by the organizer.",
        my_formations: "My training",
        rule: "Access to the retirement journey is reserved for employees who have attended a retirement training. This step ensures you have all the keys to make the most of your review.",
        participants: "{{count}} registered",
        register: "Register",
      },
      layout: {
        step_of: "Step {{current}} of {{total}}",
        restart: "Restart",
        restart_title: "Test period: restart the journey from the beginning",
        progress_label: "Progress: step {{current}} of {{total}}",
        help_toggle: "Need help understanding?",
        recap_default: "What we noted",
        back: "Back",
        continue: "Continue",
      },
      runner: {
        step_bienvenue_label: "Welcome",
        step_bienvenue_title: "Welcome to your retirement journey",
        step_confidentialite_label: "Privacy",
        step_confidentialite_title: "Your data privacy choices",
        step_confidentialite_lead: "Choose what you want to share with your company.",
        step_confidentialite_help:
          "The Aon team always has access to your data to prepare your review. These boxes only concern what your employer can see. Some may be required by your company.",
        step_informations_label: "My info",
        step_informations_title: "My information",
        step_informations_lead: "Let's review the information about you together.",
        step_informations_help:
          "Your date of birth determines the age at which you can retire. Make sure it's correct.",
        step_famille_label: "My family",
        step_famille_title: "My family",
        step_famille_lead: "Your spouse and children may grant you additional rights.",
        // B2 : the three explanations faithfully translate the texts fixed on
        // 30/09/2026 (also shown in help bubbles).
        step_famille_help:
          "Having children often increases the number of quarters and the pension amount. Add them for a more accurate estimate.\n\nDisabled child\nIf you raised a child entitled to the disabled child education allowance (AEEH), you may receive an insurance period increase of one quarter per 30 months of education, up to 8 quarters per child. This increase is not automatically included in your estimate: your pension fund reviews it against supporting documents when you apply for retirement.\n\nStillborn child\nA stillborn child may, depending on the case, grant maternity rights. They are not automatically included in your estimate: contact your pension fund, which reviews them against supporting documents.\n\nSharing the quarters\nFor a child born or adopted since 2010, the 4 quarters granted for their education may be split between the parents. If no choice is made within 6 months of their 4th birthday, they are awarded to the mother.",
        step_documents_label: "My documents",
        step_documents_title: "My career statement",
        step_documents_lead:
          "Upload your career statement: we read your career history automatically.",
        step_documents_help:
          "The \u201ccareer statement\u201d (or RIS) is a document sent by the French pension authority. It lists all your jobs. You can download it from info-retraite.fr.",
        step_carriere_label: "My career",
        step_carriere_title: "My career",
        step_carriere_lead: "Here is what we understood from your professional history.",
        step_carriere_help:
          "Each line matches a period when you worked. If a period seems missing, your advisor can correct it with you.",
        step_carriere_help_self:
          "Each line matches a period when you worked. If a period seems missing or wrong, correct it directly: your estimate will take it into account.",
        step_situation_label: "My situation",
        step_situation_title: "My specific situation",
        step_situation_lead: "Some situations grant an earlier departure or a supplement.",
        step_situation_help:
          "For example: hard work, a disability, or having started working very young. Check what applies to you, without worry.",
        step_vip_label: "My plans",
        step_vip_title: "My plans for afterwards",
        step_vip_lead: "What you plan after retiring changes how your scenarios are analysed.",
        step_vip_help:
          "Starting a consulting activity, combining work and pension, or going through unemployment do not have the same effect on your pension. Answer freely: nothing is binding.",
        step_chomage_label: "My unemployment",
        step_chomage_title: "My period of unemployment",
        step_chomage_lead:
          "A period without work before you retire changes how your entitlements are calculated.",
        step_chomage_help:
          "Compensated unemployment periods can validate quarters without any contribution from you. Enter the dates you envisage, even approximate ones: they will be included in your calculations.",
        step_supplementaire_label: "My savings",
        step_supplementaire_title: "My supplementary pension",
        step_supplementaire_lead:
          "Enter your retirement savings plans (PER, savings plan, company schemes…).",
        step_supplementaire_help:
          "These products are not on your career statement: they are unknown to the pension authority. By entering them, they'll appear in the \u201cSupplementary scheme\u201d section of your review.",
        step_supplementaire_epargne_title: "Find your retirement savings contracts",
        step_supplementaire_epargne_loi:
          "French law no. 2021-219 of 26 February 2021 on dormant supplementary retirement contracts strengthens the information provided to savers: retirement savings contracts (PER, \u201carticle 83\u201d contracts, PERCO, Madelin contracts…) can be viewed in your online retirement account, on info-retraite.fr.",
        step_supplementaire_epargne_justif:
          "Documents to upload: for each contract, the latest annual statement (showing your savings on 31 December) or, failing that, a letter from the managing organisation stating the amount of your savings.",
        step_supplementaire_epargne_link_loi: "Read the law on Légifrance",
        step_supplementaire_epargne_link_inforetraite: "Go to info-retraite.fr",
        step_projet_label: "My plan",
        step_projet_title: "My departure plan",
        step_projet_lead: "Tell us when you'd like to leave and what you want to compare.",
        step_projet_help:
          "You can compare several situations: leaving as soon as possible, at legal age, etc. Each choice will give a different estimate.",
        step_resultats_label: "My results",
        step_resultats_title: "My estimate & my simulations",
        step_resultats_lead:
          "Here is your reference estimate. Right below, create and compare as many simulations as you want.",
        step_resultats_help:
          "Your reference estimate only changes if you recalculate it. Each simulation is independent: test a precise departure date, a quarter buyback… without ever changing your reference estimate.",
        tab_estimation: "My estimate",
        tab_simulations: "My simulations",
        tab_analyse: "Noa analysis",
        tab_analyse_salarie: "My analysis",
        tab_document: "My document",
        step_attention_appetences: "Wishes to confirm to access your BRI",
        prev: "Previous",
        next: "Next",
        error_required: "Please complete the required fields before continuing.",
        error_save: "Your progress could not be saved: {{error}}",
        reset_ok: "File reset: all data has been deleted. You can start over from the beginning.",
        reset_failed: "The reset failed: {{error}}",
        reset_title: "Erase everything and start over?",
        reset_desc:
          "This action PERMANENTLY deletes all data in this file: information, family, documents, career, scenarios and results. The journey starts from scratch.",
        reset_confirm: "Erase everything",
        reset_cancel: "Cancel",
      },
      steps: {
        bienvenue_hello: "Hello {{name}} 👋",
        bienvenue_intro:
          "This journey guides you, step by step, to estimate your future retirement. It's all simple: you move at your own pace, and you can stop then resume whenever you want.",
        bienvenue_prepare: "To get off to a good start, prepare if possible:",
        bienvenue_prepare_ris:
          "Your career statement (the \u201cRIS\u201d) in PDF format, if you have it.",
        bienvenue_prepare_family: "The dates of birth of your spouse and children.",
        bienvenue_outro_1:
          "Don't worry if you don't have everything: you can complete it later. Click on",
        bienvenue_outro_continue: " \u201cContinue\u201d",
        bienvenue_outro_2: " to get started.",
        infos_title: "Let's check your identity",
        infos_desc:
          "This information is used to calculate your retirement. Check it and correct if needed. It is saved automatically at each step and synced with your profile; this data is what counts for your estimates.",
        infos_civility: "Title",
        infos_civility_m: "Mr",
        infos_civility_mme: "Mrs",
        infos_first_name: "First name",
        infos_last_name: "Last name",
        infos_birth_date: "Date of birth",
        infos_birth_place: "Place of birth",
        infos_postal_code: "Postal code of your current home",
        infos_postal_placeholder: "e.g. 75015",
        infos_phone: "Phone",
        infos_phone_placeholder: "e.g. 06 12 34 56 78",
        infos_email: "Email",
        infos_email_placeholder: "first.last@company.com",
        infos_min_warning: "Please provide at least your first name, last name and date of birth.",
        err_first_name_required: "First name required.",
        err_last_name_required: "Last name required.",
        err_birth_required: "Date of birth required.",
        err_postal: "5-digit postal code (e.g. 75015).",
        famille_conjoint_title: "Your spouse",
        famille_conjoint_desc: "Do you live as a couple? This can affect your rights.",
        famille_has_conjoint: "I have a partner (married, civil union or cohabiting)",
        famille_union_type: "Type of union",
        famille_union_epoux: "Married",
        famille_union_pacse: "Civil union",
        famille_union_concubin: "Cohabitation / free union",
        famille_conjoint_dob: "Partner's date of birth",
        famille_enfants_title: "Your children",
        famille_enfants_desc: "The number of children can increase your pension (bonus).",
        famille_no_enfant: "You haven't added any children yet.",
        famille_add_enfant: "Add a child",
        famille_enfant_dob: "Child {{index}} — date of birth",
        // B2 (30/09/2026): information only, no effect on the calculation.
        famille_enfant_handicap: "Disabled child",
        famille_enfant_mort_ne: "Stillborn child",
        famille_partage_label: "Sharing the quarters",
        famille_help_handicap:
          "If you raised a child entitled to the disabled child education allowance (AEEH), you may receive an insurance period increase of one quarter per 30 months of education, up to 8 quarters per child. This increase is not automatically included in your estimate: your pension fund reviews it against supporting documents when you apply for retirement.",
        famille_help_mort_ne:
          "A stillborn child may, depending on the case, grant maternity rights. They are not automatically included in your estimate: contact your pension fund, which reviews them against supporting documents.",
        famille_help_partage:
          "For a child born or adopted since 2010, the 4 quarters granted for their education may be split between the parents. If no choice is made within 6 months of their 4th birthday, they are awarded to the mother.",
        famille_recap_couple: "You live as a couple. ",
        famille_recap_single: "You live alone. ",
        famille_recap_children_one: "You declared {{count}} child.",
        famille_recap_children_many: "You declared {{count}} children.",
        docs_ris_title: "Your career statement",
        docs_ris_desc:
          "Upload your career statement (RIS) in PDF format. We automatically read your professional history.",
        docs_ris_choose: "Click to choose your PDF file",
        docs_ris_drop: "or drag it here — one statement at a time (PDF, {{size}} MB max)",
        docs_analyzing: "Analyzing your statement...",
        docs_sending: "Uploading...",
        docs_analyzing_hint:
          'This operation can take up to a minute. The "Continue" button will be unlocked automatically.',
        docs_analyzing_wait: "Analyzing the statement... Please wait before continuing.",
        docs_analyzed: "Statement analyzed: {{count}} career periods identified.",
        docs_default_name: "Document",
        docs_delete_aria: "Delete {{name}}",
        docs_delete_this: "this document",
        docs_delete_title_default: "the document",
        docs_replace_title: "Delete to upload another one",
        docs_delete_impossible: "Cannot delete: {{error}}",
        docs_others_title: "Your other documents",
        docs_others_desc:
          "These items complete your file. The list adapts to your company and your situation.",
        docs_missing_one: "Required document missing: {{labels}}.",
        docs_missing_many: "Required documents missing: {{labels}}.",
        docs_no_extra: "No additional document is requested for your journey.",
        docs_howto: {
          toggle: "Where can I get this document?",
          ris: {
            steps: [
              "Log in to info-retraite.fr with FranceConnect (impots.gouv, Ameli or La Poste).",
              "Open “Ma carrière” then “Mon relevé de carrière”.",
              "Download the individual statement (RIS) as a PDF, with all its pages.",
            ],
            tip: "A statement less than 6 months old gives the most reliable results. Do not upload a screenshot: we need the full PDF.",
          },
          agirc_arrco: {
            steps: [
              "Log in to your personal area on agirc-arrco.fr (or through FranceConnect).",
              "Under “Mes points”, choose “Relevé de points” or “Mon relevé de carrière complémentaire”.",
              "Download the statement as a PDF: it lists your points year by year.",
            ],
            tip: "If you have never created an account, registration is done online with your social security number.",
          },
          bulletin_salaire: {
            steps: [
              "Retrieve your payslip for December of last year.",
              "It is usually available in your digital safe (e.g. Digiposte, MyPeopleDoc) or on the HR intranet.",
              "Otherwise ask your payroll department: a PDF or a legible scan is expected.",
            ],
          },
          retraite_supp: {
            steps: [
              "Gather the annual statements of your supplementary pension plans (PER, article 83, article 39, PERCO…).",
              "They are sent every year by the insurer or plan manager (by post or in your online area).",
              "Upload one statement per plan; the most recent one is enough.",
            ],
            tip: "The “Mes contrats d'épargne retraite” service on info-retraite.fr lists the plans known in your name.",
          },
          justificatif_penibilite: {
            steps: [
              "Log in to compteprofessionnelprevention.fr to view your C2P account.",
              "Download your hardship points statement or the exposure certificate provided by your employer.",
            ],
          },
          justificatif_handicap: {
            steps: [
              "Gather the RQTH notification issued by the MDPH or the disability pension notification from the CPAM.",
              "Upload the document stating the start date and, where applicable, the disability rate.",
            ],
          },
          justificatif_carriere: {
            steps: [
              "For a period abroad: statement or certificate from the pension fund of the country concerned.",
              "For military service: the service record (“état signalétique et des services”), available from the military personnel archives centre.",
              "For any other period: work certificates, contracts or employer attestations.",
            ],
          },
        },
        docs_required: "Required",
        docs_optional: "Optional",
        docs_add: "Add",
        docs_replace: "Replace",
        docs_deposit: "Upload",
        docs_delete_doc_title: "Delete this document?",
        docs_delete_doc_desc:
          "The file {{name}} will be permanently deleted. This action is irreversible.",
        docs_delete: "Delete",
        docs_cancel: "Cancel",
        docs_error: "Error: {{error}}",
        carriere_title: "Your reconstructed career",
        carriere_desc:
          "Here are the work periods we understood from your statement. Check that they look correct.",
        carriere_empty_title: "No period yet",
        carriere_empty_desc:
          "Go back to the previous step to upload and analyze your career statement.",
        carriere_manual_hint:
          "Is a period missing (for example a job abroad that isn't in your statement)? Add, edit or remove it here.",
        carriere_manual_empty_desc:
          "First upload your career statement in the previous step, or add your periods manually (for example a period abroad).",
        carriere_period_default: "Activity period",
        carriere_verified: "Verified",
        carriere_ongoing: "ongoing",
        carriere_convention: "Agreement:",
        carriere_revenus: "Income:",
        carriere_revenus_ignored:
          "not used by the calculation, the yearly detail below takes precedence",
        carriere_evolution: "evolution",
        carriere_source: "Source: {{source}}",
        situation_title: "Your specific situation",
        situation_desc: "Check what applies to you. If nothing applies, simply move on.",
        situation_warn_many:
          "You checked many situations. An advisor will verify their consistency and the impact on your estimate.",
        situation_warn_many_self:
          "You checked many situations. Make sure they really apply to you: they affect your estimate.",
        situation_warn_invalidite:
          "\u201cDisability\u201d and \u201cearly full-rate departure\u201d often fall under different schemes: to be confirmed with your advisor.",
        situation_warn_invalidite_self:
          "Disability and early full-rate departure often fall under different schemes: your estimate remains indicative on this point.",
        cas_penibilite: "I did hard work",
        cas_amiante: "I was exposed to asbestos",
        cas_rqth: "I am recognized as a disabled worker",
        cas_invalidite: "I am on disability",
        cas_arret_long_maladie: "I had a long-term sick leave",
        cas_militaire: "I completed military service",
        cas_expatriation_sans_cfe: "I worked abroad without contributing in France",
        cas_poly_pension: "I have several pension schemes",
        cas_multi_activite: "I had several activities at the same time",
        cas_travail_etudiant: "I worked during my studies",
        cas_carriere_longue: "I started working very young",
        cas_taux_plein_anticipe: "I plan to retire early at the full rate",
        cas_cet: "I have a time savings account",
        // Blocks of the « Your personal situation » step (B1, 30/09/2026).
        situation_block_carriere: "My career",
        situation_block_carriere_help:
          "Situations that may have changed your insurance period or opened the right to early retirement.",
        situation_block_sante: "My health",
        situation_block_sante_help:
          "Health or exposure situations that may grant additional quarters or early retirement.",
        situation_block_autre: "Other",
        situation_block_autre_help: "Schemes that may influence your effective departure date.",
        cet_title: "Your time savings account",
        cet_hint:
          "This helps your consultant combine the end of career (end-of-career leave, monetisation) with the departure date.",
        cet_jours_label: "Saved days",
        cet_avant_depart_label: "I intend to use my CET before leaving",
        cet_avant_depart_hint: "For instance as end-of-career leave.",
        militaire_dates_title: "National service dates",
        militaire_dates_hint:
          "These dates are compared with your career statement to check that they match.",
        militaire_debut: "Start",
        militaire_fin: "End",
        militaire_match: "Matches your career statement.",
        militaire_mismatch:
          "Your statement shows the period from {{debut}} to {{fin}}. An adviser will review this discrepancy.",
        militaire_mismatch_self:
          "Your statement shows the period from {{debut}} to {{fin}}. Check your dates: if the statement is wrong, the correction must be requested from the pension authority.",
        militaire_no_ris:
          "No military period appears in your statement: these dates will help have it added.",
        vip_title: "My plans for afterwards",
        vip_desc:
          "These answers help compare your retirement scenarios and prepare your debriefing.",
        vip_no_work: "I do not want to work once retired",
        vip_no_work_hint: "You wish to stop all professional activity.",
        vip_conseil: "I have a consulting activity to set up",
        vip_conseil_hint: "Setting up a structure for an independent activity.",
        vip_ca: "Expected revenue (€/year)",
        vip_forme: "Legal form",
        vip_forme_sas: "SAS",
        vip_forme_sarl: "SARL",
        vip_remuneration: "Remuneration",
        vip_remu_salaire: "Salary",
        vip_remu_dividendes: "Dividends",
        vip_remu_mixte: "Salary and dividends",
        vip_undecided: "Not decided yet",
        vip_cumul: "I want to combine work and pension",
        vip_cumul_hint: "Continue an activity while receiving your pension.",
        vip_chomage: "A period of unemployment is expected before I retire",
        vip_chomage_hint: "For example after a settlement agreement.",
        vip_chomage_debut: "Unemployment start",
        vip_chomage_fin: "Unemployment end",
        vip_comment: "Additional details (optional)",
        vip_comment_placeholder: "Anything useful for your adviser…",
        vip_note:
          "This information is shared with your Aon adviser, who includes it in the analysis of your scenarios.",
        projet_when_title: "When would you like to retire?",
        projet_when_desc: "Enter a planned departure date (you can change it).",
        projet_date_visee: "Planned departure date (optional)",
        projet_date_eval: "Evaluation date",
        projet_derive_title: "Your salary growth",
        projet_derive_desc: "Assumed annual growth of your pay.",
        projet_derive_label: "Estimated annual salary increase (%)",
        projet_derive_hint: "Until your departure. Suggested value: {{pct}} %",
        projet_compare_title: "What do you want to compare?",
        projet_compare_desc: "Choose one or more situations to simulate.",
        projet_urgence_title: "Urgent file",
        projet_urgence_desc: "An upcoming deadline or a situation that needs a quick answer?",
        projet_urgence_label: "My file is urgent",
        projet_urgence_reason: "Reason",
        projet_urgence_reason_pick: "Choose a reason",
        projet_urgence_reason_required: "Choose a reason to mark your file as urgent.",
        projet_urgence_reason_depart_moins_6_mois: "My departure is planned within 6 months",
        projet_urgence_reason_rupture_licenciement: "A termination or dismissal is in progress",
        projet_urgence_reason_decision_rapide: "I need to make a decision quickly",
        projet_urgence_reason_autre: "Other",
        projet_urgence_comment: "Comment (optional)",
        projet_urgence_comment_ph: "Explain your situation to your adviser…",
        projet_urgence_privacy:
          "Your Aon adviser will handle your file first. Your HR contact only sees that your file is a priority, never the reason or your comment.",
        projet_urgence_auto: "Automatically flagged as a priority (departure soon)",
        projet_urgence_consultant: "Your file has been flagged as a priority by your Aon adviser.",
        resultats_estimation_title: "Your retirement estimate",
        resultats_estimation_desc:
          "Run the calculation to discover your estimate, scenario by scenario.",
        resultats_recalc: "Recalculate",
        resultats_calc: "Calculate my estimate",
        resultats_calc_ok: "Your estimate has been calculated.",
        resultats_empty: "No estimate yet. Run the calculation above.",
        result_per_month_gross: "per month (gross)",
        result_per_month_net: " / month (net)",
        result_depart: "Estimated departure",
        result_depart_age: "{{age}} years old",
        result_taux: "Replacement rate",
        result_trim_valid: "Validated quarters",
        result_trim_cotises: "Contributed quarters",
        result_trim_reputes: "Deemed contributed",
        result_trim_reputes_hint: "approx.",
        result_trim_missing_age: "Quarters missing for the full rate",
        result_penalite_tous_regimes: "Penalty / all schemes",
        result_decote_appliquee: "Applied reduction",
        result_penalite_cnav: "Reduction quarters applied to the basic scheme",
        bubble_trim_missing:
          "Quarters still missing at the retirement date to obtain the full rate.",
        bubble_penalite_cnav:
          "Number of reduction quarters actually applied to the calculation of your basic pension.",
        bubble_decote_base:
          "Basic scheme reduction: 1.25% per missing quarter, capped at 20 quarters (25%), here {{n}} quarters, i.e. {{pct}}%.",
        bubble_decote_base_short:
          "Basic scheme reduction: 1.25% per missing quarter, capped at 20 quarters (25%).",
        result_taux_cnav: "CNAV pension rate",
        result_points_agirc: "Agirc-Arrco points",
        result_show_detail: "Show details",
        result_hide_detail: "Hide details",
        result_estimation: "Estimate",
        result_date_visee: "At the desired date",
        conf_intro_title: "Your data belongs to you",
        conf_intro_body_1:
          "To prepare your review, the Aon team needs access to your information. However, ",
        conf_intro_you_decide: "you decide",
        conf_intro_body_2: " what is shared with your ",
        conf_company: "company",
        conf_rule: "Rule set by your company: {{label}}",
        conf_opt_date_title: "Share my full-rate departure date",
        conf_opt_date_desc:
          "My company will be able to know the date I can retire at the full rate, without any other detail.",
        conf_opt_full_title: "Share my entire pension review (BRI)",
        conf_opt_full_desc:
          "My company will have access to the full support of my pension review (amounts, scenarios, etc.).",
        conf_required: "Required",
        conf_recap_full_1: "You share ",
        conf_recap_full_strong: "your entire review",
        conf_recap_full_2: " with your company.",
        conf_recap_date_1: "You share ",
        conf_recap_date_strong: "only your departure date",
        conf_recap_date_2: " with your company.",
        conf_recap_none_1: "You share ",
        conf_recap_none_strong: "no information",
        conf_recap_none_2: " with your company. Only the Aon team has access.",
        supp_intro_title: "Your retirement savings plans",
        supp_intro_body:
          "Enter here your supplementary retirement products (PER, PERCOL, savings plan, company schemes…) and the estimated net monthly annuity. These amounts do not appear on your career statement: they complete your review.",
        supp_hint:
          "Leave the amount blank if you don't know it yet: your advisor can complete it. You can also add or remove lines according to your contracts.",
        supp_hint_self:
          "Leave the amount blank if you don't know it yet: you can come back to it later. You can also add or remove lines according to your contracts.",
        supp_col_device: "Plan",
        supp_col_rente: "Net annuity / month",
        supp_device_placeholder: "Plan name",
        supp_per_month: "€/month",
        supp_remove_aria: "Remove this line",
        supp_empty: "No plan. Add one if you have retirement savings.",
        supp_add: "Add a plan",
        supp_total: "Estimated total",
        supp_footer_1: "These plans will appear in the ",
        supp_footer_strong: "\u201cSupplementary scheme\u201d",
        supp_footer_2: " section of your review (BRI).",
      },
      simulations: {
        title: "My simulations",
        intro:
          "Create several simulations to compare different situations: retiring on a specific date, buying back quarters… You can edit and recalculate them at any time.",
        create: "Create a simulation",
        empty_title: "No simulation yet",
        empty_desc: "Create your first simulation to test a retirement date or a quarters buyback.",
        comparator_label: "Retirement age comparison",
        comparator_title: "Compare retirement ages",
        comparator_desc:
          "Calculate your 6 standard retirement scenarios at once (62, as soon as possible, legal age, 65, full rate, 67) to see the impact on your pension.",
        comparator_refresh: "Refresh the comparison",
        comparator_run: "Compare my retirement options",
        comparator_hint:
          "Run the comparison to see, scenario by scenario, your pension and the corresponding retirement age.",
        col_scenario: "Retirement scenario",
        col_depart: "Estimated retirement",
        col_brut: "Gross pension / month",
        col_net: "Net pension / month",
        col_vs: "vs estimate",
        col_trim_missing: "Missing quarters",
        best: "Most advantageous",
        age_years: "{{age}} years",
        card_calculated: "Calculated",
        card_to_calculate: "To calculate",
        card_requested_drh: "Requested by your HR",
        card_recalc: "Recalculate",
        card_calc: "Calculate",
        card_edit: "Edit",
        card_delete_aria: "Delete simulation {{label}}",
        card_show_details: "Show detailed results",
        card_hide_details: "Hide detailed results",
        card_no_result: "No results recorded. Run the calculation above.",
        card_no_params:
          "This simulation has no parameters: the calculation will use the full-rate retirement.",
        card_calculated_notice: "The simulation \u201c{{label}}\u201d has been calculated.",
        delete_title: "Delete this simulation?",
        delete_desc:
          "The simulation \u201c{{label}}\u201d and its results history will be detached. This action is permanent.",
        delete_confirm: "Delete",
        result_per_month_gross: "per month (gross)",
        result_per_month_net: " / month (net)",
        result_depart: "Estimated retirement",
        result_age: "{{age}} years",
        result_trim_valid: "Validated quarters",
        result_trim_missing_age: "Quarters missing for the full rate",
        result_penalite_tous_regimes: "Penalty / all schemes",
        result_decote_appliquee: "Applied reduction",
        result_penalite_cnav: "Reduction quarters applied to the basic scheme",
        result_taux_cnav: "CNAV pension rate",
        result_rachat: "Buyback",
        result_rachat_value: "Included",
        comp_identical: "Same as your estimate",
        comp_delta: "{{sign}}{{amount}} / month",
        comp_vs_base: "vs base estimate",
        comp_vs_base_pct: "{{sign}}{{pct}} % vs base estimate ({{kind}})",
        comp_net: "net",
        bubble_decote_base:
          "Basic scheme reduction: 1.25% per missing quarter, capped at 20 quarters (25%), here {{n}} quarters, i.e. {{pct}}%.",
        comp_delta_hint:
          "Difference between this simulation and your reference estimate, in monthly net pension (reference {{ref}}, simulation {{sim}}).",
        delta_hint:
          "Difference between this simulation and your reference estimate, in monthly net pension (reference {{ref}}, simulation {{sim}}).",
        bubble_trim_missing:
          "Quarters still missing at the retirement date to obtain the full rate.",
        bubble_penalite_cnav:
          "Number of reduction quarters actually applied to the calculation of your basic pension.",
        comp_brut: "gross",
        resume_title: "In summary",
        resume_cl_yes:
          "You could benefit from the \u201clong career\u201d scheme (early retirement possible).",
        resume_cl_no: "The \u201clong career\u201d scheme does not apply in this simulation.",
        resume_missing_one:
          "You are still {{count}} quarter short of the full rate in the best case.",
        resume_missing_other:
          "You are still {{count}} quarters short of the full rate in the best case.",
        resume_missing_none: "You have all the quarters required for the full rate.",
        resume_rachat_one:
          "This simulation includes the buyback of {{count}} quarter ({{effect}}). The estimated cost and profitability are shown above.",
        resume_rachat_other:
          "This simulation includes the buyback of {{count}} quarters ({{effect}}). The estimated cost and profitability are shown above.",
        resume_effect_opt1: "improves your rate only",
        resume_effect_opt2: "improves your rate and your insurance duration",
        table_title: "Compare my simulations",
        table_desc:
          "Each simulation is compared to your base estimate (highlighted). Your advisor will help you choose the most suitable option.",
        table_desc_self:
          "Each simulation is compared to your base estimate (highlighted). Compare the options freely to find the one that suits you.",
        table_col_simulation: "Simulation",
        table_base_row: "Base estimate",
        table_ref: "reference",
        form_title_edit: "Edit the simulation",
        form_title_new: "New simulation",
        form_desc: "Choose what you want to test. You can change everything later.",
        form_create: "Create the simulation",
        form_name: "Simulation name",
        form_name_placeholder: "E.g. Retirement in June 2030 with buyback",
        form_err_name: "Give your simulation a name (e.g. \u201cRetirement in June 2030\u201d).",
        form_err_params:
          "Choose at least one situation, one retirement date or a quarters buyback.",
        form_scenarios_legend: "Which situations do you want to compare?",
        form_scenarios_hint: "Check one or more situations. Each one will produce an estimate.",
        form_dates_legend: "Test one or more specific retirement dates?",
        form_dates_hint:
          "For example a date suggested by your employer or a date that matters to you.",
        form_dates_hint_max:
          "For example a date suggested by your employer. Latest allowed date: {{date}}.",
        form_err_max_date:
          "The retirement date cannot go beyond {{date}} at your company. Ask your adviser for a specific date.",
        form_err_max_date_self:
          "The retirement date cannot go beyond {{date}} at your company. You can request that a specific date be unlocked.",
        limit_hint_date: "Your company limits simulations to retirement dates up to {{date}}.",
        limit_hint_tpn: "Your company limits simulations to retirement at the natural full rate.",
        limit_request_cta: "Request a specific date",
        limit_request_title: "Request a specific retirement date",
        limit_request_desc:
          "Your Aon adviser receives the request and can unlock free date entry on your file.",
        limit_request_desc_self:
          "Your HR department receives the request and can unlock free date entry on your file.",
        limit_request_sent_self: "Request sent to your HR department.",
        limit_request_pending_self: "Request sent on {{date}}, awaiting your HR department.",
        limit_request_message: "Your message (optional)",
        limit_request_placeholder: "E.g. my employer offers me a departure on 30/06/2032.",
        limit_request_send: "Send request",
        limit_request_sent: "Request sent to your Aon adviser.",
        limit_request_pending: "Request sent on {{date}}, awaiting your adviser.",
        form_remove_date: "Remove this date",
        form_add_date: "Add a retirement date",
        form_rachat_title: "Simulate a quarters buyback",
        form_rachat_desc:
          "A buyback lets you \u201cbuy back\u201d missing quarters (study years, incomplete periods) to retire earlier or increase your pension.",
        form_rachat_nb: "How many quarters to buy back? (1 to 12)",
        form_rachat_type: "Which type of buyback?",
        form_opt1_title: "Improve my rate",
        form_opt1_desc: "Reduces the discount: your pension is calculated at a better rate.",
        form_opt2_title: "Improve my rate and my duration",
        form_opt2_desc: "Also counts towards the insurance duration: stronger effect, higher cost.",
        preview_unavailable:
          "Cost unavailable (CNAV scale not configured for your situation). Your advisor will specify it.",
        preview_cost_one: "Estimated cost ({{count}} quarter)",
        preview_cost_other: "Estimated cost ({{count}} quarters)",
        desc_scenarios_one: "{{count}} situation compared",
        desc_scenarios_other: "{{count}} situations compared",
        desc_dates_one: "{{count}} retirement date tested",
        desc_dates_other: "{{count}} retirement dates tested",
        desc_rachat_one: "buyback of {{count}} quarter",
        desc_rachat_other: "buyback of {{count}} quarters",
        desc_none: "No parameters (full-rate retirement by default)",
      },
      breakdown: {
        composition: "Composition of your pension (gross)",
        etage_base: "Basic scheme",
        etage_compl: "Complementary",
        etage_suppl: "Supplementary",
        reversion_label: "Estimated survivor's pension (spouse)",
        reversion_hint: "Pension that could be paid to your spouse.",
        baisse_label: "Income drop at retirement",
        baisse_hint: "Gap between your end-of-career income and your pension.",
        per_month: "{{amount}} / month",
        per_month_minus: "− {{amount}} / month",
        regimes_detail: "Breakdown by pension fund ({{n}})",
        caisse_fallback: "Fund",
        mini_points: "Points",
        mini_point_value: "Point value",
        mini_trim: "Validated quarters",
        mini_trim_cotises: "Contributed quarters",
        mini_trim_reputes: "Deemed contributed",
        mini_ram: "Average annual income",
        mini_majoration: "Children bonus",
        regime_base: "Basic",
        regime_compl: "Complementary",
        regime_suppl: "Supplementary",
        surcote: "Increase",
        decote: "Discount",
        surcote_title: "Increase for retiring after the full rate",
        decote_title: "Reduction for early retirement",
        bubble_decote_base:
          "Basic scheme reduction: 1.25% per missing quarter, capped at 20 quarters (25%), here {{n}} quarters, i.e. {{pct}}%.",
        bubble_decote_base_short:
          "Basic scheme reduction: 1.25% per missing quarter, capped at 20 quarters (25%).",
        bubble_decote_agirc:
          "Agirc-Arrco anticipation coefficient: a reduction applied when you retire before reaching the full rate, based on the number of missing quarters, here a coefficient of {{coeff}}.",
        bubble_surcote:
          "Surcharge: 1.25% per additional quarter beyond the full rate and the legal age, here +{{pct}}%.",
      },
      progressive: {
        title: "Progressive retirement",
        desc: "Work part-time at the end of your career while receiving part of your pension. Pick a working time ratio to preview your income.",
        ineligible:
          "You are not eligible for progressive retirement: {{trimestres}} validated quarters at entry date, while {{min}} are required.",
        non_estime:
          "Amount not estimated: the calculation engine does not model phased retirement before the legal age. To be confirmed with your pension scheme.",
        trim_unknown: "an insufficient number of",
        date_debut: "Possible entry from",
        date_fin: "Estimated final retirement",
        quotite_label: "Part-time working ratio",
        salaire_partiel: "Part-time salary ({{pct}}%)",
        pension_base: "Basic pension ({{pct}}%)",
        pension_compl: "Supplementary ({{pct}}%)",
        total: "Total monthly income",
        note_net:
          "Estimated net amounts: the part-time salary is approximated from your gross income (about 78%).",
        detail_title: "Calculation method — Agirc-Arrco supplementary pension",
        detail_points: "Points earned at entry",
        detail_vp: "Point value",
        detail_coeff: "Agirc-Arrco coefficient",
        detail_minoration: "{{pct}}% reduction",
        detail_majoration: "{{pct}}% increase",
        detail_taux_plein: "full rate",
        detail_formula:
          "Supplementary pension at entry = points × point value × coefficient; the fraction paid is prorated by (100% − working time).",
        detail_unverified:
          "A discrepancy was found between this recalculation and the calculation engine's amount: the engine's amount is kept.",
      },
      pdf: {
        title: "Your simulation as a PDF",
        desc: "Download the full summary of your retirement simulation (situation, rights, career, points of attention and parameters).",
        download: "Download my simulation",
        failed: "The document generation failed.",
      },
      charts: {
        title: "Comparison of your scenarios",
        desc: "Monthly pension (gross and net) per scenario, replacement rate curve, and your current income as a reference.",
        serie_brut: "Gross pension",
        serie_net: "Net pension",
        serie_taux: "Replacement rate",
        axis_month: "€ / month",
        axis_taux: "Rate",
        current_income: "Current income: {{amount}}",
        estimation: "Estimate",
        date_visee: "At the desired date",
      },
      audit: {
        title: "Reliability of your statement",
        desc: "We analyse your career to spot possible omissions or inconsistencies before the calculation.",
        run: "Check my career",
        rerun: "Run the check again",
        failed: "The check failed.",
        hint: "Run the check to automatically detect points to fix (missing periods, zero income, unusual drops…).",
        clean: "No anomaly detected: your statement looks consistent.",
        points_one: "{{count}} point to check. Your advisor can help you fix it.",
        points_other: "{{count}} points to check. Your advisor can help you fix them.",
        action_add: "To add",
        action_modify: "To edit",
        occurrences_one: "{{count}} occurrence",
        occurrences_other: "{{count}} occurrences",
        fallback: "Point to check",
        code_serviceMilitaire: "Missing military service",
        code_avpfSansEnfant: "AVPF period without a child",
        code_indiceFonct: "Missing end-of-career index",
        code_revenuNul: "Zero income over a period",
        code_jeuneParent: "Unusual parent / child age gap",
        code_baisseRevenu: "Significant income drop",
        code_tauxActivite: "Activity rate to check",
        code_periodeJour: "One-day period",
        code_periodeSansInformation: "Period without information",
        code_periodeAnnuelleSansInformation: "Year without information",
        fiche_toggle: "Understand and fix",
        fiche_explication: "Explanation",
        fiche_recommandation: "Recommended action",
        fiche_pieces: "Documents to gather",
      },
      revenus: {
        title: "Evolution of your income",
        desc: "Reconstruction of your professional income, year by year, until your retirement. Annual amounts expressed in euros.",
        run: "Project my income",
        rerun: "Recalculate",
        failed: "The calculation failed.",
        hint: "Run the projection to see how your professional income evolves over your career.",
        empty: "No usable income could be projected from your statement.",
        serie_percu: "Annual income received",
        serie_projete: "Annual income projected",
      },
      points: {
        title: "Your Agirc-Arrco points",
        desc: "Supplementary pension points earned each year, from your career statement.",
        points_unit: "points",
        drop_tooltip: "−{{pct}}% vs {{prev}} pts the previous year",
        table_year: "Year",
        table_points: "Points earned",
        table_diff: "Change (points)",
        table_diff_pct: "Change (%)",
        table_flag: "Finding",
        table_drop: "Marked drop",
        table_expand: "Show the previous {{count}} years",
        table_collapse: "Collapse the table",
        drop_legend:
          "A drop in points can reflect a period of unemployment, part-time work or missing data on your statement. Your adviser checks it with you.",
      },
      rachatPanel: {
        unavailable_title: "Buyback cost unavailable",
        unavailable_desc:
          "The CNAV scale is not yet configured for your situation (age / income bracket). The exact cost will be provided by your Aon advisor.",
        title: "Cost and profitability of the buyback",
        subtitle_one: "Estimate for {{count}} quarter · option \u201c{{option}}\u201d",
        subtitle_other: "Estimate for {{count}} quarters · option \u201c{{option}}\u201d",
        option_taux_duree: "Rate + insurance duration",
        option_taux_seul: "Rate only",
        cost: "Estimated cost",
        cost_hint: "{{amount}} / quarter",
        gain: "Estimated gain",
        gain_value: "+{{amount}} / month",
        gain_hint_year: "{{amount}} / year",
        gain_hint_base: "vs base estimate",
        amort: "Paid back in",
        amort_year: "{{years}} year",
        amort_years: "{{years}} years",
        amort_hint_yes: "then net gain",
        amort_hint_no: "gain not determined",
        other_option: "Other option \u201c{{option}}\u201d:",
        tax_note_1: "Amount ",
        tax_note_strong: "deductible from your taxable income",
        tax_note_2:
          ": the real after-tax cost is lower (depending on your marginal tax bracket). Indicative estimate based on the CNAV scale{{year}}; your Aon advisor will refine the calculation.",
        c2_desc:
          "You do not need to buy back quarters: you will reach the full rate at the legal retirement age.",
      },
      rachatTauxPlein: {
        option_taux_seul: "rate only",
        option_taux_duree: "rate and duration",
        title: "Quarters buyback for the full rate",
        subtitle_one:
          "{{count}} quarter bought back for retirement at the legal age ({{option}} option)",
        subtitle_other:
          "{{count}} quarters bought back for retirement at the legal age ({{option}} option)",
        plafond: "(legal cap of 12 quarters reached)",
        sans_rachat: "Without buyback",
        avec_rachat: "With buyback",
        per_month: "net pension / month at the legal age",
        cout: "Estimated cost",
        cout_hint: "{{option}} option, indicative scale",
        roi: "Payback period",
        roi_years: "{{years}} years",
        gain_hint: "gain of {{amount}} / month",
        taux_plein_ok:
          "The full rate is reached at the retirement date thanks to the bought-back quarters.",
        taux_plein_ko:
          "The bought-back quarters bring you closer to the full rate without reaching it at that date.",
        caution:
          "The years that can actually be bought back (studies, incomplete years) must be confirmed with your pension fund.",
        c2_title: "No buyback needed",
        c2_desc:
          "You do not need to buy back quarters: you will reach the full rate at the legal retirement age.",
      },
    },
    placeholder: {
      coming_soon: "This feature is coming soon.",
    },
  },
  admin: {
    referentiels: {
      kicker: "Administration",
      title: "Reference data freshness",
      description:
        "Last update date of each internal reference dataset (buy-back scale and PASS, catalogues, checklists, libraries), with an alert beyond the expected delay.",
      table_title: "Internal reference data",
      ref_rachat_bareme: "Quarter buy-back scale (active vintage)",
      ref_document_types: "Document types",
      ref_controle_checklist: "N1 / N2 self-check grid",
      ref_bri_annexes: "BRI annexes",
      ref_email_templates: "Email templates",
      ref_content_library: "Content library",
      ref_anomalie_types: "Anomaly library",
      ref_points_attention: "Attention points library",
      ref_conventions_collectives: "Collective agreements (IDCC)",
      updated_on: "Last update: {{date}}",
      never_updated: "Never filled in",
      badge_ok: "Up to date",
      badge_stale: "To check ({{days}} d)",
      badge_empty: "Empty",
      engine_note:
        "The pension calculation engine is operated by its editor, which does not expose usable version information: its update date is intentionally not tracked here.",
    },
    refprof: {
      kicker: "Administration",
      title: "Professions and schemes reference",
      description:
        "Mapping between the professions handled by the calculation engine and their pension schemes (base, complementary, supplementary). It is inferred from engine calculations, then manually correctable: your corrections are kept on every regeneration.",
      actions_title: "Automatic feeding",
      refresh: "Refresh the list",
      generate: "Generate the reference ({{count}} calls)",
      last_refresh: "Profession list updated on {{date}}",
      never_refreshed: 'Profession list never refreshed: run "Refresh the list" first.',
      refreshed: "{{count}} professions fetched from the engine.",
      generated: "Reference generated for {{count}} professions out of {{total}} in {{seconds}} s",
      failures: "professions without result: {{codes}}",
      list_title: "Professions and schemes",
      search: "Search a profession…",
      empty: 'No profession: run "Refresh the list" to load the reference from the engine.',
      sans_famille: "No family",
      no_regime: "No scheme recorded for this profession.",
      add_regime: "Add a scheme",
      new_code: "Scheme code",
      new_libelle: "Label",
      rename: "Rename",
      hide: "Hide",
      show: "Show again",
      badge_auto: "auto",
      badge_manuel: "manual",
      badge_masque: "hidden",
      classif_base: "base scheme",
      classif_complementaire: "complementary",
      classif_supplementaire: "supplementary",
    },
    conv: {
      kicker: "Administration",
      title: "Collective agreements",
      description:
        "Collective agreement reference list (IDCC codes), loaded from the official DILA list and extendable via Excel/CSV import or manual entry. Stored for pension-protection purposes: it has no effect on the pension calculation.",
      list_title: "Reference list",
      search_title: "Agreements",
      search: "Search by label or IDCC…",
      import: "Import (Excel/CSV)",
      import_empty: "No valid row in the file.",
      imported: "Import complete: {{added}} added, {{modified}} updated out of {{total}} rows.",
      duplicates: "{{count}} duplicate IDCC ignored",
      add: "Add",
      new_idcc: "IDCC",
      new_libelle: "Label",
      rename: "Rename",
      activate: "Reactivate",
      deactivate: "Deactivate",
      active: "active",
      inactive: "inactive",
      source_dila: "DILA",
      source_import: "import",
      source_manuel: "manual",
      count: "{{total}} agreements, {{active}} active",
      empty: "No agreement matches the search.",
      col_idcc: "IDCC",
      col_label: "Label",
      col_status: "Status",
      col_actions: "Actions",
      sort_by: "Sort by {{column}}",
      unit: "agreements",
    },
    dashboard: {
      kicker: "Administration",
      title: "Aon admin console",
      description: "Platform overview: clients, operations, users.",
      overview: "Overview",
      quick_links: "Quick links",
      open: "Open",
      guided_start: "Guided start",
      onboard_title: "Onboard a new company",
      onboard_desc:
        "A step-by-step wizard: company, BRI campaign, then first invited employees. The easiest way to get everything set up.",
      launch_wizard: "Launch wizard",
      stat_groups: "Client groups",
      stat_societes: "Companies",
      stat_operations: "Active operations",
      stat_dossiers: "Active files",
      hint_salaries_total: "{{count}} employees total",
      hint_operations_total: "{{count}} total (all statuses)",
      hint_dossiers_production: "{{count}} in production",
      stat_urgents: "Urgent files in progress",
      hint_urgents: "Not debriefed, flagged as priority",
      stat_urgence_delai: "Average debrief lead time",
      stat_urgence_delai_suffix: "working days",
      hint_urgence_delai: "Across {{count}} file(s) debriefed in the last 90 days",
      link_tenants_title: "Groups & companies",
      link_tenants_desc: "Create / edit clients, manage hierarchy.",
      link_operations_title: "BRI operations",
      link_operations_desc: "Launch a new campaign, manage ongoing ones.",
      link_users_title: "Users & roles",
      link_users_desc: "Invite, assign roles and scopes.",
      link_branding_title: "Branding",
      link_branding_desc: "Logos, colours and labels per company.",
    },
    tenants: {
      kicker: "Administration",
      title: "Groups, companies & subsidiaries",
      description:
        "Client hierarchy: groups → companies → subsidiaries (BU & sites). BRI operations are managed separately.",
      add_groupe: "New group",
      add_societe: "New company",
      search_placeholder: "Search for a group, company or SIREN…",
      empty_title: "No clients yet",
      empty_description: "Create your first client group or company to get started.",
      empty_action: "Create a group",
      slug_label: "slug",
      inactive: "Inactive",
      confidential_badge: "Confidential",
      confidential_hint:
        "Personal data of this company's employees is only visible to super-admins and authorized internal Aon users.",
      societe_button: "Company",
      emails_button: "Emails",
      emails_title: "Group email template library",
      edit: "Edit",
      delete: "Delete",
      no_societes_in_group: "No company attached to this group.",
      independent_societes: "Independent companies",
      independent_description: "{{count}} company(ies) without a parent group.",
      societes_count: "{{count}} company(ies)",
      page: "Page {{page}} of {{total}}",
      previous: "Previous",
      next: "Next",
      drh_label: "HR",
      group_delete_title: "Delete group « {{name}} » ?",
      group_delete_description: "Attached companies will remain but be detached from the group.",
      group_delete_confirm: "Delete group",
      societe_delete_title: "Delete company « {{name}} » ?",
      societe_delete_description:
        "All operations and employees associated with this company will also be deleted.",
      irreversible: "This action is irreversible.",
      societe_delete_confirm: "Delete permanently",
      logo_alt: "{{name}} logo",
      subsidiaries: "Subsidiaries",
      add_filiale: "New subsidiary",
      no_filiales: "No subsidiary attached to this company.",
      siren: "SIREN",
      siret: "SIRET",
      bu: "BU",
      sites_count: "{{count}} site(s)",
      filiale_delete_title: "Delete subsidiary « {{name}} » ?",
      filiale_delete_description:
        "{{business_units_count}} BU · {{sites_count}} site(s) will also be deleted.",
      filiale_delete_confirm: "Delete permanently",
    },
    tenantForms: {
      cancel: "Cancel",
      save: "Save",
      groupe: {
        new_title: "New group",
        edit_title: "Edit group « {{name}} »",
        new_description:
          "A group is the root entity of a client (e.g. TotalEnergies, BNP Paribas).",
        edit_description: "Edit client group information.",
        create: "Create group",
        siren_prefill_label: "Pre-fill by SIREN",
        siren_prefill_hint: "Enter the group SIREN to automatically retrieve name and description.",
        siren_label: "SIREN",
        siren_hint: "9 digits. Filled automatically by the search above.",
        siren_error: "SIREN must contain 9 digits",
        nom_label: "Group name",
        nom_error: "Name must be at least 2 characters",
        slug_label: "URL identifier (slug)",
        slug_error: "Slug can only contain lowercase letters, numbers and hyphens",
        slug_hint: "Used for URLs and exports. Editable but should be avoided once in production.",
        description_label: "Description",
        description_placeholder: "Activity, scope, context…",
        logo_label: "Group logo",
        logo_hint:
          "The logo will be displayed in the client space header (recommended formats: SVG, transparent PNG).",
        logo_url_error: "Invalid URL",
        active_label: "Active group",
        active_description: "Disable to hide this group without deleting it.",
        bri_title: "BRI settings",
        bri_description: "BRI support configuration requested by the client at group level.",
        simulations_label: "Requested simulations",
        simulations_autres_label: "Other simulations",
        simulations_autres_placeholder: "E.g. expatriation simulation, early retirement…",
        simulations_autres_hint: "Additional simulations not listed above.",
        simulation_temps_partiel: "Part-time",
        simulation_retraite_progressive: "Progressive retirement",
        simulation_rachat_trimestres: "Quarter buy-back",
        simulation_cumul_emploi_retraite: "Work-retirement cumulation",
        simulation_carriere_longue: "Long career",
        annexes_label: "Standard BRI appendices",
        annexes_hint: "Library sheets making up the validated BRI support.",
        annexes_empty: "No active sheet in the library. Create some in « BRI Appendices ».",
        annexes_precision_label: "Appendix details",
        annexes_precision_placeholder:
          "Specific appendices, special mentions requested by the client…",
        diffusion_label: "Sharing authorization",
        diffusion_hint: "Defines the sharing of BRI information between employee and company.",
        diffusion_souhait_salarie_label: "Employee's choice",
        diffusion_souhait_salarie_description:
          "The employee freely chooses the information shared with the company.",
        diffusion_accord_partiel_label: "Mandatory agreement — partial",
        diffusion_accord_partiel_description:
          "Mandatory sharing of the natural full-rate date with the company.",
        diffusion_accord_total_label: "Mandatory agreement — full",
        diffusion_accord_total_description:
          "Mandatory sharing of the full BRI support with the company.",
      },
      societe: {
        new_title: "New client company",
        edit_title: "Edit « {{name}} »",
        new_description:
          "A company is the client's legal entity (SIREN/SIRET). Main tenant for BRI operations.",
        edit_description: "Edit legal and contact information.",
        create: "Create company",
        siren_prefill_hint:
          "Enter the company SIREN to pre-fill name, legal name, SIRET, NAF code and head office address.",
        section_identification: "Identification",
        groupe_parent_label: "Parent group",
        option_no_groupe: "None (independent company)",
        nom_commercial_label: "Commercial name",
        nom_error: "Name must be at least 2 characters",
        slug_label: "Slug",
        slug_error: "Slug can only contain lowercase letters, numbers and hyphens",
        raison_sociale_label: "Legal name",
        raison_sociale_placeholder: "TotalEnergies SA",
        siren_label: "SIREN",
        siren_error: "SIREN must contain 9 digits",
        siret_label: "Head office SIRET",
        siret_error: "SIRET must contain 14 digits",
        code_naf_label: "NAF code",
        section_adresse: "Head office address",
        adresse_label: "Street",
        code_postal_label: "Postal code",
        ville_label: "City",
        pays_label: "Country",
        section_contact_drh: "HR contact",
        drh_nom_label: "Name",
        drh_email_label: "Email",
        email_error: "Invalid email",
        drh_phone_label: "Phone",
        section_accords_seniors: "Senior agreements",
        accords_seniors_description:
          "Applicable senior schemes (part-time senior, progressive retirement, end-of-career arrangements, severance…). This content is sent to the AI to personalize the retirement review.",
        accord_branche_label: "Branch agreement",
        accord_branche_placeholder: "Collective agreement / branch provisions relating to seniors…",
        accord_entreprise_label: "Company agreement",
        accord_entreprise_placeholder:
          "Provisions negotiated within the company relating to seniors…",
        active_label: "Active company",
        active_description: "Disable to hide this company without deleting it.",
        confidential_label: "Confidential company",
        confidential_description:
          "Hides employees' personal data from unauthorized internal Aon users. The company, its operations and settings remain visible.",
        confidential_readonly: "Confidential company: only a super-admin can change this setting.",
        confidential_access_title: "Confidential access",
        confidential_access_hint:
          "Internal Aon users allowed to view employees' personal data for this company (super-admins always have access).",
        confidential_access_empty: "No authorized internal users yet.",
        confidential_access_add_label: "Add an internal Aon user",
        confidential_access_add_placeholder: "Choose an internal user…",
        confidential_access_add: "Authorize",
        confidential_access_remove: "Revoke this access",
        confidential_access_readonly:
          "The confidential access list is only visible to super-admins.",
      },
      filiale: {
        new_title: "New subsidiary",
        edit_title: "Edit subsidiary « {{name}} »",
        description_with_parent: "Attached to company {{societe}}.",
        description_without_parent:
          "A subsidiary is a legal entity attached to a company in the group.",
        create: "Create subsidiary",
        finish: "Finish",
        tab_identification: "Identification",
        tab_parametrage: "Settings",
        siren_mismatch_title: "SIREN different from parent company",
        siren_mismatch_message:
          "The provided SIRET belongs to SIREN {{siren}}, different from the parent company ({{societe_siren}}).",
        siret_prefill_hint: "Enter the subsidiary SIRET to pre-fill name and address.",
        section_identification: "Identification",
        nom_label: "Subsidiary name",
        nom_error: "Name must be at least 2 characters",
        slug_label: "Slug",
        slug_error: "Slug can only contain lowercase letters, numbers and hyphens",
        siret_label: "SIRET",
        siret_hint: "14 digits. Optional — filled automatically by the search above.",
        siret_error: "SIRET must contain 14 digits",
        section_adresse: "Address",
        adresse_label: "Address",
        code_postal_label: "Postal code",
        ville_label: "City",
        pays_label: "Country",
        active_label: "Active subsidiary",
        active_description: "Disable to hide this subsidiary without deleting it.",
        info_create_parametrage:
          "You will be able to add Business Units and geographic sites in the Settings tab once the subsidiary has been created.",
        business_units_title: "Business Units",
        bu_empty: "No Business Unit yet.",
        bu_add_label: "Add a Business Unit",
        bu_add_button: "Add",
        bu_delete_confirm: "Delete Business Unit « {{name}} » ?",
        bu_delete_confirm_description: "Attached sites and employees will be detached.",
        bu_delete_button: "Delete",
        bu_edit_name_label: "Name",
        bu_edit_slug_hint: "Current slug: {{slug}} (not editable)",
        bu_edit_active_label: "Active Business Unit",
        sites_title: "Geographic sites",
        sites_empty: "No site yet.",
        site_add_title: "Add a site",
        site_nom_label: "Site name",
        site_adresse_label: "Street",
        site_cp_label: "Postal code",
        site_ville_label: "City",
        site_add_button: "Add site",
        site_delete_confirm: "Delete site « {{name}} » ?",
        site_delete_confirm_description: "This action is irreversible.",
        site_delete_button: "Delete",
        site_edit_nom_label: "Site name",
        site_edit_adresse_label: "Street",
        site_edit_cp_label: "Postal code",
        site_edit_ville_label: "City",
        site_edit_active_label: "Active site",
        site_edit_slug_hint: "Current slug: {{slug}} (not editable)",
        site_no_address: "No address",
        inactive_badge: "Inactive",
        edit_button_aria: "Edit",
        delete_button_aria: "Delete",
      },
    },
    users: {
      kicker: "Administration",
      title: "Users & access",
      description: "Functional roles and access scopes by company and operation.",
      tab_active: "Users",
      tab_invitations: "Invitations",
      invite: "Invite a user",
      edit_access: "Edit access",
      resend: "Resend",
      resend_title: "Resend invitation email",
      revoke: "Revoke",
      revoke_edit: "Edit",
      resend_success: "Email resent to {{recipient}}.",
      resend_error: "Error while sending",
      revoke_success: "Invitation revoked.",
      revoke_confirm: "Revoke this invitation?",
      no_users: "No users",
      no_users_desc:
        "Invite a user from the Invitations tab: they will receive an activation email to join the platform.",
      no_invitations: "No pending invitations",
      no_invitations_desc: "All invitations have been accepted or none have been created yet.",
      search_placeholder: "Name, email, role…",
      last_login: "Last login",
      never_logged_in: "Never logged in",
      role: "Role",
      scope: "Scope",
      invited_at: "Invited on",
      invited_by: "Invited by",
      invitation_sent: "Invitation sent to {{recipient}}.",
      invitation_pending_count_one: "{{count}} pending invitation",
      invitation_pending_count_other: "{{count}} pending invitations",
      badge_disabled: "Disabled",
      badge_expired: "Expired",
      badge_expired_hint:
        "Invitation expired: click Resend to extend it by 30 days and send the email again.",
      apply_error_label: "Account activation failed:",
      societies_count_one: "{{count}} company",
      societies_count_other: "{{count}} companies",
      operations_count_one: "{{count}} operation",
      operations_count_other: "{{count}} operations",
      region_scope: "Region: {{region}}",
      close: "Close",
      // InviteUserDrawer
      invite_drawer_title_new: "Invite a user",
      invite_drawer_title_edit: "Invite {{email}}",
      invite_drawer_desc_new:
        "The activation email is sent immediately to the recipient. On first login, their roles and scopes will be applied automatically.",
      invite_drawer_desc_edit:
        "Update the invitation and resend an activation email to the recipient.",
      invite_info:
        "An invitation email containing an activation link will be sent immediately to the recipient after creation.",
      section_contact: "Contact details",
      field_email: "Email",
      field_email_placeholder: "firstname.lastname@company.com",
      field_prenom: "First name (optional)",
      field_nom: "Last name (optional)",
      field_note: "Internal note (optional)",
      field_note_placeholder: "Context, team, etc.",
      section_roles: "Roles to assign",
      roles_required: "Select at least one role to create the invitation.",
      roles_rules:
        "Employees are not invited here: create an employee record instead. A single account cannot combine HR and Aon team roles.",
      roles_exclusive_hint: "Incompatible with the roles already selected (HR ↔ Aon team).",
      salarie_conflict_title: "This email belongs to an employee",
      salarie_conflict_desc:
        "The address {{email}} belongs to employee {{name}} (ID {{matricule}}). An employee cannot receive an Aon team account: use another address or remove this email from their record first. HR access, however, can be granted on this address.",
      section_options: "Options",
      option_create_salarie_label: "Allow manual creation of an employee account",
      option_create_salarie_desc:
        "Allows this user to create employee accounts themselves within their scope.",
      section_scope: "Access scope",
      scope_hint:
        "Checking a level grants access to everything it contains: a company covers its subsidiaries, BUs, sites and operations; a subsidiary alone restricts access to that subsidiary.",
      global_access_title: "Automatic global access",
      global_access_desc:
        "The Aon Administrator role automatically grants access to all groups, companies, subsidiaries, BUs, sites and operations. No scope to check.",
      cancel: "Cancel",
      submit_new: "Create & send email",
      submit_edit: "Update & resend",
      // UserAccessDrawer
      access_drawer_title: "Access for {{name}}",
      btn_impersonate: "View as",
      impersonate_self: "You cannot impersonate yourself.",
      impersonate_inactive: "This account is disabled.",
      impersonate_title: "Log in as this user",
      impersonate_internal_disabled:
        "Impersonation not possible: this account holds an internal Aon role.",
      impersonate_denied:
        "Impersonation denied: this user belongs to a confidential company or a protected scope.",
      mfa_enabled: "2FA enabled",
      mfa_disabled: "2FA not enabled",
      mfa_section: "Two-factor authentication",
      mfa_reset_title: "Reset two-factor authentication",
      mfa_reset_disabled: "No 2FA to reset.",
      mfa_reset_self: "You cannot reset your own 2FA here.",
      mfa_reset_button: "Reset two-factor authentication",
      mfa_reset_hint:
        "Deletes the account's TOTP factor and recovery codes. The user will have to enroll a new app at their next sign-in.",
      mfa_reset_confirm_title: "Reset 2FA for {{name}}?",
      mfa_reset_confirm_desc:
        "Their authenticator app and recovery codes will be deleted. They will have to enroll a new app at their next sign-in. The action is recorded in the audit log.",
      mfa_reset_confirm_button: "Reset",
      btn_deactivate: "Deactivate",
      btn_reactivate: "Reactivate",
      btn_delete: "Delete",
      delete_self_disabled: "You cannot delete your own account.",
      delete_admin_disabled: "Remove the admin_aon role first before deleting this account.",
      super_admin_readonly:
        "Super-admin account: only a super-admin can change its roles, status or delete it.",
      super_admin_only_hint:
        "The super_admin role can only be granted or revoked by a super-admin.",
      delete_title_default: "Permanently delete account",
      save: "Save",
      section_functional_roles: "Functional roles",
      delete_confirm_title: "Delete {{name}}?",
      delete_confirm_desc:
        "This action is irreversible. The account will be permanently deleted along with its roles and scopes.",
      delete_confirm_note:
        "History (files, documents, audit) is retained but the author will be anonymised.",
      delete_confirm_button: "Delete permanently",
      // ScopeSelector
      scope_groups: "Groups",
      scope_companies: "Companies",
      scope_subsidiaries: "Subsidiaries",
      scope_business_units: "Business Units",
      scope_sites: "Sites",
      scope_operations: "Operations",
      scope_empty_groups: "No groups.",
      scope_empty_companies: "No companies. Create one from the Tenants tab.",
      scope_empty_subsidiaries: "No subsidiaries.",
      scope_empty_bus: "No BUs.",
      scope_empty_sites: "No sites.",
      scope_empty_operations: "No operations. Create one from the Operations tab.",
      scope_no_results: "No results.",
      scope_selected_one: "{{count}} selected",
      scope_selected_other: "{{count}} selected",
      scope_search: "Search…",
    },
    operations: {
      kicker: "Administration",
      title: "BRI Operations",
      description: "All campaigns (draft, planned, in progress, closed).",
      add: "New operation",
      edit: "Edit operation",
      no_operations: "No operations created.",
      search_placeholder: "Search for an operation…",
      year: "Year",
      societe: "Company",
      status: "Status",
      dossiers_count: "Files",
      start_date: "Start date",
      end_date: "End date",
      active: "Active",
      closed: "Closed",
      draft: "Draft",
      filter_search: "Search",
      filter_placeholder: "Name, slug, company…",
      filter_all_societes: "All",
      filter_all_status: "All",
      empty_title_default: "No operation created",
      empty_title_filtered: "No results for these filters",
      empty_desc_default: "Create your first BRI operation to get started.",
      empty_desc_filtered: "Adjust your filters or create a new operation.",
      empty_action: "Create an operation",
      count: "{{count}} operation(s)",
      group_label: "Group",
      date_from: "from {{date}}",
      date_to: "to {{date}}",
      edit_aria: "Edit",
      delete_aria: "Delete",
      delete_title: 'Delete operation "{{name}}"?',
      delete_desc: "All files associated with this operation will also be deleted.",
      delete_irreversible: "This action is irreversible.",
      delete_confirm: "Delete permanently",
      form: {
        title_new: "New BRI operation",
        title_edit: 'Edit operation "{{name}}"',
        description_new:
          "An operation is a BRI campaign attached to a group, a company or a subsidiary.",
        description_edit: "Edit campaign settings.",
        cancel: "Cancel",
        save: "Save",
        create: "Create operation",
        scope_section: "Scope",
        management_section: "Management",
        documents_section: "Requested documents (depending on journey)",
        documents_hint:
          "Core documents (career statement, Agirc-Arrco, payslip) are always requested. Enable here documents specific to this journey, such as the supplementary pension statement.",
        no_configurable_types: "No configurable document type.",
        required_checkbox: "Required",
        attachment_level: "Attachment level",
        client_group: "Client group",
        client_societe: "Client company",
        filiale: "Subsidiary",
        operation_name: "Operation name",
        slug: "Slug",
        campaign_year: "Campaign year",
        start_date: "Start date",
        end_date: "End date",
        status: "Status",
        chef_projet: "Aon project manager",
        chef_projet_hint:
          "The HR sponsor's single Aon contact for this operation: they carry the HR ↔ project manager messaging channel.",
        search_chef_projet: "Search for a project manager…",
        bri_type_default: "BRI type",
        bri_type_hint:
          "Applies to every dossier in the operation. For flash BRI, the employee must record their wishes before accessing their BRI.",
        salary_band: "Salary band",
        salary_band_placeholder: "Select a band",
        salary_band_hint:
          "Employees of a single-band operation inherit it; in a mixed operation, the band is set employee by employee.",
        formation_required_label: "Training required before the journey",
        formation_required_hint:
          "If enabled, the employee must have attended a training session to access their retirement journey. If disabled, they access the digital journey directly.",
        parcours_section: "Simulation journey",
        parcours_hint:
          "Defines what the employee can simulate on their own. An Aon adviser can unlock a specific file from its detail page.",
        parcours_type_label: "Employee journey type",
        parcours_type_digital: "Fully digital",
        parcours_type_digital_humain: "Digital and human",
        parcours_type_vip: "VIP",
        parcours_type_digital_hint:
          "Self-sufficient employee, far from retirement: simulations within the defined age range, AI assistant and messaging. No appointments, no hotline, no handling by Aon production.",
        parcours_type_digital_humain_hint:
          "The employee fills in their journey, Aon processes it, an appointment is booked and the file is presented (quarter buyback, phased retirement, career anomaly report).",
        parcours_type_vip_hint:
          "Digital and human journey, plus questions about plans after retirement, comparative scenario analysis and Bracket C arbitrage / ROI.",
        parcours_capabilities_title: "What this journey opens up for the employee",
        parcours_capabilities_locked:
          "These options follow from the journey type and cannot be set one by one.",
        parcours_capability_aonProduction: "Handled by Aon production",
        parcours_capability_appointments: "Appointment booking",
        parcours_capability_hotline: "Phone hotline",
        parcours_capability_aiAssistant: "AI assistant",
        parcours_capability_messaging: "Messaging",
        parcours_capability_anomaliesBank: "Career anomaly report",
        parcours_capability_rachatRestitution: "Quarter buyback restitution",
        parcours_capability_retraiteProgressive: "Phased retirement",
        parcours_capability_scenarioComparison: "Comparative scenario analysis",
        parcours_capability_vipQuestions: "VIP complementary questions",
        parcours_capability_tranchecArbitrage: "Bracket C arbitrage and ROI",
        parcours_capability_chomageScenario: "Unemployment scenario",
        chomage_scenario_label: "Offer the unemployment scenario",
        chomage_scenario_hint:
          "Always included in the VIP journey. For other journeys, HR can also request it file by file.",
        rachat_enabled_label: "Allow simulation with quarter buyback",
        rachat_enabled_hint:
          "If disabled, the buyback option does not appear in the employee's simulations.",
        max_age_policy_label: "Maximum simulable retirement date",
        max_age_policy_hint:
          "Upper bound. Earlier retirements and the natural full rate remain always available.",
        max_age_tpn: "Natural full rate (no free date)",
        max_age_65: "Up to age 65",
        max_age_67: "Up to age 67",
        max_age_libre: "Unrestricted",
        simulations_max_label: "Max simulations per employee (12 months)",
        simulations_max_placeholder: "Unlimited",
        simulations_max_hint:
          "Calculations run by the employee over a rolling 12 months. Empty = unlimited. The Aon team is not counted.",
        rdv_duration_label: "Length of a restitution appointment",
        rdv_duration_option: "{{minutes}} minutes",
        rdv_duration_hint:
          "Length sold to the client. Slots opened for this operation follow it and an employee cannot book longer.",
        dates_imposees_label: "Departure dates set by the company",
        dates_imposees_hint:
          "Up to 6 dates simulated for every employee of the operation, on top of their own scenarios. They appear in the BRI summary as “date set by the company”.",
        dates_imposees_add: "Add a date",
        dates_imposees_remove: "Remove",
        bri_selection_section: "Simulations shown in the BRI by default",
        bri_selection_hint:
          "Client scope: scenarios shown in the BRI of this operation's files, in this order. All checked or all unchecked = every simulation; the consultant can refine file by file.",
        bri_selection_progressive: "Progressive retirement: quotities shown",
        annexes_section: "BRI appendix sheets",
        annexes_hint:
          "Library sheets appended to the BRI for this operation's files. By default the client group's selection applies.",
        annexes_mode_inherit: "Inherit from client group",
        annexes_mode_custom: "Operation-specific selection",
        annexes_empty: "No active appendix sheet in the library.",
        population_cible: "Target population",
        description: "Description (visible to client)",
        notes_internes: "Internal notes (Aon only)",
        placeholder_operation_name: "BRI Senior 2026",
        placeholder_slug: "bri-senior-2026",
        placeholder_population: "E.g.: Seniors 58+, executives, France BU…",
        placeholder_description: "Objectives, target population, context…",
        placeholder_notes: "Commitments, constraints, specifics…",
        attachment_group: "Group (all companies)",
        attachment_societe: "Company",
        attachment_filiale: "Subsidiary",
        bri_type_flash: "Flash",
        bri_type_standard: "Standard",
        bri_type_vip: "VIP / Executives",
        search_group: "Search a group…",
        search_societe: "Search a company…",
        search_filiale: "Search a subsidiary…",
        errors: {
          name_required: "Name is required",
          slug_format: "Slug: lowercase letters, digits, hyphens",
          group_required: "Group is required",
          societe_required: "Company is required",
          filiale_required: "Subsidiary is required",
          salary_band_required: "Salary band is required",
        },
      },
    },
    aiCosts: {
      kicker: "Administration",
      title: "AI costs (OpenAI)",
      description:
        "Precise tracking of OpenAI consumption: cost per request, model, feature and user.",
      period_days: "{{n}} days",
      kpi_cost: "Total cost",
      kpi_requests: "Requests",
      kpi_avg: "Average cost / request",
      kpi_cache: "Cached tokens",
      chart_title: "Cost per day",
      chart_desc: "Total ${{usd}} over the period, converted at the per-model configured rate.",
      chart_cost: "Cost (EUR)",
      by_model: "By model",
      by_feature: "By feature",
      by_user: "Top users",
      pricing_title: "Per-model pricing",
      pricing_desc:
        "OpenAI prices (USD / 1M tokens) used to cost each request. Update when OpenAI changes its rates.",
      col_model: "Model",
      edit_pricing: "Edit pricing: {{model}}",
      field_rate: "USD to EUR conversion rate",
    },
    usageStats: {
      kicker: "Administration",
      title: "Usage statistics",
      description:
        "Pension calculation API call volume (calculations and RIS imports), with an adjustable time unit.",
      period_days: "{{n}} days",
      unit_label: "Unit",
      unit_day: "Day",
      unit_week: "Week",
      unit_month: "Month",
      kpi_harvest_calls: "API calls",
      kpi_harvest_calls_hint: "{{calc}} calculations · {{ris}} RIS imports",
      kpi_success: "Success rate",
      kpi_duration: "Average duration",
      kpi_failures: "Failures",
      harvest_chart_title: "Calls over time",
      harvest_chart_desc:
        "Successful / failed calculations, RIS imports and average calculation duration per period.",
      harvest_ok: "Successful calculations",
      harvest_ko: "Failed calculations",
      harvest_ris: "RIS imports",
      harvest_duration: "Average duration",
      harvest_mix_title: "Call breakdown",
      harvest_mix_desc: "Origin of calculations over the period.",
      harvest_parcours: "Journey (estimate)",
      harvest_simulations: "On-demand simulations",
    },
    settings: {
      kicker: "Administration",
      title: "Settings",
      description: "Global platform settings, applied to all workspaces.",
      parcours_title: "Simulation journey settings",
      parcours_desc: "These settings are now defined per operation.",
      parcours_item_max_age: "Maximum simulable retirement date (natural full rate, 65 or 67).",
      parcours_item_rachat: "Simulation with or without quarter buyback.",
      parcours_item_formation: "Training required or not before accessing the journey.",
      parcours_item_quota: "Number of simulations allowed per employee over a rolling 12 months.",
      parcours_hint:
        "Open an operation, then the “Simulation journey” section of the form. An Aon adviser can also unlock a specific file from its detail page.",
      parcours_cta: "Go to operations",
      urgence_title: "Urgent files",
      urgence_desc:
        "Automatic flagging based on departure proximity, and target processing lead time.",
      urgence_auto_mois_label: "Automatic flagging (months before departure)",
      urgence_auto_mois_hint:
        "A file that has not been debriefed becomes urgent when the intended departure date or the known exit date is within this number of months (1 to 24).",
      urgence_delai_label: "Target processing lead time (working days)",
      urgence_delai_hint:
        'Beyond it, an "overdue" alert is sent to the project manager and the consultant (1 to 60, Monday to Friday).',
      saved: "Settings saved.",
      bri_legal_title: "BRI legal notice",
      bri_legal_desc:
        "Notice printed at the bottom of the BRI result pages (summary, schemes, assumptions). To be validated by Aon legal; applies immediately to the next generated documents.",
      bri_legal_lang_fr: "French",
      bri_legal_lang_en: "English",
      bri_legal_lang_es: "Spanish",
      bri_legal_hint:
        "Leave a field empty to use the default text (shown greyed out). Two to three lines maximum: beyond that the text is truncated in the PDF.",
      bri_legal_save: "Save legal notice",
      calc_title: "Calculation assumptions",
      calc_desc: "Projection drifts applied by the calculation engine.",
      calc_pass_label: "Annual PASS drift (%)",
      calc_salaires_label: "Default annual salary increase (%)",
      calc_salaires_help: "Value suggested to the employee, adjustable in their journey.",
      calc_point_service: "Point service value: 0% (value in force at the calculation date)",
      calc_point_achat: "Point purchase value: as per the calculation engine",
      calc_hint:
        "These settings apply to upcoming calculations: files already calculated are not recalculated.",
      calc_save: "Save assumptions",
      drh_reporting_title: "HR reporting",
      drh_reporting_desc:
        "Settings for the aggregated, anonymised reporting made available to HR contacts.",
      drh_seuil_label: "Anonymity threshold (minimum number of employees)",
      drh_seuil_help: "Below this number, headcounts are hidden in the HR reporting.",
      drh_reporting_save: "Save threshold",
      bri_calc_title: "BRI calculations",
      bri_calc_desc:
        "Contribution rates shown in the BRI document and the small-pension mention threshold. To be updated every January 1st.",
      bri_calc_charges_label: "Social charges on salary (%)",
      bri_calc_charges_help:
        "Displayed in the BRI and applied to the part-time net salary estimate (phased retirement).",
      bri_calc_suppl_label: "Contributions on additional pension (%)",
      bri_calc_source_label: "Rates source",
      bri_calc_date_label: "Rates in force as at",
      bri_calc_seuil_label: "Small pension threshold (€ gross / month)",
      bri_calc_seuil_help:
        "Below this amount, the BRI mentions the possible one-off lump-sum payment.",
      bri_calc_hint:
        "Basic and supplementary pension contribution rates are not set here: they are recalculated by the engine from each file's gross and net amounts.",
      bri_calc_save: "Save BRI settings",
      legal_privacy_title: "Aon confidentiality commitment",
      legal_privacy_desc:
        "Text shown to employees in a blocking window at first sign-in, then on each new version that requires re-acceptance.",
      legal_ia_conditions_title: "AI terms of use",
      legal_ia_conditions_desc:
        'Text of the "Artificial intelligence" section of the (public) Privacy page.',
      legal_ia_mention_title: "Short AI notice",
      legal_ia_mention_desc:
        'Sentence shown below the Noa analysis and the assistant, with a "Learn more" link to the Privacy page.',
      legal_version: "Version {{version}}",
      legal_published_at: "Published on {{date}} by {{author}}",
      legal_lang_fr: "French",
      legal_lang_en: "English",
      legal_lang_es: "Spanish",
      legal_minor_fix: "Minor fix: do not ask employees to accept again",
      legal_publish: "Publish version {{version}}",
      legal_publish_confirm_title: "Publish version {{version}}?",
      legal_publish_confirm_desc:
        "Employees will have to read this text again and accept it at their next sign-in before accessing their space.",
      legal_versions: "Previous versions",
      legal_reaccept_yes: "Re-acceptance required",
      legal_reaccept_no: "Minor fix",
      nav_sections: "Settings sections",
      last_modified: "Modified on {{date}} at {{time}} by {{author}}",
      section_parcours: "Employee journey",
      section_calculs: "Calculations",
      section_bri: "BRI",
      section_textes_legaux: "Consents and legal texts",
      section_ia: "Artificial intelligence",
      section_reporting_drh: "HR reporting",
      section_securite: "Security",
      mfa_title: "Two-factor authentication",
      mfa_desc: "Populations for which two-factor authentication (TOTP app) is mandatory.",
      mfa_aon_label: "Aon internal users",
      mfa_aon_desc: "Aon administrators, project managers and consultants.",
      mfa_drh_label: "HR contacts",
      mfa_drh_desc: "Client-side users with the HR role.",
      mfa_salarie_label: "Employees",
      mfa_salarie_desc: "Off by default: they can enable it from their profile.",
      mfa_warning:
        "Enabling a population forces all its users to enroll an authenticator app the next time a page loads. Warn them before enabling.",
      mfa_save: "Save security settings",
      bri_taux_title: "Social contribution rates",
      bri_taux_desc:
        "Rates shown in the BRI document for contributions on salary and on the additional pension.",
      bri_taux_save: "Save rates",
      bri_petite_pension_title: "Very small pension notice",
      bri_petite_pension_desc:
        "Threshold below which the BRI mentions the possible one-off lump-sum payment, per pension fund rules.",
      bri_petite_pension_save: "Save threshold",
      noa_facts_title: "Did you know?",
      noa_facts_desc:
        "Sentences shown while the Noa analysis is being generated. Any change is visible immediately to all users.",
      noa_facts_hint:
        "Only active sentences rotate, in the order shown. Empty translations fall back to French.",
      noa_facts_empty: "No sentence: the block is not displayed during the analysis.",
      noa_facts_add: "Add a sentence",
      noa_facts_edit: "Edit",
      noa_facts_delete: "Delete",
      noa_facts_move_up: "Move up",
      noa_facts_move_down: "Move down",
      noa_facts_translations: "Translations (EN, ES)",
      noa_facts_active: "Visible during the analysis",
      noa_facts_fr_label: "French (required)",
      noa_facts_en_label: "English",
      noa_facts_es_label: "Spanish",
      noa_facts_edit_title: "Edit the sentence",
      noa_facts_new_title: "New sentence",
      noa_facts_save: "Save the sentence",
      noa_facts_delete_title: "Delete this sentence?",
      noa_facts_delete_desc:
        "It will no longer be displayed while analyses are generated. This action is permanent.",
    },
    audit: {
      kicker: "Administration",
      title: "Audit log",
      description: "Traceability of access and actions on files, employees and permissions (GDPR).",
      search_placeholder: "Action, email, entity…",
      export: "Export (CSV)",
      exporting: "Exporting…",
      no_events: "No events",
      empty_title: "No audit events yet",
      empty_description:
        "Sensitive actions (creation, modification, deletion on files, employees and permissions) will be logged here as they occur.",
      no_events_description: "No events match these filters.",
      category: "Category",
      category_auth: "Authentication",
      category_read: "Read",
      category_write: "Write",
      category_export: "Export",
      category_delete: "Delete",
      category_system: "System",
      category_help_auth: "Logins and logouts to the platform.",
      category_help_read: "Information consultations (read-only).",
      category_help_write: "Creation and modification of information.",
      category_help_export: "Downloads and data exports (e.g. CSV files).",
      category_help_delete: "Deletion of information.",
      category_help_system: "Automatic technical actions of the platform.",
      outcome: "Outcome",
      outcome_success: "Success",
      outcome_failure: "Failure",
      outcome_denied: "Denied",
      actor: "Actor",
      entity: "Entity",
      action: "Action",
      timestamp: "Date and time",
      from: "From",
      to: "To",
      events: "events",
      help_title: "What is this page for?",
      help_description:
        "This log lists, in readable format, who did what and when on the platform: logins, creations, modifications, deletions and exports. Click on a row to see details. No sensitive personal data is stored here.",
      show_legend: "Understand categories",
      hide_legend: "Hide legend",
      no_detail: "No detail available.",
      status_change: "Status change:",
      affected_fields: "Affected fields ({{count}})",
      tech_ref: "Technical reference",
      collapse: "Collapse",
      expand: "Expand",
      system: "System",
      action_login: "Logged in to the platform",
      action_logout: "Logged out",
      action_auth_generic: "Authentication action",
      action_mfa_codes_generated: "Regenerated their recovery codes (2FA)",
      action_mfa_recovery_used: "Signed back in with a recovery code (2FA)",
      action_mfa_recovery_failed: "2FA recovery code refused",
      action_mfa_reset: "Reset a user's two-factor authentication",
      action_export: "Exported data",
      action_read: "Consulted {{entity}}",
      action_create: "Created {{entity}}",
      action_update: "Modified {{entity}}",
      action_delete: "Deleted {{entity}}",
      entity_dossier_indef: "a file",
      entity_dossier_def: "the file",
      entity_salarie_indef: "an employee",
      entity_salarie_def: "the employee",
      entity_bri_indef: "a retirement assessment",
      entity_bri_def: "the retirement assessment",
      entity_document_indef: "a document",
      entity_document_def: "the document",
      entity_user_role_indef: "a user role",
      entity_user_role_def: "the user role",
      entity_user_scope_indef: "an access scope",
      entity_user_scope_def: "the access scope",
      entity_operation_indef: "an operation",
      entity_operation_def: "the operation",
      entity_societe_indef: "a company",
      entity_societe_def: "the company",
      entity_groupe_indef: "a group",
      entity_groupe_def: "the group",
      entity_settings_indef: "a setting",
      entity_settings_def: "the setting",
      entity_noa_fact_indef: "a “Did you know?” item",
      entity_noa_fact_def: "the “Did you know?” item",
      value_empty: "empty",
      field_actif: "Active",
      field_position: "Position",
      field_assigned_consultant: "Assigned consultant",
      field_assigned_chef_projet: "Assigned project manager",
      field_assigned_reviewer: "Assigned reviewer",
      field_assigned_restitution_consultant: "Assigned restitution consultant",
      field_prenom: "First name",
      field_email_pro: "Professional email",
      field_email_correspondance: "Correspondence email",
      field_email_perso: "Personal email",
      field_date_naissance: "Date of birth",
      field_civilite: "Civility",
      field_code_postal: "Postal code",
      field_adresse: "Address",
      field_ville: "City",
      field_salaire_annuel_declare: "Declared annual salary",
      field_salaire_annuel_confirme: "Confirmed annual salary",
      field_nombre_enfants: "Number of children",
      field_role: "Role",
      field_scope_type: "Scope type",
      field_scope_id: "Concerned scope",
      field_nom_commercial: "Trade name",
      field_raison_sociale: "Company name",
      field_siren: "SIREN",
      field_bri_type: "Assessment type",
      field_is_active: "Active",
      gdpr_notice:
        "GDPR log: only modified columns are kept, never business values. Access restricted to Aon administration.",
    },
    pappers: {
      label_default: "Auto-fill from SIREN/SIRET",
      aria_label: "Company search by SIREN/SIRET",
      field_siren: "SIREN (9 digits)",
      field_siret: "SIRET (14 digits)",
      search: "Search",
      success: "Data retrieved: {{name}}",
      hint_siren:
        "Enter the company's SIREN to auto-fill name, corporate name, SIRET, NAF code and registered address.",
      hint_siret:
        "Enter the subsidiary's SIRET (14 digits) to retrieve its name and verify it is linked to the parent company.",
    },
    branding: {
      kicker: "Administration",
      title: "Tenant branding",
      description:
        "Aon co-branding per company. Inherited by cascade: Operation > Site > BU > Subsidiary > Company > Group > Aon.",
      search_placeholder: "Name, slug…",
      overrides_count_one: "active branding override on the platform.",
      overrides_count_other: "active branding overrides on the platform.",
      entities_count_one: "{{count}} entity",
      entities_count_other: "{{count}} entities",
      tabs: {
        societes: "Companies",
        groupes: "Groups",
        operations: "Operations",
      },
      empty: {
        societes_title: "No company",
        societes_hint: "Create a company from the Tenants tab to edit its branding.",
        groupes_title: "No group",
        groupes_hint: "Create a group from the Tenants tab to edit its branding.",
        operations_title: "No operation",
        operations_hint: "Create an operation from the Operations tab to edit its branding.",
      },
      status: {
        active: "Active branding",
        inherit: "Inherited",
      },
      actions: {
        configure: "Configure",
        edit: "Edit",
        details: "Details",
        delete: "Delete",
        delete_aria: "Delete branding",
      },
      delete_confirm: {
        title: "Delete this branding?",
        description: "The scope will revert to values inherited from its parent.",
      },
      scope_labels: {
        groupe: "Group",
        societe: "Company",
        filiale: "Subsidiary",
        business_unit: "Business Unit",
        site: "Site",
        operation: "Operation",
      },
      fields: {
        product_name: "Product name",
        product_tagline: "Tagline",
        font_sans: "Sans font",
        font_display: "Display font",
        footer_legal: "Legal footer",
        brand: "Brand",
        brand_foreground: "Brand foreground",
        brand_hover: "Brand hover",
        brand_muted: "Brand muted",
        accent: "Accent",
        accent_foreground: "Accent foreground",
      },
      drawer: {
        title: "Branding · {{scope}}",
        description: "{{level}} level. Empty values will inherit from the parent.",
        identity_title: "Product identity",
        identity_name_label: "Displayed product name",
        identity_name_placeholder: "e.g. BRI TotalEnergies",
        identity_tagline_label: "Tagline / subtitle",
        identity_tagline_placeholder: "The personalised Aon BRI x {Company}",
        colors_title: "Colours",
        preview_title: "Preview",
        preview_primary: "Primary button",
        preview_secondary: "Secondary button",
        preview_session: "Preview on my session",
        preview_restore: "Restore current branding",
        logos_title: "Logos & favicon",
        logo_light_label: "Logo (light background)",
        logo_light_hint: "Shown in the sidebar and header · PNG, JPG, WEBP or SVG",
        logo_dark_label: "Logo (dark background)",
        logo_dark_hint: "Light variant for dark backgrounds (optional)",
        favicon_label: "Favicon",
        favicon_hint: "Browser tab icon · PNG, SVG or ICO",
        typography_title: "Typography",
        font_sans_label: "Sans-serif font (CSS stack)",
        font_sans_placeholder: '"Inter", system-ui, sans-serif',
        font_display_label: "Display font (CSS stack)",
        font_display_placeholder: '"Helvetica Now Display", "Helvetica Neue", sans-serif',
        legal_title: "Legal notices (PDF footer)",
        footer_label: "Footer text",
        footer_placeholder: "Specific mentions (registered office, ORIAS, etc.)",
        color_format_error: "Expected format: #RRGGBB or HSL triplet (e.g. 354 100% 46%)",
        hsl_detected: "HSL triplet detected",
        cancel: "Cancel",
        save: "Save",
      },
    },
    email_templates: {
      kicker: "Administration",
      title: "Email templates",
      description: "Manage email templates sent by the platform.",
      add: "New template",
      edit: "Edit template",
      kind: "Type",
      subject: "Subject",
      body: "Body",
      preview: "Preview",
      no_templates: "No templates configured.",
      variables: "Available variables",
    },
    onboarding: {
      kicker: "Administration · Onboarding",
      title: "Launch a new company",
      description:
        "4 guided steps: create the company (and its group), its internal structure (BUs, sites), its BRI campaign and options, then invite the first employees. Everything is pre-filled as much as possible — you can refine it all afterwards.",
      step_company: "Company",
      step_structure: "BUs & sites",
      error_create_group: "Failed to create the group.",
      error_create_structure: "Failed to create the BUs / sites.",
      field_group_new: "Or create a new group",
      field_group_new_placeholder: "Group name (e.g. Bouygues Group)",
      field_group_new_hint: "Optional: the group will be created and the company attached to it.",
      structure_section_title: "Internal structure (optional)",
      structure_section_desc:
        "Declare the business units and geographic sites of {{company}}: they are used to attach employees and scope HR access.",
      bu_title: "Business units",
      bu_hint: "Departments, divisions or BUs used to segment the population.",
      bu_add: "Add a BU",
      bu_name_placeholder: "E.g. Industrial Division",
      sites_title: "Geographic sites",
      sites_hint: "Physical establishments or sites employees are attached to.",
      site_add: "Add a site",
      site_name_placeholder: "E.g. HQ — La Défense",
      site_ville_placeholder: "City",
      structure_field_name: "Name",
      structure_field_ville: "City",
      structure_created: "Created",
      structure_remove: "Remove row",
      structure_skip_hint:
        "This step is optional: you can continue without BUs or sites and add them later from the client record.",
      options_section_title: "Journey options",
      step_operation: "BRI operation",
      step_employees: "Employees",
      step_summary: "All set",
      back: "Back",
      continue: "Continue",
      finish_without_employee: "Finish without employee",
      create_employees: "Create {{count}} employee",
      create_employees_plural: "Create {{count}} employees",
      onboard_another: "Onboard another company",
      see_operations: "View operations",
      company_section_title: "The client company",
      company_section_desc: "Enter the SIREN to auto-fill, or fill in the name manually.",
      pappers_hint:
        "Auto-fills the name, legal name, SIRET, NAF code and registered office address.",
      field_company_name: "Company name",
      field_slug: "Identifier",
      field_group: "Attach to a group (optional)",
      field_group_placeholder: "No group",
      field_group_search: "Search a group…",
      field_siren: "SIREN",
      field_raison_sociale: "Legal name",
      field_adresse: "Address",
      field_code_postal: "Postcode",
      field_ville: "City",
      drh_section_title: "HR / DRH contact (optional)",
      field_drh_nom: "Contact name",
      field_drh_email: "Email",
      field_drh_tel: "Phone",
      operation_section_title: "The BRI campaign",
      operation_section_desc:
        "An operation is the retirement assessment campaign linked to {{company}}.",
      operation_section_desc_default: "the company",
      field_operation_name: "Operation name",
      field_operation_year: "Year",
      field_bri_type: "BRI type",
      bri_type_hint:
        "Applies to every dossier in the operation. For flash BRI, the employee must record their wishes before accessing their BRI.",
      field_salary_band: "Salary band",
      salary_band_placeholder: "Select a band",
      salary_band_hint:
        "Employees of a single-band operation inherit it; in a mixed operation, the band is set employee by employee.",
      field_status: "Status",
      field_population: "Target population (optional)",
      population_placeholder: "E.g. Seniors 58+, senior executives…",
      bri_type_flash: "Flash",
      bri_type_standard: "Standard",
      bri_type_vip: "VIP / Executives",
      status_draft: "Draft",
      status_planned: "Planned",
      status_ongoing: "Ongoing",
      employees_section_title: "The first employees",
      employees_section_desc:
        "Add a few employees linked to {{operation}}. You can bulk-import more later from the Employees screen.",
      field_firstname: "First name",
      field_lastname: "Last name",
      field_email: "Email",
      email_placeholder: "firstname.lastname@company.com",
      add_employee: "Add an employee",
      remove_employee: "Remove this employee",
      send_invitation_label: "Send invitation by email",
      send_invitation_desc:
        "Each employee with an email address will receive a secure link to access their retirement journey.",
      done_title: "Company onboarded!",
      done_desc: "{{company}} and its campaign {{operation}} have been created.",
      done_tile_company: "Company",
      done_tile_operation: "Operation",
      done_tile_employee: "Employee",
      done_tile_employees: "Employees",
      done_invited_one: "{{count}} invited",
      done_invited_plural: "{{count}} invited",
      done_link_intro: "Find the company in",
      done_link_clients: "Clients",
      done_link_and: "and the campaign in",
      done_link_operations: "Operations",
      error_company_name: "Company name is required.",
      error_slug_format:
        "The identifier (slug) must contain only lowercase letters, digits and hyphens.",
      error_company_missing: "Please create the company first.",
      error_operation_name: "Operation name is required.",
      error_operation_salary_band: "Choose a salary band for the operation.",
      error_email_required:
        "An email is required to invite {{name}}. Disable invitations or provide the email.",
      error_create_company: "Failed to create the company.",
      error_create_operation: "Failed to create the operation.",
      error_create_employee: "Failed to create an employee.",
      error_company_incomplete: "Company is missing.",
    },
    formations: {
      kicker: "Administration",
      title: "Training",
      description: "Manage training sessions and attendance.",
    },
    document_types: {
      kicker: "Administration",
      title: "Document types",
      description:
        "Catalogue of documents that can be requested in a file. Core types are offered to every employee; others are activated per journey in the operation record.",
      new_type: "New type",
      catalogue: "Catalogue",
      empty: "No document types.",
      badge_core: "Core",
      badge_required: "Required",
      badge_inactive: "Inactive",
      aria_edit: "Edit",
      aria_delete: "Delete",
      core_no_delete: "Core type cannot be deleted",
      dialog_title_new: "New document type",
      dialog_title_edit: "Edit document type",
      field_label: "Label",
      field_label_placeholder: "E.g. Supplementary pension statement",
      field_slug: "Identifier (slug)",
      field_slug_hint: "Cannot be changed: referenced by journeys and uploaded documents.",
      field_kind: "Storage category",
      field_description: "Description (upload guidance)",
      field_description_placeholder:
        "Explain to the employee which document to upload and where to find it.",
      field_position: "Position",
      translations_title: "Translations (EN / ES)",
      translations_hint:
        "Optional: label and description shown to employees in their language. French is used as fallback.",
      field_label_en: "Label (English)",
      field_label_es: "Label (Spanish)",
      field_description_en: "Description (English)",
      field_description_es: "Description (Spanish)",
      check_core: "Core (always offered in every journey)",
      check_required: "Required by default",
      check_multiple: "Multiple files allowed",
      check_active: "Active",
      delete_title: "Delete document type",
      delete_description:
        'Delete "{{label}}"? Journeys that request it will no longer offer it. Already uploaded documents are not deleted.',
      kind_ris: "Career statement (RIS)",
      kind_agirc_arrco: "Agirc-Arrco statement",
      kind_bulletin_salaire: "Pay slip",
      kind_justificatif_retraite_supp: "Supplementary pension (PER, art. 83/39)",
      kind_justificatif_carriere: "Career certificate",
      kind_justificatif_penibilite: "Hardship certificate",
      kind_justificatif_handicap: "Disability certificate",
      kind_autre: "Other",
    },
    controle_qualite: {
      kicker: "Administration",
      title: "Quality checklist",
      description:
        "Two-level review grid (N1 production / N2 project manager) to complete before BRI generation. Required items block level validation.",
      info: "These control points appear in the file record (production area) as checkboxes. An item marked as required prevents level validation until it is checked.",
      level_n1_label: "N1 — Production",
      level_n2_label: "N2 — Project manager",
      level_n1_description: "Peer review (peer to peer) carried out by a production peer.",
      level_n2_description: "Final check by the project manager before delivery.",
      add: "Add",
      empty: "No control points for this level.",
      badge_required: "Required",
      badge_optional: "Optional",
      badge_inactive: "Inactive",
      dialog_title_new: "New control point",
      dialog_title_edit: "Edit control point",
      field_level: "Level",
      field_position: "Position",
      field_label: "Label",
      field_label_placeholder: "E.g. RIS imported & career verified",
      field_description: "Description (review guidance)",
      field_description_placeholder: "Specify what the reviewer must check.",
      check_required: "Required item (blocks validation)",
      check_active: "Active",
      cancel: "Cancel",
      save: "Save",
      delete_title: "Delete control point",
      delete_description:
        'Delete "{{label}}"? Answers already recorded on files will also be deleted.',
      delete_confirm: "Delete",
    },
    annexes_bri: {
      kicker: "Administration",
      title: "BRI Annexes",
      description:
        "Library of annex sheets (glossary, special schemes, taxation...) insertable into BRI documents and selectable as default annexes at client group level.",
      new_annexe: "New sheet",
      stat_total: "Sheets",
      stat_actives: "Active",
      stat_avec_fichier: "With file",
      search_placeholder: "Search by title, topic, tag...",
      filter_all: "All topics",
      empty_title: "No sheets",
      empty_filtered: "No results for these filters.",
      empty_description: "Create your first annex sheet to enrich the library.",
      create_first: "Create a sheet",
      badge_inactive: "Inactive",
      action_open_file: "Open file",
      action_deactivate: "Deactivate",
      action_activate: "Activate",
      action_edit: "Edit",
      action_delete: "Delete",
      delete_title: "Delete this sheet",
      delete_description: '"{{titre}}" will be permanently deleted.',
      delete_body:
        "The sheet will be removed from the library and from all group annex selections.",
      delete_confirm: "Delete",
      drawer_title_new: "New annex sheet",
      drawer_title_edit: "Edit annex sheet",
      drawer_description:
        "Reusable sheet inserted into BRI documents (glossary, schemes, taxation...).",
      field_titre: "Title",
      field_slug: "Slug",
      field_slug_hint: "Unique identifier.",
      field_thematique: "Topic",
      field_description: "Description",
      field_description_hint: "Summary of the sheet content.",
      field_file: "Sheet file",
      field_file_hint_replace: "A file is already attached. Select a new one to replace it.",
      field_file_hint_new: "PDF or image (max 200 MB). Optional - can be added later.",
      file_replace: "Replace file...",
      file_choose: "Choose a file...",
      field_cover: "Preview image",
      field_cover_hint: "Optional. PNG, JPG, WEBP or SVG · max 5 MB.",
      field_tags: "Tags",
      field_tags_hint: "Comma-separated.",
      switch_active_label: "Active sheet",
      switch_active_description: "Deactivate to remove from the selection without deleting.",
      cancel: "Cancel",
      save: "Save",
      create: "Create sheet",
      thematique_lexique: "Glossary",
      thematique_regimes_speciaux: "Special schemes",
      thematique_fiscalite: "Taxation",
      thematique_cas_particuliers: "Special cases",
      thematique_infographie: "Infographic",
      thematique_autre: "Other",
    },
    rachat: {
      kicker: "Reference",
      title: "Quarter buyback scale",
      description:
        "CNAV scale for the voluntary pension contribution (VPLR / Fillon scheme), versioned by year. The cost of a quarter depends on age, income bracket (indexed to the PASS) and option. This scale feeds the cost and profitability estimate in the retirement journey.",
      new_millesime: "New year edition",
      info_stable:
        "The cost scale is stable over time (unchanged for ~11 years); only the income thresholds change each year (indexed to the PASS). Update the PASS / thresholds on the year edition and import the official cost grid (CNAV circular) below.",
      empty_title: "No year edition",
      empty_description:
        "Create a first year edition (year + PASS + bracket thresholds) to get started.",
      active_badge: "Active",
      activate: "Activate",
      pass: "PASS",
      tranche_label: "Bracket {{n}} / {{m}}",
      edit: "Edit",
      delete_millesime_title: "Delete year edition {{annee}}?",
      delete_millesime_description:
        "All scale cells for this year edition will be permanently deleted.",
      delete_confirm: "Delete",
      cancel: "Cancel",
      millesime_dialog_new: "New year edition",
      millesime_dialog_edit: "Year edition {{annee}}",
      millesime_dialog_description:
        "PASS and income bracket thresholds (bracket 1 < threshold1 ≤ bracket 2 ≤ threshold2 < bracket 3).",
      field_annee: "Year",
      field_pass: "PASS (€)",
      field_seuil1: "Bracket 1 threshold (€)",
      field_seuil2: "Bracket 2 threshold (€)",
      field_libelle: "Label",
      field_source: "Source",
      libelle_placeholder: "CNAV scale 2025",
      source_placeholder: "CNAV — Circular 2025-01",
      save: "Save",
      create: "Create",
      error_annee: "Invalid year.",
      error_pass_seuils: "PASS and thresholds must be positive amounts.",
      error_seuil_order: "Bracket 1 threshold must be less than or equal to bracket 2 threshold.",
      bareme_title: "Scale {{annee}}",
      bareme_description: "Cost per quarter by age, income bracket and option.",
      cells_filled_one: "{{count}} cell filled",
      cells_filled_other: "{{count}} cells filled",
      cells_total: " / {{total}}",
      import: "Import",
      export_csv: "Export CSV",
      col_age: "Age",
      col_tranche: "Bracket {{n}}",
      age_years: "{{age}} yrs",
      option_taux_seul: "Rate only",
      option_taux_duree: "Rate + duration",
      test_title: "Test cost (active edition)",
      test_field_age: "Age",
      test_field_revenu: "Annual income (€)",
      test_tranche: "Bracket",
      test_taux_seul: "Rate only",
      test_taux_duree: "Rate + duration",
      test_per_trim: "{{value}} / qtr.",
      test_no_active: "No active year edition.",
      test_not_found: "Scale not filled for this cell (age / bracket).",
      test_active_mismatch: "Note: the test uses the active edition ({{active}}), not {{current}}.",
      cell_dialog_title: "Cost per quarter",
      cell_dialog_context: "{{age}} yrs · Bracket {{tranche}} · {{option}}",
      cell_field_percent: "Percentage of income (%)",
      cell_field_euro: "Cost per quarter (€)",
      cell_tranche2_hint:
        "Bracket 2 (income between 75% and 100% of PASS): the cost is a percentage applied to the average income.",
      import_dialog_title: "Import scale {{annee}}",
      import_dialog_description:
        "CSV format: one line per cell — age;bracket;option;cost. Option = taux_seul or taux_duree (or OPTION_1 / OPTION_2).",
      import_example_title: "Example",
      import_tranche2_hint:
        "For bracket 2 (income between 75% and 100% of PASS), the value is a percentage of income (e.g. 10.73), not an amount in €.",
      import_field_csv: "CSV data",
      import_placeholder: "Paste the official scale here (age;bracket;option;cost)…",
      import_replace: "Fully replace the scale for this year edition (otherwise merge / update)",
      import_errors_more: "… and {{count}} more.",
      import_button: "Import",
      import_button_count: "Import ({{count}})",
      import_error_empty: "No valid cells to import.",
    },
    rgpd: {
      kicker: "Administration",
      title: "GDPR requests",
      description:
        "Track data subject requests, data retention and portability, in compliance with the GDPR.",
      tab_requests: "Requests",
      tab_retention: "Retention & portability",
      requests: {
        export_csv: "Export (CSV)",
        stat_pending: "To do",
        stat_in_review: "In progress",
        stat_fulfilled: "Completed",
        stat_overdue: "Overdue",
        search_label: "Search",
        search_placeholder: "Requester email, reason…",
        kind_label: "Right type",
        status_label: "Status",
        reset: "Reset",
        empty_title_filtered: "No requests",
        empty_title: "No GDPR requests",
        empty_desc_filtered: "No requests match these filters.",
        empty_desc:
          "Data subject requests submitted by employees or their representatives will appear here for processing.",
        table_received: "Received",
        table_requester: "Requester",
        table_kind: "Right type",
        table_status: "Status",
        table_due: "Due date",
        table_actions: "Actions",
        aria_expand: "Expand",
        aria_collapse: "Collapse",
        detail_reason: "Reason",
        detail_salarie: "Concerned employee",
        detail_not_linked: "Not linked",
        detail_created: "Created on",
        detail_due: "Legal deadline",
        detail_handled_by: "Handled by",
        detail_handled_at: "Handled on",
        detail_fulfilled_at: "Completed on",
        detail_rejected_at: "Rejected on",
        detail_rejection_reason: "Rejection reason",
        salarie_label: "Employee: {{name}}",
        action_generate_export: "Generate export",
        action_download: "Download",
        action_take_in_charge: "Take over",
        action_fulfill: "Complete",
        action_reject: "Reject",
        action_reopen: "Reopen",
        footer_note:
          "Under the GDPR, requests must be processed within one month (deadline shown). The right to erasure is limited by legal data retention obligations.",
        reject_dialog_title: "Reject request",
        reject_dialog_desc:
          "Enter the reason for rejection (shared with the requester). This can be undone by reopening the request.",
        reject_dialog_reason_label: "Rejection reason",
        reject_dialog_reason_placeholder: "E.g. request out of scope, legal retention obligation…",
        reject_dialog_confirm: "Reject",
        kind_export: "Access / portability",
        kind_effacement: "Erasure",
        kind_rectification: "Rectification",
        kind_opposition: "Objection",
        kind_limitation: "Processing restriction",
        status_pending: "To do",
        status_in_review: "In progress",
        status_fulfilled: "Completed",
        status_rejected: "Rejected",
        csv_header_created_at: "created_at",
        csv_header_requester_email: "requester_email",
        csv_header_salarie: "employee",
        csv_header_kind: "kind",
        csv_header_status: "status",
        csv_header_due_at: "due_at",
        csv_header_reason: "reason",
        csv_header_handled_by: "handled_by",
        csv_header_rejection_reason: "rejection_reason",
        csv_filename: "gdpr_{{date}}.csv",
      },
      retention: {
        title: "Data retention",
        description: "Retention periods by data category (GDPR — storage limitation).",
        add: "Add",
        empty: "No policy defined.",
        edit_aria: "Edit",
        delete_aria: "Delete",
        dialog_new: "New retention policy",
        dialog_edit: "Edit policy",
        field_label: "Label",
        field_label_placeholder: "E.g. Pension reviews",
        field_category: "Category (key)",
        field_category_placeholder: "E.g. dossier_actif",
        field_months: "Retention period (months)",
        field_basis: "Legal basis",
        field_basis_placeholder: "E.g. Legal obligation",
        field_description: "Description",
        active_label: "Active policy",
        months_none: "No retention",
        months_year_one: "{{count}} year",
        months_year_other: "{{count}} years",
        months_months_one: "{{count}} month",
        months_months_other: "{{count}} months",
        delete_title: "Delete policy",
        delete_desc: "Delete policy « {{label}} »? This action is permanent.",
        delete_confirm: "Delete",
        reversibility_title: "Data portability",
        reversibility_desc:
          "Return all data for a company (full export of employees and reviews, CDC §17d). The file is generated as JSON in secure storage.",
        export: "Export",
        no_societes: "No companies.",
        export_failed: "Export failed",
      },
    },
    salaries: {
      kicker: "Administration",
      title: "Employees",
      description: "Full employee record management.",
      add: "New employee",
      import: "Import employees",
      search_placeholder: "Search for an employee…",
      no_salaries: "No employees found.",
      matricule: "Employee ID",
      nom: "Last name",
      prenom: "First name",
      email: "Email",
      societe: "Company",
      operation: "Operation",
      status: "Status",
      vip: "VIP",
      send_invitation: "Send invitation",
      delete_confirm: "Delete this employee?",
      parcours: "Retirement journey",
      detail: "Employee record",
    },
    roadmap: {
      kicker: "Administration",
      title: "Roadmap",
      description: "Feature tracking and project progress.",
    },
    controle: {
      kicker: "Administration",
      title: "Quality checklist",
      description: "Quality checklist to validate a file before production.",
    },
    content_library: {
      views_title: "Views of this resource",
      views_label_one: "{{count}} view · last: {{last}}",
      views_label_other: "{{count}} views · last: {{last}}",
      views_none: "No view",
      kicker: "Administration",
      title: "Content library",
      description:
        "Sheets, videos, articles and links published read-only in the employee, HR and Aon spaces based on their targeting.",
      new_button: "New content",
      stat_total: "Items",
      stat_published: "Published",
      stat_featured: "Featured",
      search_placeholder: "Search by title, topic, tag…",
      filter_all_types: "All types",
      empty_title: "No content",
      empty_filtered: "No results for these filters.",
      empty_none: "Create your first content to populate the spaces.",
      empty_create: "Create content",
      row_unpublish: "Unpublish",
      row_publish: "Publish",
      row_edit: "Edit",
      row_delete: "Delete",
      row_draft: "Draft",
      row_featured: "Featured",
      delete_title: "Delete this content",
      delete_description: '"{{title}}" will be permanently deleted.',
      delete_confirm: "Delete",
      delete_body: "The content will immediately disappear from the spaces that display it.",
      drawer_title_create: "New content",
      drawer_title_edit: "Edit content",
      drawer_description:
        "Sheet, video, article or link — visible read-only in the targeted spaces.",
      drawer_cancel: "Cancel",
      drawer_save: "Save",
      drawer_create: "Create content",
      drawer_error_unknown: "Unknown error",
      tab_edit: "Edit",
      tab_preview: "Preview",
      field_title: "Title",
      field_slug: "Slug",
      field_slug_hint: "Unique identifier (URL).",
      field_duration: "Duration (min)",
      field_duration_hint: "Estimated reading / viewing time.",
      field_kind: "Type",
      field_category: "Category",
      field_audiences: "Visible in spaces",
      field_audiences_hint: "At least one space.",
      field_summary: "Summary",
      field_summary_hint: "A sentence displayed on the card.",
      field_body: "Content (markdown)",
      field_body_hint: "## Headings, **bold**, lists (-), blockquotes (>), [links](url).",
      field_url_video: "Video URL",
      field_url_video_hint: "YouTube or Vimeo (auto embed).",
      field_url_link: "Link URL",
      field_url_link_hint: "External link (public service, partner…).",
      field_file: "File",
      field_file_optional: "Video file (optional)",
      field_file_hint_doc: "PDF, Word, Excel or PowerPoint (max 200 MB).",
      field_file_hint_video: "If no YouTube/Vimeo URL, upload an mp4.",
      field_file_existing: "A file is already attached. Select a new one to replace it.",
      field_file_replace: "Replace file…",
      field_file_choose: "Choose a file…",
      field_cover: "Cover image",
      field_cover_hint: "Optional. PNG, JPG, WEBP or SVG · max 5 MB.",
      field_tags: "Tags",
      field_tags_hint: "Comma-separated.",
      switch_featured: "Featured",
      switch_featured_desc: "Pin at the top of the library.",
      switch_published: "Published",
      switch_published_desc: "Uncheck to hide the resource from spaces.",
      preview_hint: "Card preview as it will appear in the targeted spaces.",
    },
    emailTemplates: {
      kicker: "Administration",
      title: "Email templates",
      description:
        "Emails actually sent by the platform: invitations, magic-link login (OTP), password reset and file follow-ups.",
      new_button: "New template",
      search_placeholder: "Search a template, a word in the subject…",
      all_kinds: "All types",
      count_label: "{{count}} template",
      count_label_plural: "{{count}} templates",
      empty_title: "No template",
      empty_filtered: "No result for these filters.",
      empty_create_first: "Create your first template to start automated communications.",
      empty_create_button: "Create a template",
      edit_tooltip: "Edit",
      delete_tooltip: "Delete",
      delete_title: "Delete this template",
      delete_confirm: "Delete",
      delete_description: "« {{slug}} » will be permanently deleted.",
      delete_history_note:
        "If this template is referenced in past sends, history will be kept but the template will no longer be usable.",
      badge_system: "System",
      badge_inactive: "Inactive",
      kinds: {
        invitation: "Invitation (system)",
        otp_login: "OTP login (system)",
        password_reset: "Password reset (system)",
        relance: "File follow-up",
        evaluation_invitation: "Service evaluation invitation",
        evaluation_relance: "Service evaluation reminder",
      },
      variables: {
        prenom: "Recipient first name",
        nom: "Recipient last name",
        magic_link: "Magic link (invitation / OTP)",
        reset_link: "Password reset link",
        roles_label: "Assigned roles (user invitation)",
        inviter_name: "Inviter name (user invitation)",
        societe: "Company name (follow-up)",
        lien_dossier: "URL to employee space (follow-up)",
        consultant_nom: "Consultant name (follow-up)",
      },
      drawer: {
        new_title: "New email template",
        edit_title: "Edit template",
        description:
          "System emails sent automatically by the platform (invitation, OTP login, password reset)",
        cancel: "Cancel",
        save: "Save",
        create: "Create template",
        tab_edit: "Editor",
        tab_preview: "Preview",
        field_slug: "Slug",
        field_kind: "Type",
        field_langue: "Language",
        field_langue_fr: "Français",
        field_langue_en: "English",
        field_scope: "Scope",
        scope_system: "System",
        scope_operation: "Operation",
        scope_operation_disabled_title: "Link to an operation coming soon",
        field_subject: "Subject",
        field_subject_placeholder: "Hello {{prenom}}, your BRI is available",
        field_body_html: "HTML body",
        field_body_html_hint: "You can use simple HTML. Click a variable to insert it.",
        field_body_html_placeholder: "<p>Hello {{prenom}},</p>\n<p>Your BRI…</p>",
        variables_available: "Available variables",
        variables_hint: "Click to insert into the body.",
        field_body_text: "Text version (fallback)",
        field_body_text_hint: "Optional. If empty, generated automatically on send.",
        preview_subject_label: "Subject",
        preview_rendered_label: "Rendered preview (variables replaced)",
        preview_empty: "(empty)",
        preview_disclaimer: "Preview based on dummy data ({{count}} variables).",
      },
    },
    messageTracking: {
      kicker: "Administration",
      title: "Message tracking",
      description:
        "All conversations awaiting a response, sorted by age. An email notification is already sent for each message: this screen ensures no exchange is left pending.",
      badge_critical_one: "{{count}} conversation unanswered for more than 48 hours",
      badge_critical_other: "{{count}} conversations unanswered for more than 48 hours",
      stat_total: "Active conversations",
      stat_aon: "Awaiting Aon response",
      stat_client: "Awaiting client response",
      filter_aon: "To handle by Aon ({{count}})",
      filter_client: "Awaiting client ({{count}})",
      filter_all: "All ({{count}})",
      empty_title: "Nothing pending",
      empty_description: "All conversations in this filter have received a response. Great work.",
      list_title_one: "{{count}} conversation",
      list_title_other: "{{count}} conversations",
      channel_salarie_production: "Employee ↔ Production",
      channel_drh_chefprojet: "HR ↔ Project manager",
      awaiting_aon: "Aon team must respond",
      awaiting_client: "Awaiting client response",
      no_subject: "Conversation without subject",
      waiting_less_than_hour: "less than an hour",
      waiting_hours: "{{count}} h",
      waiting_days_one: "{{count}} day",
      waiting_days_other: "{{count}} days",
      waiting_since: "Unanswered for {{when}}",
      open: "Open",
    },
  },
  aon: {
    anomalies: {
      kicker: "Aon team",
      title: "Anomaly library",
      description:
        "Reusable career-anomaly sheets: explanation for the employee, recommended action and documents to request. Automatically matched with anomalies detected by the career audit.",
      ia_hint:
        "Active sheets feed the Noa analysis as a knowledge base: the AI reuses the wording validated here instead of improvising.",
      new_fiche: "New sheet",
      catalogue: "Sheets",
      empty: "No anomaly sheet.",
      badge_inactive: "Inactive",
      aria_edit: "Edit",
      aria_delete: "Delete",
      dialog_title_new: "New anomaly sheet",
      dialog_title_edit: "Edit anomaly sheet",
      field_label: "Label",
      field_label_placeholder: "E.g.: Unexplained drop in earnings",
      field_code: "Code",
      field_code_hint:
        "Use the audit engine code (baisseRevenu, revenuNul…) for automatic matching; free text otherwise.",
      field_position: "Position",
      field_explication: "Explanation for the employee",
      field_explication_placeholder:
        "Explain the anomaly in plain language, as it will be presented to the employee.",
      field_recommandation: "Recommended action",
      field_recommandation_placeholder: "Validated steps to follow to fix the anomaly.",
      field_pieces: "Documents to request",
      field_pieces_placeholder:
        "Supporting documents to request from the employee (pay slips, certificates…).",
      translations_title: "Translations (EN / ES)",
      translations_hint:
        "Optional: content shown according to the employee's language. French is used as fallback.",
      field_label_tr: "Translated label",
      field_explication_tr: "Translated explanation",
      field_recommandation_tr: "Translated recommendation",
      field_pieces_tr: "Translated documents",
      check_active: "Active sheet (offered to consultants and to the AI analysis)",
      delete_title: "Delete sheet",
      delete_description:
        "Delete “{{label}}”? The sheet will no longer be offered nor used by the AI analysis.",
      frequency_title: "Most frequent anomalies",
      frequency_hint:
        "Consolidated view across all files: anomalies detected by the career audit and anomalies declared by consultants.",
      frequency_count_one: "{{count}} file",
      frequency_count_other: "{{count}} files",
    },
    alertes: {
      title: "Automatic alerts & Agirc-Arrco points",
      description:
        "Signals computed from the record, income and profile: qualify them, then push to the anomalies & vigilance register when relevant.",
      points_title: "Agirc-Arrco points by year",
      points_drops: "{{count}} drop(s)",
      points_empty: "No points series in the last imported record.",
      points_unit: "points",
      drop_tooltip: "−{{pct}}% vs {{prev}} pts the previous year",
      table_year: "Year",
      table_points: "Points earned",
      table_diff: "Change (points)",
      table_diff_pct: "Change (%)",
      table_flag: "Signal",
      table_drop: "Drop",
      table_expand: "Show the previous {{count}} years",
      table_collapse: "Collapse the table",
      list_title: "Alerts",
      empty: "No automatic alert on this file.",
      tracked: "In register",
      add_to_registre: "Add to register",
      niveau_info: "Info",
      niveau_important: "Important",
      niveau_critique: "Critical",
      code_service_militaire_absent: "National service declared but missing from the record",
      msg_service_militaire_absent:
        "The employee declares national service; no military period appears on the RIS. Request the service certificate and the regularisation.",
      code_service_militaire_dates: "National service dates differ",
      msg_service_militaire_dates:
        "Declared: {{declare}} — record: {{ris}}. Check the period retained by the fund.",
      code_baisse_revenu: "Income drop of at least 30%",
      msg_baisse_revenu:
        "{{count}} year(s) show an income at least 30% below the previous year. Qualify the cause (unemployment, part time, illness…) and check assimilated quarters.",
      code_revenu_nul: "Year(s) without income mid-career",
      msg_revenu_nul:
        "{{count}} year(s) without any declared income while the career is under way. Quarters and points of the period to check.",
      code_baisse_points: "Agirc-Arrco points drop",
      code_points_salaire: "Points and salary: check the difference",
      msg_points_salaire:
        "In {{annee}}, the statement shows {{points}} points versus an indicative {{attendu}} points using the declared salary and the annual standard rates. Check the contribution base, prorated ceilings, employer rates and special periods with the scheme. This check does not establish missing entitlements.",
      msg_baisse_points:
        "{{count}} year(s) with at least half the points of the previous year (e.g. {{exemple}}). Check the employer's declaration and the contribution scheme.",
      code_points_sans_trimestre: "Supplementary points without basic quarters",
      msg_points_sans_trimestre:
        "{{count}} year(s) credit Agirc-Arrco points without any validated quarter in the basic scheme: paid work exists, the CNAV must be regularised.",
      code_trimestres_sans_points: "Validated quarters without supplementary points",
      msg_trimestres_sans_points:
        "{{count}} year(s) validate 4 quarters without any Agirc-Arrco point while neighbouring years have some. Check the employer's supplementary affiliation.",
      code_creux_carriere: "Years without information on the record",
      msg_creux_carriere:
        "{{count}} year(s) without any period between the start and the end of the known career. Ask the employee what they were doing (studies, abroad, undeclared work…).",
      code_arret_maladie: "Sick leave / disability to check",
      msg_arret_maladie:
        "{{count}} illness period(s) detected (or long sick leave declared). Check that assimilated quarters and free points were credited.",
      code_chomage: "Unemployment periods to check",
      msg_chomage:
        "{{count}} unemployment period(s) on the record. Check assimilated quarters (compensated or not) and Agirc-Arrco points granted.",
      code_expatriation: "Career abroad",
      msg_expatriation:
        "{{count}} expatriation period(s) or non-CFE expatriation declared. Check bilateral agreements, periods to validate and the lead time to obtain foreign records.",
      code_temps_partiel_recent: "Recent drop: part time?",
      msg_temps_partiel_recent:
        "{{count}} year(s) since 2023 below the 2022 level (uncapped income). Ask the employee whether they work part time, since when, and their pension contribution level.",
      code_carriere_longue_potentielle: "Potential long career not declared",
      msg_carriere_longue_potentielle:
        "Started working at {{age}}: the long-career scheme may allow early retirement. To investigate (contributed quarters before 16, 18, 20 or 21).",
      code_majoration_enfants: "Child bonus quarters",
      msg_majoration_enfants:
        "{{count}} child(ren) declared: check that bonus quarters (maternity / education, adoption, disabled child) appear on the record.",
      code_trimestres_manquants_faibles: "Full rate within reach",
      msg_trimestres_manquants_faibles:
        "Only {{count}} quarter(s) missing for the full rate: a few months of work or a targeted buy-back are enough.",
      code_taux_plein_atteint: "Full rate already reached",
      msg_taux_plein_atteint:
        "The natural full-rate date ({{date}}) is past: the employee can leave whenever they wish; check the surcharge.",
      code_age_legal_proche: "Legal age within a year, file incomplete",
      msg_age_legal_proche:
        "The employee is {{age}} and the file is not complete: the restitution must be scheduled quickly to leave time for the formalities.",
      code_depart_anticipe_dispositif: "Early retirement scheme to investigate",
      msg_depart_anticipe_dispositif:
        "Declared exposure ({{dispositif}}): check the rights opened (C2P points, asbestos allowance) and their impact on the departure date.",
    },
    droits: {
      title: "Recovered rights",
      description:
        "Bought-back or gained quarters, recovered Agirc-Arrco points: what the analysis achieved, with regularisation tracking. Aggregated in the HR reporting.",
      total_trimestres: "Quarters obtained",
      total_points: "Agirc-Arrco points obtained",
      empty: "No recovered right recorded.",
      statut_label: "Status",
      statut_identifie: "Identified",
      statut_demande: "Requested",
      statut_obtenu: "Obtained",
      nature_trimestres_rachetes: "Bought-back quarters",
      nature_trimestres_gagnes: "Gained quarters",
      nature_points_agirc_arrco: "Agirc-Arrco points",
      nature_autre: "Other right",
      field_nature: "Nature",
      field_quantite: "Quantity",
      field_annee: "Year",
      field_comment: "Comment",
      field_comment_placeholder: "E.g.: 2004 period regularised with the CNAV",
      field_motif: "Reason",
      motif_service_national: "National service",
      motif_activite_salariee: "Salaried employment",
      motif_chomage: "Unemployment",
      motif_enfant_handicape: "Disabled child",
      motif_maternite: "Maternity",
      motif_autre: "Other",
      motif_non_renseigne: "Not provided",
      field_gain: "Estimated annual gain (€/yr)",
      total_gain: "Estimated annual gain (obtained)",
      gain_format: "{{value}} €/yr",
      proposals_title: "Suggestions from career alerts",
      proposal_use: "Use",
      proposal_comment_prefix: "Suggestion: ",
      completion_a_confirmer: "To be confirmed",
      completion_saisis: "Confirmed: rights entered",
      completion_aucun: "Confirmed: no rights recovered",
      completion_at: "Confirmed on {{date}} by {{auteur}}",
      confirm_saisis: "Confirm the rights entered",
      confirm_aucun: "No rights recovered",
      completion_cancel: "Cancel the confirmation",
      completion_hint:
        "Confirmation is required before closing the case: state whether rights were entered or confirm that no rights were recovered.",
      qty_trimestres: "{{count}} quarter(s)",
      qty_points: "{{value}} points",
    },
    surcotisation: {
      title: "Employer extra contributions",
      description:
        "When the employer paid contributions above the standard rate for this employee over a period (for example a top-up on the supplementary scheme), enter the rates actually paid here: they are sent to the calculation engine for that period and increase the supplementary pension. Mentioned in the BRI.",
      empty: "No extra contribution recorded on this file.",
      add: "Add an extra contribution",
      field_period: "Career period",
      field_period_placeholder: "Choose a period",
      period_hint:
        "Past years are already recorded on the Agirc-Arrco points statement: what the employer paid is already counted there. The extra contribution applies to the current period, until retirement.",
      no_effect: "No effect on the calculation (past period)",
      field_caisse: "Fund",
      field_taux_ta: "Bracket A rate (%)",
      field_taux_tb: "Bracket B rate (%)",
      field_taux_tc: "Bracket C rate (%)",
      field_taux_activite: "Activity rate (%)",
      field_type_taux: "Rate type (optional)",
      type_taux_contractuel: "Contractual rates (scheme scale)",
      type_taux_appele: "Called rates (actually paid, top-up included)",
      type_taux_hint:
        "Contractual rate (recommended): the rate that generates points. Called rate: the rate actually levied, including the call coefficient; the engine derives fewer points from it.",
      field_comment: "Comment",
      field_comment_placeholder: "E.g.: employer top-up on bracket B from 2010 to 2015",
      rates_hint:
        "Rates as a percentage of the bracket's salary. Indicative contractual scale for a manager: bracket A 6.2 %, brackets B and C 17 % (engine lists: A from 6.2 to 8 %, B from 17 to 20 %).",
      caisse_AGIRC_ARRCO: "Agirc-Arrco",
      caisse_ARRCO: "Arrco",
      caisse_AGIRC: "Agirc (bracket B)",
      caisse_AGIRCTC: "Agirc (bracket C)",
      caisse_MSA_RCO: "MSA supplementary scheme",
      delete_confirm:
        "Delete this extra contribution? The next calculation will no longer take it into account.",
    },
    vigilance: {
      title: "Anomalies & watchpoints",
      description:
        "Single register of the file's anomalies, whatever their origin (automatic audit, consultant entry): lifecycle, comment and selection of what goes into the BRI.",
      empty:
        "No anomaly detected or declared. Run the career audit from the journey to feed this register.",
      source_audit: "Automatic audit",
      source_consultant: "Consultant",
      statut_label: "Status",
      statut_a_traiter: "To handle",
      statut_en_cours: "In progress",
      statut_ecartee: "Dismissed",
      statut_resolue: "Resolved",
      include_bri: "Include in the BRI",
      comment_placeholder: "Comment (who, what, why)…",
      field_titre: "New anomaly (free entry)",
      field_titre_placeholder: "E.g.: 2012 salary not reported by employer X",
      field_comment: "Comment",
      field_comment_placeholder: "Optional details…",
      bri_hint:
        "The BRI “Attention points” page lists the anomalies ticked “Include in the BRI”; a dismissed or resolved anomaly is removed automatically.",
    },
    points_attention: {
      title: "Attention points",
      description:
        "Points brought to the employee's attention by the consultant: title, text, importance level and display order. A dedicated page is added to the BRI only if points are selected.",
      empty: "No attention point selected: the BRI will not include a dedicated page.",
      preview_show: "Preview rendering",
      preview_hide: "Hide preview",
      preview_title_a: "Your attention",
      preview_title_b: " points",
      field_model: "Reuse a template from the library",
      model_none: "— Free entry —",
      field_niveau: "Importance level",
      niveau_info: "Note",
      niveau_important: "Important",
      niveau_critique: "Priority",
      field_titre: "Title",
      field_titre_placeholder: "E.g.: Regularise year 2015 with the CNAV",
      field_texte: "Text",
      field_texte_placeholder:
        "Write the point as it will appear in the BRI given to the employee.",
      add: "Add to file",
      save_model: "Save as template",
      saved_model: "Template saved",
      move_up: "Move up",
      move_down: "Move down",
      bri_hint:
        "The BRI “Attention points” page lists these points in the order above, strictly following the document template (logo, header, colours).",
    },
    trimestres: {
      title: "Missing & recovered quarters",
      description:
        "Quarters missing for the full rate according to the latest calculation, and recoverable quarters identified by the consultant (included in the BRI).",
      missing_label: "Missing quarters (full rate)",
      missing_no_calc: "No calculation available: run a calculation from the journey.",
      recovered_label: "Recoverable quarters recorded",
      empty: "No recoverable quarter recorded for this file.",
      field_motif: "Reason",
      field_nb: "Number",
      field_comment: "Comment",
      field_comment_placeholder: "RIS reference, period concerned…",
      motif_periode_salariee: "Unreported salaried period",
      motif_periode_chomage: "Unemployment period",
      motif_enfant_handicap: "Disabled child",
      motif_etranger: "Period abroad",
      motif_service_national: "National service",
      motif_autre: "Other reason",
      bri_hint:
        "These quarters are included in the “Points of attention” page of the generated BRI.",
    },
    vip: {
      answers_title: "VIP complementary questions",
      answers_desc: "Plans declared by the employee in their journey.",
      answers_empty: "Questionnaire not completed",
      answers_empty_desc:
        "The employee has not answered the complementary questions of their journey yet.",
    },
    tranche_c: {
      title: "Bracket C arbitrage and ROI",
      desc: "Deterministic calculation: contribution cost, resulting annuity and break-even point.",
      computed_at: "Computed on {{date}}",
      salaire: "Bracket C base (€/year)",
      taux: "Contribution rate (%)",
      annees: "Years of contribution",
      points: "Estimated points acquired",
      valeur_point: "Point value",
      esperance: "Payout duration (years)",
      out_cout: "Total cost",
      out_rente: "Annual annuity",
      out_roi_annees: "Break-even",
      out_ratio: "Annuity / cost ratio",
      years: "{{value}} years",
      verdict_favorable: "Favourable: the annuity received clearly exceeds the cost.",
      verdict_neutre: "Break-even: the annuity roughly offsets the cost.",
      verdict_defavorable: "Unfavourable: the cost is not amortised over the selected duration.",
      verdict_inconnu: "Complete the parameters to get an arbitrage.",
      rachat_title: "Comparison with a quarter buyback",
      rachat_unit_hint: "Current scale: about {{cost}} per quarter (rate-only option).",
      rachat_no_bareme: "No usable buyback scale for this file.",
      rachat_cout: "Total buyback cost (€)",
      rachat_gain: "Net monthly gain (€)",
      rachat_roi: "Buyback break-even",
      commentaire: "Consultant comment",
      commentaire_placeholder: "Assumptions used, points to watch…",
      note: "These amounts are estimates based on the parameters entered. They feed the summary written by Noa, which recalculates nothing.",
      save: "Save arbitrage",
      saved: "Arbitrage saved.",
      save_failed: "Could not save.",
    },
    scenario_comparison: {
      title: "Comparative scenario analysis",
      desc: "Net monthly pension gaps compared with the reference scenario ({{reference}}).",
      empty: "Not enough calculated scenarios",
      empty_desc: "Run a calculation with at least two scenarios to get the comparison.",
      col_scenario: "Scenario",
      col_date: "Retirement",
      col_age: "Age",
      col_trimestres: "Quarters",
      col_net: "Net pension",
      col_delta: "Gap",
      age_value: "{{age}} years",
      reference: "Reference",
      delta_hint:
        "Difference between this simulation and the reference estimate, in monthly net pension (reference {{ref}}, simulation {{sim}}).",
    },
    dashboard: {
      kicker_pilot: "Aon steering",
      kicker_production: "Aon production",
      greeting: "Hello {{name}}",
      desc_pilot: "BRI operations and production team steering.",
      desc_production: "Overview of your BRI file portfolio.",
      my_portfolio: "My portfolio",
      stat_my_dossiers: "My files",
      stat_accessible: "Out of {{count}} accessible",
      stat_to_complete: "To complete",
      stat_to_complete_hint: "Waiting for employee or me",
      stat_to_validate: "To validate (N1)",
      stat_to_validate_hint: "Quality check before calculation",
      stat_to_restitute: "To deliver",
      stat_to_restitute_hint: "BRI ready, awaiting employee meeting",
      immediate_actions: "Files requiring immediate action",
      view_all_dossiers: "View all my files",
      up_to_date: "You're all caught up",
      restitution_badge: "Restitution",
      no_action_needed: "No file requires immediate action from you.",
      quick_links: "Quick links",
      link_dossiers: "All my files",
      link_dossiers_desc: "Filterable list of files I manage.",
      link_agenda: "My calendar",
      link_agenda_desc: "My upcoming debrief appointments.",
      link_library: "Library",
      link_library_desc: "BRI templates, letters, training materials.",
    },
    chef_projet: {
      kicker: "Project manager steering",
      title: "Operation tracking",
      stat_to_dispatch: "To dispatch",
      stat_to_dispatch_hint: "Files without a consultant",
      stat_n2: "N2 review",
      stat_n2_hint: "N1 validated, awaiting review",
      stat_avg_time: "Avg. production time",
      stat_avg_time_hint: "Days from start to delivery",
      stat_completion: "Completion rate",
      stat_completion_hint: "Completed files / total",
      to_assign_title: "Files to dispatch",
      to_assign_empty: "All files are assigned",
      to_assign_empty_desc: "No file is waiting to be assigned to a consultant.",
      n2_title: "N2 review",
      n2_empty: "No files awaiting N2 review",
      n2_empty_desc: "All quality checks are up to date.",
      workload_title: "Team workload",
      workload_empty: "No active consultants",
      workload_empty_desc: "No consultant has any assigned files at the moment.",
      workload_dossiers: "active files",
      workload_desc: "Active files per consultant — adjust distribution as needed.",
      view_all: "View all",
    },
    dossiers: {
      kicker: "Aon production",
      title: "My files",
      description: "Filterable list of all your BRI files.",
      search_placeholder: "Search for a file…",
      no_dossiers: "No files found.",
      filter_status: "Status",
      filter_operation: "Operation",
      filter_societe: "Company",
      take_over: "Take over",
      reassign: "Reassign",
      assign_self: "Assign to me",
      assign_other: "Assign to a consultant…",
    },
    equipe: {
      kicker: "Aon space",
      title: "My team",
      description: "Consultants and project managers in your scope.",
      invite: "Invite a consultant",
      success_prefix: "Invitation sent to",
      success_suffix: "The person will receive an email to activate their account.",
      close: "Close",
      button_invite: "Invite a consultant",
      stat_active: "Active consultants",
      stat_active_dossiers: "Active files",
      stat_avg_time: "Average file time",
      stat_avg_time_hint_with_count: "on {{count}} delivered file(s)",
      stat_avg_time_hint_none: "no measurable delivered file",
      stat_invitations: "Pending invitations",
      section_consultants: "Production consultants",
      consultants_description:
        "Current workload, control status and average production time per consultant (file submission → BRI delivered). The N1 badge highlights files waiting for self-check.",
      empty_title: "No consultant",
      empty_desc: "Invite production consultants to start your team.",
      empty_action: "Invite",
      section_invitations: "Pending invitations",
      invitations_desc: "These people have not activated their account yet.",
      revoke_title: "Revoke this invitation",
      revoke_desc: "The invitation sent to {{email}} will be cancelled.",
      revoke_confirm: "Revoke",
      revoke_footer:
        "The person will no longer be able to create their account with this link. You can send a new one later.",
      expired: "Expired",
      invited_at: "Invited {{date}}",
      n1_label: "N1: {{count}}",
      n2_label: "N2: {{count}}",
      relecture_label: "{{count}} in review",
      restitution_label: "{{count}} in restitution",
      active_suffix: "active",
      delivered_suffix: "delivered",
      avg_time_suffix: "d / file",
      avg_time_title: "Average production time (submission → BRI delivered)",
    },
    revue: {
      kicker: "Aon production",
      title: "Quality review",
      description:
        "Two-level file review: N1 (peer to peer review by production) then N2 (final project manager validation). Validate N2 directly from the queue to unlock BRI generation.",
      stat_to_dispatch: "To dispatch",
      stat_to_dispatch_hint: "Files without a consultant",
      stat_n1: "Awaiting N1",
      stat_n1_hint: "Production peer review",
      stat_n2: "To review N2",
      stat_n2_hint: "N1 validated, waiting for you",
      stat_avg_time: "Average production time",
      stat_avg_time_value: "{{days}} d",
      stat_avg_time_hint_with_count: "Across {{count}} delivered files",
      stat_avg_time_hint_none: "No delivered file yet",
      to_dispatch_title: "To dispatch",
      to_dispatch_desc: "Files submitted without an assigned consultant.",
      to_dispatch_empty_title: "All assigned",
      to_dispatch_empty_desc: "No file awaiting assignment.",
      n1_title: "Awaiting: Level 1 (peer review)",
      n1_desc:
        "Peer to peer review: to be done by a production peer, not by the assigned consultant.",
      n1_empty_title: "Nothing pending",
      n1_empty_desc: "No file awaiting N1 review.",
      n2_title: "To review: Level 2",
      n2_desc: "N1 validated by production, waiting for your final review.",
      n2_empty_title: "Up to date",
      n2_empty_desc: "No file awaiting N2 review.",
      validated_title: "Validated N2 (review complete)",
      validated_desc: "Files already reviewed, hidden from queues. Shown on request.",
      validated_empty_title: "No validated file",
      validated_empty_desc: "No N2 review has been validated yet.",
      submitted_label: "Submitted",
      n1_ok_label: "N1 ok",
      validated_label: "Validated",
      select_all: "Select all",
      deselect_all: "Deselect all",
      action_assign: "Assign",
      validate_n2: "Validate N2",
      validate_n2_error: "Failed, please retry",
      consultant_label: "Production consultant",
      reviewer_label: "Review consultant",
      restitution_consultant_label: "Restitution consultant",
      restitution_same_as_production: "Same as the production consultant",
      chef_projet_label: "Project manager",
      keep_unchanged: "— Do not change —",
      empty_consultants: "No active consultant",
      empty_chefs: "No active project manager",
      clear_selection: "Clear",
      assign: "Assign",
      bulk_assign: "Assign selection",
      bulk_assign_desc_one: "{{count}} file will be assigned.",
      bulk_assign_desc_other: "{{count}} files will be assigned.",
      confirm_assign: "Confirm assignment",
      selected_count_one: "{{count}} file selected",
      selected_count_other: "{{count}} files selected",
      dossier_count_one: "{{count}} file",
      dossier_count_other: "{{count}} files",
      role_admin: "Admin",
      role_chef_projet: "Project manager",
      consultant_assigned: "Consultant: {{name}}",
      unassigned: "Unassigned",
      badge_autonome: "Self-service journey",
      select_dossier_aria: "Select file of {{name}}",
      open_dossier_title: "Open file",
      pagination_unit: "files",
      export_excel: "Export (Excel)",
      sheet_consultants: "Consultants",
      times_title: "Production time per consultant",
      times_desc: "Days between file submission and the delivery appointment, per consultant.",
      times_empty_title: "No measure available",
      times_empty_desc: "No submitted file with a scheduled delivery appointment yet.",
      times_col_consultant: "Consultant",
      times_col_dossiers: "Files",
      times_col_mesures: "Measured",
      times_col_avg: "Average time",
      times_col_min: "Min",
      times_col_max: "Max",
      export_col_salarie: "Employee",
      export_col_matricule: "Employee ID",
      export_col_operation: "Operation",
      export_col_statut: "Status",
      export_col_consultant: "Consultant",
      export_col_soumis: "Submitted on",
      export_col_n1_at: "N1 validated on",
      export_col_n1_par: "N1 validated by",
      export_col_n2_at: "N2 validated on",
      export_col_n2_par: "N2 validated by",
      export_col_rdv: "Delivery appointment",
      export_col_days: "Production time (days)",
    },
    relances: {
      kicker: "Aon space",
      title: "Follow-ups",
      description: "Email and phone follow-up tracking with employees.",
      channel_email: "Email",
      channel_phone: "Phone",
      outcome_repondu: "Answered",
      outcome_pas_de_reponse: "No answer",
      outcome_message_laisse: "Message left",
      outcome_a_rappeler: "Call back",
      outcome_refus: "Refused",
      outcome_injoignable: "Unreachable",
      next_relance: "Next follow-up",
      auto_settings: "Automatic follow-ups",
      auto_enabled: "Enable automatic follow-ups",
      first_after: "First follow-up after",
      followup_interval: "Interval between follow-ups",
      max_relances: "Maximum number of follow-ups",
      target_statuses: "Target statuses",
      template: "Email template",
      dry_run: "Preview (dry run)",
      run_now: "Run now",
      last_run: "Last run",
      auto_badge: "Auto",
    },
    calendrier: {
      kicker: "Aon space",
      title: "My calendar",
      description: "Debrief appointments and availability.",
      no_appointments: "No appointments scheduled.",
      add_availability: "Add availability",
    },
    agenda: {
      kicker: "Aon steering",
      title: "Agenda & appointments",
      description: "Manage your open slots and BRI debrief appointments.",
      add_slot: "Add a slot",
      stat_open: "Open slots",
      stat_booked: "Booked slots",
      stat_upcoming: "Upcoming appointments",
      appointments_title: "My upcoming appointments",
      no_appointment_title: "No appointment scheduled",
      no_appointment_desc: "Open slots so employees can book an appointment with you.",
      slots_title: "My slots",
      scope_upcoming: "Upcoming",
      scope_past: "Past",
      slots_count: "{{count}} slots",
      pagination_page: "Page {{page}} of {{total}}",
      pagination_previous: "Previous",
      pagination_next: "Next",
      empty_past_title: "No past slots",
      empty_upcoming_title: "No open slots",
      empty_past_desc: "Your past slots will appear here.",
      empty_upcoming_desc: "Add slots to make your calendar visible to employees.",
      cancel_title: "Cancel this appointment",
      cancel_desc: "Appointment with {{name}} on {{date}}.",
      cancel_confirm: "Cancel appointment",
      cancel_footer:
        "The related slot becomes available again. The employee and the consultant receive the cancellation in their calendar.",
      action_done: "Done",
      action_no_show: "No-show",
      action_cancel: "Cancel",
      meeting_link: "Meeting link",
      slot_reserved: "Booked",
      slot_open: "Free",
      delete_slot_tooltip: "Cancel the appointment first to release this slot",
      delete_slot_action: "Delete",
      detail_title: "Slot detail",
      detail_start: "Start",
      detail_end: "End",
      detail_duration: "Duration",
      detail_channel: "Channel",
      detail_status: "Status",
      detail_created: "Created on",
      appointment_section: "Associated appointment",
      unknown_company: "Unknown company",
      detail_matricule: "Employee ID",
      detail_email: "Email",
      detail_video_link: "Video link",
      join_meeting: "Join",
      detail_phone: "Phone",
      notes_consultant: "Consultant notes",
      open_dossier: "Open dossier",
      missing_appointment: "Slot marked as booked, but no appointment was found.",
      unknown_employee: "Unknown employee",
      channel_teams: "Video conference (Teams)",
      channel_teams_short: "Video",
      channel_telephone: "Phone",
      channel_presentiel: "In person",
      channel_default: "{{channel}}",
      status_propose: "Proposed",
      status_planifie: "Scheduled",
      status_realise: "Done",
      status_annule: "Cancelled",
      status_no_show: "No-show",
      duration_min: "{{minutes}} min",
      duration_h: "{{hours}} h",
      duration_h_min: "{{hours}} h {{minutes}} min",
      format_range_separator: " · ",
      format_range_arrow: " → ",
      cal: {
        title: "Calendar",
        title_for: "{{name}}'s calendar",
        title_team: "Team calendar",
        view_week: "Week",
        view_month: "Month",
        previous: "Previous period",
        next: "Next period",
        today: "Today",
        more: "+{{count}}",
      },
      feed: {
        title: "Calendar subscription: {{name}}",
        you: "you",
        team: "the team",
        desc: "Get appointments in Outlook or your calendar app, read-only. The link contains a revocable secret token.",
        active_since: "Link active since {{date}}",
        last_sync: "last synced on {{date}}",
        never_synced: "never synced",
        create: "Create subscription link",
        regenerate: "Regenerate link",
        revoke: "Revoke",
        shown_once: "Copy this link now: it will not be shown again.",
        share_warning:
          "This link gives access to employee names and appointment times: do not share it.",
        copy: "Copy",
        copied: "Copied",
        subscribe_outlook: "Subscribe in Outlook",
        open_calendar_app: "Open in calendar app",
        refresh_hint: "Outlook refreshes subscriptions at its own pace (up to a few hours).",
        hide_link: "Hide the link",
        regen_title: "Regenerate the subscription link",
        regen_desc: "The previous link will stop working immediately.",
        revoke_title: "Revoke the subscription link",
        revoke_desc: "The link will stop working immediately. This action is final.",
        cal_name: "NOA: calendar of {{name}}",
      },
      tabs_label: "Agenda view",
      tab_mine: "My agenda",
      tab_team: "All agendas",
      team: {
        stat_open: "Open slots (30 d)",
        stat_booked: "Booked slots (30 d)",
        stat_upcoming: "Upcoming appointments (30 d)",
        consultants_title: "Consultants' agendas",
        consultants_desc:
          "Over the next 30 days. Select a consultant to see their slots and filter their appointments.",
        no_consultant_title: "No consultant",
        no_consultant_desc: "No consultant account is active in the team yet.",
        all_consultants: "Whole team",
        all_consultants_meta: "{{count}} consultants",
        next_at: "Next appointment: {{date}}",
        no_upcoming: "No upcoming appointment",
        col_open: "Open",
        col_booked: "Booked",
        col_upcoming: "Appts",
        slots_title: "{{name}}'s slots",
        no_slot_title: "No upcoming slot",
        no_slot_desc: "This consultant has not opened any slot for the coming weeks.",
        appointments_title: "Upcoming appointments — whole team",
        appointments_title_for: "Upcoming appointments — {{name}}",
        appointments_desc:
          "Cancelling an appointment frees the slot and notifies the employee and the consultant (calendar cancellation).",
        no_appointment_title: "No appointment scheduled",
        no_appointment_desc: "Appointments scheduled by the team will appear here.",
        with_consultant: "with {{name}}",
        cancel_action: "Cancel",
        cancel_title: "Cancel this appointment",
        cancel_desc: "Appointment of {{name}} with {{consultant}}, on {{date}}.",
        cancel_confirm: "Cancel the appointment",
        cancel_reason_label: "Reason (sent to the employee and the consultant)",
        cancel_reason_placeholder: "E.g.: consultant unavailable, we will offer a new date.",
        cancel_footer:
          "The slot becomes available again. Both parties receive an email with the event cancellation for their calendar.",
      },
      drawer: {
        title: "Add a slot",
        description: "Open your calendar so employees can book an appointment.",
        single_tab: "Single slot",
        bulk_tab: "Bulk generation",
        date_label: "Date",
        start_time_label: "Start time",
        end_time_label: "End time",
        modality_label: "Modality",
        cancel_button: "Cancel",
        create_slot_button: "Create slot",
        from_date_label: "From",
        to_date_label: "Until",
        weekdays_label: "Weekdays",
        slots_per_day_label: "Slots per day",
        add_time_slot: "Add a time slot",
        bulk_preview: "<strong>{{count}}</strong> slot{{plural}} will be created",
        bulk_preview_dates: " (from {{start}} to {{end}})",
        bulk_generate_button: "Generate {{count}} slot{{plural}}",
        error_invalid_datetime: "Invalid date or time.",
        error_end_after_start: "End time must be after start time.",
        error_future: "The slot must be in the future.",
        error_no_slots: "No slots will be generated with these settings.",
        error_too_many_slots: "Too many slots to generate ({{count}}). Limit to 200.",
        operation_label: "Operation",
        operation_all: "All operations",
        operation_hint_all:
          "Slot open to all your files. Pick an operation to reserve it for its employees and apply its appointment length.",
        operation_hint_selected:
          "Slot reserved for this operation's employees — appointment length: {{minutes}} min.",
        end_time_locked: "End time computed: {{minutes}} min length set by the operation.",
        ranges_per_day_label: "Time ranges per day",
        ranges_hint: "Each range is split into {{minutes}}-minute slots.",
        error_unknown: "Unknown error",
      },
    },
    pilotage: {
      kicker: "Aon steering",
      title: "Operation steering",
      description:
        "Production activity overview: active files, two-level quality control, follow-up reminders and team workload.",
      section_summary: "Summary",
      stat_active: "Active files",
      stat_active_hint: "{{count}} delivered files",
      stat_to_complete: "To complete",
      stat_to_complete_hint: "Waiting for employee or production",
      stat_to_relance: "To follow up",
      stat_to_relance_hint: "{{count}} never followed up",
      stat_avg_time: "Average production time",
      stat_avg_time_hint_with_count: "Based on {{count}} delivered files",
      stat_avg_time_hint_none: "No delivered file",
      stat_avg_time_suffix: "d",
      section_review: "Control and review",
      section_sorties: "Exits and contact refusals",
      stat_sorties: "Closed accounts",
      stat_sorties_hint: "Exit date and reason recorded",
      stat_sorties_retraite: "Retirements",
      stat_sorties_retraite_hint: "Voluntary and employer-initiated",
      stat_refus_contact: "Contact refusals",
      stat_refus_contact_hint: "Excluded from manual and automatic reminders",
      review_link: "Open quality review",
      queue_to_assign: "To dispatch",
      queue_to_assign_desc: "Submitted files with no consultant assigned.",
      queue_n1: "Waiting for N1",
      queue_n1_desc: "Self-check by production.",
      queue_n2: "N2 to control",
      queue_n2_desc: "N1 validated, final project manager control.",
      section_relances: "Follow-up tracking",
      relances_desc: "Latest follow-ups by the production team.",
      relances_manage: "Manage",
      relance_to_relance: "To follow up",
      relance_this_month: "This month",
      relance_never: "Never followed up",
      relances_empty_title: "No recent follow-up",
      relances_empty_desc: "Follow-ups recorded will appear here.",
      relance_default_note: "Follow-up recorded",
      section_workload: "Team workload",
      workload_desc: "{{occupied}}/{{total}} consultants busy",
      workload_team: "Team",
      workload_empty_title: "No consultant",
      workload_empty_desc: "Invite production consultants to get started.",
      workload_n2: "N2: {{count}}",
      time_since_today: "today",
      time_since_days: "{{count}}d ago",
      time_since_weeks: "{{count}}w ago",
      time_since_months: "{{count}}mo ago",
    },
    library: {
      kicker: "Aon resources",
      title: "Library",
      subtitle: "Production methods, technical references and training materials for Aon teams.",
    },
  },
  shareLevel: {
    none: "Sharing: none",
    date_only: "Sharing: full-rate date",
    full: "Sharing: full BRI",
  },
  drh: {
    partage: {
      kicker: "HR space · File",
      title: "Retirement file",
      description: "What the employee chose to share with your company.",
      back: "Back to the employee list",
      error_title: "File unavailable",
      error_desc: "This file does not exist or is outside your perimeter.",
      status_label: "File status",
      submitted: "Submitted on {{date}}",
      restituted: "Delivered on {{date}}",
      none_title: "The employee has not authorized the sharing of their results.",
      none_body:
        "You can only see the status of their file. The employee can change their choice at any time from their space.",
      taux_plein_label: "Full-rate retirement",
      age_at: "At age {{age}}",
      age_years: "{{count}} year",
      age_years_other: "{{count}} years",
      age_months: "{{count}} months",
      synthese_label: "Results summary",
      kv_premiere_date: "Earliest possible retirement date",
      kv_age_premiere_date: "Age at earliest date",
      kv_pension_brute: "Gross monthly pension",
      kv_pension_nette: "Net monthly pension",
      kv_trimestres: "Validated quarters",
      trimestres_value: "{{valides}} validated, {{manquants}} missing",
      kv_points: "Agirc-Arrco points",
      bris_label: "BRI documents released to the employee",
      bris_empty: "No BRI has been released yet.",
      bri_name: "Individual retirement review, version {{version}}",
      bri_released: "Released on {{date}}",
      bri_download: "Download",
      help: "The sharing level is chosen by the employee, within the limits set by their group. Only the Aon team sees the full file contents.",
    },
    dashboard: {
      kicker: "HR space · Steering",
      title: "HR dashboard",
      description: "Steering the BRI campaign for your scope.",
      scope_badge: "You only see data from your scope.",
      stat_salaries: "Covered employees",
      stat_salaries_hint: "{{count}} with a file",
      stat_dossiers: "Active files",
      stat_dossiers_hint: "{{count}} delivered",
      stat_completion: "Completion rate",
      stat_restitutions: "Upcoming debriefs",
      stat_restitutions_hint: "{{count}} in the next 30 days",
      stat_urgents: "Urgent files",
      stat_urgents_hint: "Flagged as priority in your scope",
      badge_urgent: "Urgent",
      distribution_title: "File distribution",
      distribution_over: "Out of {{count}} files",
      funnel_completion: "Completion",
      funnel_production: "Production",
      funnel_restitution: "Debrief",
      funnel_delivered: "Delivered",
      contacts_title: "My Aon contacts",
      contacts_desc:
        "Aon project managers in charge of your operations. Click to start or resume a conversation.",
      contact_role: "Project manager",
      contact_chat: "Chat",
      upcoming_title: "Upcoming debriefs",
      upcoming_desc: "Next appointments in your scope",
      upcoming_empty_title: "No debrief scheduled",
      upcoming_empty_desc: "Debrief appointments will appear here once booked.",
      unknown_salarie: "(unknown employee)",
      with: "with {{name}}",
      recent_title: "Recent activity",
      see_all: "View all",
      recent_empty_title: "No file",
      recent_empty_desc: "No file has been created in your scope yet.",
    },
    reporting: {
      kicker: "HR space · Steering",
      title: "Reporting",
      description:
        "Aggregated statistics of your scope — anticipate retirements and steer your pension review campaign at a glance.",
      anonymized_badge: "Anonymised data · headcount < {{k}} hidden",
      all_societes: "All my companies",
      export: "Export",
      no_data_title: "No data for this scope",
      no_data_desc: "Statistics will appear once employees and files are linked to your scope.",
      cohort_too_small_title: "Headcount too low for anonymised reporting",
      cohort_too_small_desc:
        "Your scope has fewer than {{k}} employees: detailed statistics are hidden to prevent re-identification.",
      participation: "Participation",
      eligible: "Eligible",
      started: "Started",
      completed: "Completed",
      delivered: "Delivered",
      participation_rate: "Participation rate",
      completion_rate: "Completion rate",
      delivery_rate: "Delivery rate",
      distribution_title: "Status distribution",
      departure_title: "Retirement age distribution",
      ventilation_title: "Breakdown",
      axis_bu: "Business Unit",
      axis_category: "Category",
      axis_salary_band: "Salary band",
      axis_region: "Region",
      axis_operation: "Operation",
      filter_operation: "Operation",
      filter_region: "Region",
      rachat_tous: "Buy-back: all",
      rachat_sans: "Without buy-back",
      rachat_avec: "With buy-back",
      pas_label: "Grouping",
      pas_annee: "Year",
      pas_trimestre: "Quarter",
      annee_reference: "Reference year",
      comparaison_masked: "N / N-1 comparison masked (count below threshold)",
      comparaison_resume: "N: {{x}} · N-1: {{y}} · diff {{ecart}}",
      comparaison_chart_desc: "N vs N-1 comparison by quarter",
      adhesion_title: "Training uptake by BU",
      adhesion_desc:
        "Active employees, registered and attending at least one training, and opt-outs per Business Unit (counts masked below the anonymity threshold).",
      adhesion_empty: "No Business Unit in this scope.",
      adhesion_col_presents: "Present",
      adhesion_col_inscrits: "Registered",
      adhesion_col_taux: "Uptake rate",
      adhesion_col_formation_presents: "Attended training",
      adhesion_col_refus: "Opt-outs",
      adhesion_taux_masked: "hidden",
      kpi_refus_adhesion: "Present employees opting out",
      kpi_refus_adhesion_hint: "declined to be contacted",
      category_cadre: "Manager",
      category_oetam: "OETAM",
      category_dirigeant: "Executive",
      category_none: "Not specified",
      salary_sub_80k: "< 80 k€",
      salary_80k_120k: "80 – 120 k€",
      salary_above_120k: "> 120 k€",
      filter_bu: "Business Unit",
      filter_department: "Department",
      filter_category: "Category",
      filter_salary: "Salary band",
      filter_formation: "Training",
      formation_all: "Training: all",
      formation_registered: "Registered for training",
      formation_present: "Attended training",
      active_filters: "{{count}} active filter(s)",
      reset_filters: "Reset filters",
      satisfaction_title: "Satisfaction",
      satisfaction_avg: "Average score",
      satisfaction_respondents: "Respondents",
      formations_title: "Training",
      formations_sessions: "Sessions",
      formations_registered: "Registered",
      formations_present: "Attended",
      cost_title: "Financial estimates",
      badge_prefix: "Anonymised data · headcount",
      badge_suffix: "hidden",
      filter_status: "File status",
      reset_filters_count: "Reset ({{count}})",
      salary_none: "Not specified",
      kpi_covered: "Covered employees",
      kpi_covered_hint: "{{count}} space(s) activated",
      kpi_activation_rate: "Activation rate",
      kpi_activation_hint: "{{count}} consent(s) collected",
      kpi_delivered: "Reviews delivered",
      kpi_delivered_hint: "out of {{count}} file(s)",
      kpi_formation_presence: "Training attendance",
      kpi_formation_presence_hint: "{{count}} registered",
      info_activated_label: "Activated space",
      info_activated_body_1:
        ": an employee counts as an \u201cactivated space\u201d as soon as they have ",
      info_activated_strong: "logged in at least once",
      info_activated_body_2:
        " to their personal space (via the invitation link or their password). An invited but never-used account is not counted. The activation rate relates these logins to the total number of employees covered by your scope.",
      funnel_title: "File progress",
      funnel_desc: "Breakdown by status across {{count}} file(s)",
      funnel_empty: "No file in this scope.",
      chart_depart_title: "Age of first possible departure date",
      chart_depart_desc: "Distribution of earliest departure ages from the reviews.",
      chart_taux_plein_title: "Natural full-rate age",
      chart_taux_plein_desc: "Distribution of ages reaching the full rate.",
      chart_tpn_annee_title: "Natural full-rate dates by year",
      chart_tpn_annee_desc:
        "Number of employees reaching their natural full rate (NFR) each calendar year.",
      chart_departs_annee_title: "Earliest possible departure dates by year",
      chart_departs_annee_desc:
        "Number of employees able to leave each year, without buy-back (base estimate) and with quarter buy-back ({{count}} files with a buy-back simulation), and among them long careers.",
      departs_serie_sans_rachat: "Without buy-back",
      departs_serie_avec_rachat: "With buy-back",
      departs_serie_carriere_longue: "Long careers",
      sorties_title: "Workforce exits",
      sorties_desc:
        "Closed accounts (exit date and reason recorded by the team) and employees who refused to be contacted.",
      sorties_total: "Closed accounts",
      sorties_retraite: "Retirements",
      sorties_retraite_hint: "Voluntary and employer-initiated",
      refus_contact: "Contact refusals",
      refus_contact_hint: "Employees excluded from reminders",
      sorties_par_motif: "By reason",
      sorties_par_annee: "By exit year",
      sorties_motif_non_renseigne: "Reason not provided",
      sorties_empty: "No exit recorded.",
      droits_title: "Rights recovered through the programme",
      droits_desc:
        "Obtained volumes recorded by consultants on the files of your scope (masked below {{k}} files).",
      droits_dossiers: "Files concerned",
      droits_trim_rachetes: "Bought-back quarters",
      droits_trim_gagnes: "Gained quarters",
      droits_points: "Agirc-Arrco points recovered",
      droits_en_cours: "+ {{count}} being regularised",
      droits_gain_total: "Estimated annual pension gain (obtained)",
      droits_gain_en_cours: "+ {{value}} €/yr pending",
      droits_gain_en_cours_label: "Estimated annual pension gain (pending)",
      droits_par_motif: "Breakdown by reason",
      droits_motif_col: "Reason",
      droits_col_trimestres: "Quarters",
      droits_col_points: "Points",
      droits_col_gain: "Gain (€/yr)",
      retraite_title: "Retirement indicators",
      retraite_desc: "Long careers, buybacks and rights from the latest reviews.",
      kpi_carriere_longue: "Long careers",
      kpi_rachats: "Buybacks considered",
      kpi_rachats_hint: "files with an estimated buyback cost",
      kpi_cout_rachat: "Average buyback cost",
      kpi_trim_rachetes: "Quarters bought back",
      kpi_trim_rachetes_hint: "total volume considered",
      kpi_points: "Agirc-Arrco points (avg.)",
      kpi_points_hint: "out of {{count}} file(s)",
      kpi_points_none: "not provided by the engine",
      kpi_trim_manquants: "Missing quarters (avg.)",
      kpi_trim_manquants_hint: "rights left to complete",
      kpi_trim_valides: "Validated quarters (avg.)",
      kpi_trim_valides_hint: "out of {{count}} review(s)",
      kpi_points_total: "Agirc-Arrco points (total)",
      segment_title: "Participation by segment",
      segment_desc: "Covered employees and activated spaces by {{axis}}.",
      geo_title: "Geographic breakdown",
      geo_desc: "Covered employees by department (headcount hidden below the anonymity threshold).",
      appetences_title: "Expressed preferences",
      appetences_desc: "Employee wishes recorded at the end of their review.",
      satisfaction_section_title: "Employee satisfaction",
      satisfaction_section_desc: "Service ratings submitted after the review debrief (spec §16).",
      fc_title: "Trained employees tracking: login & completion",
      fc_desc: "Among trained employees: who logged in? whose file is complete? (spec §8b)",
      sessions_title: "Training sessions",
      sessions_desc: "Registrations and attendance per session within your scope.",
      fc_empty: "No trained employee in this scope (or headcount hidden for anonymity).",
      fc_formes: "Trained employees",
      fc_connectes: "… who logged in",
      fc_bilan: "… whose file led to a review",
      fc_non_connectes: "Trained but never logged in",
      fc_non_connectes_desc: "To follow up (email / phone).",
      fc_incomplets: "Logged in, file not completed",
      fc_incomplets_desc: "To support in finalising the file.",
      sat_masked: "Fewer than {{k}} ratings in this scope: results hidden to preserve anonymity.",
      sat_empty: "No rating submitted in this scope yet.",
      sat_avg: "Average rating",
      sat_out_of_5: "/ 5",
      sat_avg_hint: "{{count}} rating(s)",
      sat_nps: "NPS",
      sat_nps_hint: "out of {{count}} recommendation(s)",
      sat_nps_insufficient: "insufficient recommendations (< {{k}})",
      sat_evaluations: "Ratings",
      sat_evaluations_hint: "reviews received",
      formations_empty: "No training session in this scope.",
      col_session: "Session",
      col_date: "Date",
      col_channel: "Channel",
      col_registered: "Registered",
      col_present: "Attended",
      col_rate: "Rate",
      chart_empty_bilan: "No review data available.",
      chart_empty_segment: "No segment available.",
      masked_note: "Some headcounts are hidden (below the anonymity threshold).",
      drill_hint:
        "Click a bar to display the aggregated detail of the corresponding population (never a named list).",
      drill_desc: "Segment population ({{axis}}) — aggregated headcounts only",
      drill_salaries: "Employees covered",
      drill_actives: "Activated spaces",
      drill_delivered: "Reports delivered",
      drill_funnel: "File distribution",
      drill_anonymity_note:
        "This panel only shows aggregated headcounts: values below the anonymity threshold ({{k}}) are hidden and no named data is accessible.",
      status_history_title: "Evolution of the file distribution",
      status_history_desc:
        "Weekly distribution of files by status, reconstructed from the status change history. Each point respects the anonymity threshold.",
      status_history_loading: "Loading history…",
      status_history_error: "History could not be loaded. Please try again shortly.",
      status_history_retry: "Try again",
      status_history_empty: "Not enough history yet to draw the evolution.",
      csv_status_history: "Status evolution (week)",
      map_loading: "Loading the map…",
      legend_salaries: "Employees",
      legend_actives: "Activated spaces",
      tt_years: "yrs",
      tt_salaries: "employee(s)",
      tt_actives: "space(s) activated",
      tt_bilans: "review(s) delivered",
      tt_no_data: "No data",
      app_plus_tot: "Leave as early as possible",
      app_plus_tard: "Leave as late as possible",
      app_progressive: "Phased retirement / part-time",
      app_rupture: "Mutual termination",
      app_rachat: "Quarter buyback",
      app_cumul: "Combining employment and retirement",
      csv_indicator: "Indicator",
      csv_value: "Value",
      csv_covered: "Covered employees",
      csv_actives: "Activated spaces",
      csv_consents: "Consents collected",
      csv_formes: "Trained employees",
      csv_sortants: "Leavers",
      csv_dossiers_total: "Files (total)",
      csv_carriere_longue: "Long careers",
      csv_rachats: "Buybacks considered",
      csv_trim_rachetes: "Quarters bought back (volume)",
      csv_cout_rachat: "Average buyback cost (€)",
      csv_points: "Agirc-Arrco points (average)",
      csv_points_total: "Agirc-Arrco points (total)",
      csv_trim_manquants: "Missing quarters (average)",
      csv_trim_valides: "Validated quarters (average)",
      csv_trim_valides_total: "Validated quarters (total)",
      csv_tpn_annee: "Natural full rate by year",
      csv_departs_annee: "Earliest departure dates by year",
      csv_sorties_total: "Exits — closed accounts",
      csv_sorties_retraite: "Exits — retirements",
      csv_refus_contact: "Contact refusals",
      csv_sorties_motif: "Exits by reason",
      csv_sorties_annee: "Exits by year",
      csv_formation_inscrits: "Training — registered",
      csv_formation_presents: "Training — attended",
      csv_sat_evaluations: "Satisfaction — ratings",
      csv_sat_note: "Satisfaction — average rating /5",
      csv_sat_nps: "Satisfaction — NPS",
      csv_funnel_title: "File progress",
      csv_number: "Count",
      csv_appetences: "Preferences",
      csv_ventilation: "Breakdown — {{axis}}",
      csv_bilans: "Reviews delivered",
      csv_sessions: "Training sessions",
    },
    synthese: {
      kicker: "HR space · Steering",
      title: "Mission summary",
      description:
        "Consolidated view of the mission: headcount, completed and planned departures, employee wishes, recovered rights and satisfaction.",
      badge: "Headcounts below {{k}} hidden",
      export: "Export",
      export_title: "Export the summary",
      export_desc: "Choose the views to include in the file.",
      exporting: "Exporting…",
      all_societes: "All my companies",
      select_societe: "Choose a company",
      select_societe_title: "Select a company",
      select_societe_desc:
        "The mission summary is shown one company at a time: pick one from the selector at the top of the page.",
      sec_mission: "Mission summary",
      sec_departs_realises: "Completed departures",
      sec_departs_envisages: "Planned departures",
      sec_appetences: "Employee wishes",
      sec_droits: "Recovered rights",
      sec_satisfaction: "Satisfaction",
      sec_roi: "Return on investment",
      sec_nominatif: "Named detail",
      m_presents: "Active employees",
      m_sortis: "Departed employees",
      m_en_cours: "Files in progress",
      m_prestations: "Completed services",
      m_taux: "Completion rate",
      m_anomalies: "Resolved anomalies",
      m_rachats: "Simulated buy-backs",
      m_refus: "Participation refusals",
      dep_realises_annee: "Completed departures by year",
      dep_realises_motif: "Completed departures by reason",
      departs_envisages_desc:
        "Dates from the calculations (baseline estimate): earliest possible date, full rate and age at which the penalty is cancelled.",
      dep_au_plus_tot: "Earliest",
      dep_taux_plein: "Full rate",
      dep_annulation: "Penalty cancellation (age 67)",
      appetences_note: "Wishes expressed by employees.",
      droits_note:
        "Recovered rights recorded by consultants; the gain is the sum of the entered estimates.",
      roi_note: "Transaction and severance amounts are deliberately not reproduced.",
      nominatif_aide:
        "Only employees who authorised sharing appear, with the level of information they chose.",
      nominatif_date_title: "Consent: full-rate date only",
      nominatif_full_title: "Consent: full BRI",
      nominatif_voir: "Open file",
      sat_note: "Average rating",
      sat_nps: "NPS",
      sat_evaluations: "Evaluations",
      roi_accompagnes: "Employees supported",
      roi_taux: "Completion rate",
      roi_droits: "Recovered rights (quarters / points)",
      roi_rachats: "Simulated buy-backs",
      roi_satisfaction: "Average satisfaction",
      roi_gain: "Estimated cumulative annual pension gain",
      d_dossiers: "Files concerned",
      d_trim_rachetes: "Quarters bought back",
      d_trim_gagnes: "Quarters gained",
      d_points: "Agirc-Arrco points",
      d_trim_en_cours: "Quarters in progress",
      d_points_en_cours: "Points in progress",
      d_gain: "Estimated annual gain (obtained)",
      d_gain_en_cours: "Estimated annual gain (pending)",
      d_par_motif: "Breakdown by reason",
      col_indicateur: "Indicator",
      col_valeur: "Value",
      col_annee: "Year",
      col_departs: "Departures",
      col_motif: "Reason",
      col_souhait: "Wish",
      col_salaries: "Employees",
      col_nom: "Last name",
      col_prenom: "First name",
      col_matricule: "Employee ID",
      col_bu: "Business Unit",
      col_operation: "Operation",
      col_statut: "File status",
      col_date_taux_plein: "Full-rate departure",
      col_age_taux_plein: "Age at full rate",
      col_premiere_date: "Earliest departure",
      col_age_premiere_date: "Age",
      col_pension: "Gross monthly pension",
      sheet_perimetre: "Scope",
      perimetre_date: "Date",
      perimetre_societe: "Company",
      perimetre_filtres: "Filters",
      perimetre_filtres_aucun: "None",
      perimetre_seuil: "Headcounts below {{k}} hidden",
      pdf_aucune_donnee: "No data available for this view.",
      pdf_tendance: "{{n}} departures in {{annee}} versus {{nPrec}} in {{anneePrec}}{{delta}}",
      footer_note:
        "Headcounts below the anonymity threshold ({{k}}) are hidden. The named detail only lists employees who authorised sharing of their results.",
    },
    formations: {
      kicker: "HR space · Steering",
      title: "Training",
      description: "Retirement training session tracking for your scope.",
      no_formations: "No training sessions.",
      search_placeholder: "Search for training…",
      export: "Export",
      channel_presentiel: "In-person",
      channel_visio: "Video call",
      channel_mixte: "Hybrid",
      stat_sessions: "Sessions",
      stat_registered: "Registered",
      stat_present: "Attended",
      stat_absent: "Absent",
      stat_upcoming: "Upcoming",
      filter_period: "Period",
      filter_channel: "Channel",
      period_all: "All sessions",
      period_upcoming: "Upcoming",
      period_past: "Past",
      page_description:
        "Track retirement training sessions within your scope: schedule, registrations and attendance.",
      badge_aggregated: "Aggregated headcount · no personal data",
      all_societes: "All my companies",
      empty_title: "No training session",
      empty_desc: "Retirement training sessions held within your scope will appear here.",
      kpi_sessions: "Sessions",
      kpi_upcoming: "Upcoming",
      kpi_registrations: "Registrations",
      kpi_presence_rate: "Attendance rate",
      kpi_presence_hint: "Past sessions",
      channel_all: "Channel: all",
      reset: "Reset",
      filtered_empty_title: "No session for these filters",
      filtered_empty_desc: "Adjust the period or channel to show more sessions.",
      col_session: "Session",
      col_date: "Date",
      col_channel: "Channel",
      col_registered: "Registered",
      col_present: "Attended",
      col_rate: "Rate",
      col_eval: "Rating",
      badge_upcoming: "Upcoming",
      badge_past: "Past",
      footer_note:
        "In line with confidentiality, only aggregated headcount per session is displayed.",
      csv_session: "Session",
      csv_societe: "Company",
      csv_operation: "Operation",
      csv_date: "Date",
      csv_channel: "Channel",
      csv_lieu: "Location",
      csv_capacity: "Capacity",
      csv_registered: "Registered",
      csv_present: "Attended",
      csv_absent: "Absent",
      csv_rate: "Attendance rate (%)",
      csv_eval: "Average rating",
      csv_status: "Status",
    },
    library: {
      kicker: "HR resources",
      title: "HR library",
      subtitle:
        "Steering materials, educational sheets and benchmarks to support your retirement campaigns.",
    },
    salaries: {
      kicker: "HR space",
      title: "Employees",
      description: "View your employees' records and track their journey.",
    },
    operations: {
      kicker: "HR space · Steering",
      title: "Operations",
      description: "Track BRI campaigns within your scope.",
      empty_desc: "No operation is linked to your scope at the moment.",
      back_all: "All operations",
      dossiers_title: "Operation files",
      dossiers_subtitle: "Read-only tracking of your employees' Pension Reviews.",
      search_placeholder: "Search by name, first name, ID…",
      all_steps: "All steps",
      dossiers_count_one: "{{count}} file",
      dossiers_count_many: "{{count}} files",
      no_dossier_title: "No file",
      no_dossier_filters: "No result for these filters.",
      no_dossier_desc: "No file is visible in your scope yet.",
      societe_none: "Company not specified",
      with: "with",
      updated: "Updated {{date}}",
    },
    messages: {
      kicker: "HR space",
      title: "Messages",
      description: "Your exchanges with the Aon project managers of your operations.",
      new_conversation: "New conversation",
      search_placeholder: "Search…",
      no_results: "No result",
      no_conversations: "No conversation",
      no_conversations_desc:
        "Start an exchange with an Aon project manager via \u201cNew conversation\u201d.",
      back_conversations: "Conversations",
      select_conversation: "Select a conversation",
      dialog_title: "New conversation",
      dialog_desc: "Select an Aon project manager to start (or reopen) an exchange.",
      no_contacts_title: "No Aon contact",
      no_contacts_desc: "No project manager is linked to your operations at the moment.",
      no_name: "(no name)",
      contact_role: "Project manager",
      opening: "Opening…",
      unknown_error: "Unknown error",
      no_subject: "(no subject)",
      participants_summary: "{{count}} participants · HR ↔ Project manager",
      nobody: "(nobody)",
      rel_min: "{{count}} min ago",
      rel_hour: "{{count}} h ago",
      rel_day: "{{count}} d ago",
    },
  },
  operations_list: {
    title: "Operations",
    subtitle: "BRI client campaign steering.",
    search_placeholder: "Search an operation, a company…",
    filter_active: "Active",
    filter_draft: "Drafts",
    filter_closed: "Closed",
    filter_all: "All",
    stat_operations: "Operations",
    stat_salaries: "Covered employees",
    stat_dossiers_active: "Active files",
    stat_bri_delivered: "BRI delivered",
    empty_title: "No operation",
    empty_filtered: "Adjust your filters to see other operations.",
    empty_default: "No operation is linked to you at the moment.",
    page_of: "Page {{page}} of {{total}} · {{count}} operations",
    prev: "Previous",
    next: "Next",
    tile_salaries: "Employees",
    tile_dossiers: "Files",
    tile_active: "Active",
    tile_delivered: "Delivered",
    completion_rate: "Completion rate",
    rdv_upcoming: "{{count}} upcoming appointments (30d)",
    status_brouillon: "Draft",
    status_planifiee: "Planned",
    status_en_cours: "In progress",
    status_cloturee: "Closed",
    status_archivee: "Archived",
  },
  formations: {
    title: "Training",
    add: "New session",
    edit: "Edit session",
    delete: "Delete session",
    delete_confirm: "Delete this training session?",
    operation: "Operation",
    titre: "Title",
    description: "Description",
    starts_at: "Start date",
    ends_at: "End date",
    channel: "Channel",
    lieu: "Location",
    capacity: "Max capacity",
    formateur: "Trainer",
    participants: "Participants",
    add_participant: "Add a participant",
    remove_participant: "Remove",
    presence: "Attendance",
    present: "Present",
    absent: "Absent",
    not_recorded: "Not recorded",
    no_participants: "No participants registered.",
    search_salarie: "Search for an employee…",
  },
  salaries: {
    form: {
      title_create: "New employee",
      title_edit: "Edit {{prenom}} {{nom}}",
      description_create: "Manual record creation. For bulk import, use Import a file.",
      description_edit: "Edit the employee record.",
      cancel: "Cancel",
      save: "Save",
      create: "Create employee",
      errors: {
        required: "Required field",
        invalidEmail: "Invalid email",
        dateFormat: "Date YYYY-MM-DD",
      },
      duplicate: {
        title: "Email already in use",
        description:
          "The address <code>{{email}}</code> is already linked to <strong>{{prenom}} {{nom}}</strong>.",
        matricule: "ID {{matricule}}",
        hint: "Open that employee's record to edit it, or use a different email.",
        close: "Close this warning",
      },
      staff_conflict: {
        title: "This email belongs to an Aon team account",
        description_profile:
          "The address <code>{{email}}</code> belongs to <strong>{{name}}</strong> ({{roles}}). An Aon team member cannot be created as an employee. An HR user, however, can have their own employee record.",
        description_invitation:
          "The address <code>{{email}}</code> has a pending invitation for a {{roles}} account. An Aon team member cannot be created as an employee.",
        unknown_name: "a user",
        hint: "Use the employee's personal address, or revoke this person's Aon access first.",
      },
      sections: {
        company: "Company assignment",
        identity: "Identity",
        contact: "Contact",
        employment: "Employment",
        access: "Platform access",
      },
      fields: {
        societe: "Company",
        operation: "Operation",
        filiale: "Subsidiary",
        business_unit: "Business Unit",
        site: "Site / region",
        matricule: "Employee ID",
        civilite: "Title",
        prenom: "First name",
        nom: "Last name",
        nom_naissance: "Birth name",
        date_naissance: "Date of birth",
        gender: "Gender",
        email_pro: "Work email",
        email_perso: "Personal email",
        email_correspondance: "Preferred email",
        telephone_pro: "Work phone",
        telephone_perso: "Personal phone",
        poste: "Job title",
        professional_category: "Category",
        salary_band: "Salary band",
        salaire_annuel_declare: "Annual salary (€)",
        date_entree_societe: "Company entry date",
      },
      placeholders: {
        none: "-",
        societe_search: "Search for a company…",
        operation_search: "Search for an operation…",
        operation_disabled: "Choose a company first",
        operation_none: "- None -",
        filiale_search: "Search for a subsidiary…",
        filiale_none: "- None -",
        bu_search: "Search for a BU…",
        bu_none: "- None -",
        site_search: "Search for a site…",
        site_none: "- None -",
        email_correspondance: "Email used for communications (default: work)",
        matricule: "TE-1001",
      },
      options: {
        civilite_M: "Mr.",
        civilite_Mme: "Mrs.",
        civilite_Mx: "Mx",
        gender_m: "Male",
        gender_f: "Female",
        gender_x: "Not specified",
        category_cadre: "Executive",
        category_oetam: "ETAM (Workers, Employees, Technicians, Supervisors)",
        category_dirigeant: "Director",
        salary_sub_80k: "< 80 k€",
        salary_80k_120k: "80 - 120 k€",
        salary_above_120k: "> 120 k€",
      },
      flags: {
        is_present: "Currently employed",
        is_vip: "VIP / Director",
        has_rqth: "Recognized disability status (RQTH)",
      },
      access: {
        description:
          "Checking this option also creates the linked user account in the back office. The employee will receive an activation email and set their password on first login.",
        send_invitation: "Create linked account and send invitation",
        email_required:
          "Enter at least one email (preferred, work or personal) to send the invitation.",
        email_used: "Invitation will be sent to <code>{{email}}</code>.",
      },
    },
    import: {
      title: "Employee import",
      upload: "Upload CSV file",
      template: "Download template",
      mapping: "Mapping verification",
      preview: "Import preview",
      confirm: "Start import",
      success: "{{count}} employee(s) imported successfully.",
      errors: "{{count}} error(s) detected.",
    },
  },
  messages: {
    title: "Messages",
    new_conversation: "New conversation",
    search_placeholder: "Search for a conversation…",
    no_conversations: "No conversations.",
    no_messages: "No messages in this conversation.",
    type_message: "Write a message…",
    send: "Send",
    attachment: "Attach a file",
    read: "Read",
    unread: "Unread",
    tracking: {
      title: "Message tracking",
      description: "Overview of all platform conversations.",
    },
  },
  parcours: {
    title: "My retirement journey",
    description: "Complete the steps to produce your Individual Retirement Report.",
    step_identity: "Identity",
    step_career: "Career",
    step_family: "Family situation",
    step_documents: "Documents",
    step_scenarios: "Scenarios",
    step_validation: "Validation",
    progress: "Progress",
    complete_step: "Step completed",
    next_step: "Next step",
    submit: "Submit my file",
    submit_confirm: "Once submitted, your file will be sent to the Aon team for production.",
    reset: "Start over",
    reset_confirm: "Reset the journey? Your entered data will be preserved.",
  },
  bri: {
    title: "My Pension Review",
    subtitle: "View and download your Individual Retirement Report.",
    download_pdf: "Download PDF",
    no_bri: "Your BRI is not yet available.",
    generating: "Generating BRI…",
    generated_at: "Generated on",
    version: "Version",
  },
  salary_band: {
    sub_80k: "Under €80k / year",
    "80k_to_120k": "€80k to €120k / year",
    above_120k: "Over €120k / year",
    mixte: "Mixed (set per employee)",
    none: "Not specified",
  },
  historique: {
    title: "My calculation history",
    subtitle: "Full history of your calculations and simulations.",
    no_history: "No calculations performed yet.",
    date: "Date",
    type: "Type",
    result: "Result",
    details: "Details",
  },
} as const;
